import { PaymentStatus } from '../lib/constants/PaymentStatus';
import { PaymentType } from '../lib/constants/PaymentType';
import { OrderStatus } from '../lib/constants/OrderStatus';
import { PriceType } from '../lib/constants/PriceType';
import { PaymentTransactionStatus } from '../lib/constants/PaymentTransactionStatus';
import { PaymentMismatchType } from '../lib/constants/PaymentMismatch';
import { PaymentMismatchStatus } from '../lib/constants/PaymentMismatch';
import { MplProcessedDataKind } from '../lib/constants/PaymentMismatch';
import { DiscountType } from '../lib/constants/Discount';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: Date;
  /** Scalar */
  EmailAddress: string;
  JSONObject: {[key: string]: any };
  URL: string;
};

/** 規約同意状態 */
export type Agreement = {
  __typename?: 'Agreement';
  /** 状態 */
  status: AgreementStatus;
  /** 規約 */
  terms: Terms;
  /** 最終更新日時 */
  updatedAt: Scalars['DateTime'];
};

export enum AgreementStatus {
  /** 同意する */
  Agreement = 'agreement',
  /** 同意しない */
  Disagreement = 'disagreement'
}

/** お知らせ情報 */
export type Announcement = {
  __typename?: 'Announcement';
  /** 本文 */
  body: Scalars['String'];
  /** お知らせID */
  id: Scalars['ID'];
  /** 種別（お知らせ、メンテナンス、キャンペーン） */
  kind: Scalars['String'];
  /** 公開終了日時 */
  publishEndedAt: Scalars['DateTime'];
  /** 公開開始日時 */
  publishStartedAt: Scalars['DateTime'];
  /**
   * ステータス（Table定義にはなし）
   * ※バックエンド側で現在日時の公開開始日時・公開終了日時をもとに判定
   */
  published: Scalars['Boolean'];
  /** 件名 */
  subject: Scalars['String'];
  /** お知らせ番号 */
  systemId: Scalars['String'];
};

/** お知らせ情報一覧 */
export type Announcements = {
  __typename?: 'Announcements';
  nodes: Array<Announcement>;
  totalCount: Scalars['Int'];
};

/** アンケートの回答内容 */
export type Answer = {
  __typename?: 'Answer';
  /** 回答内容（自由記述） */
  freeTextValue?: Maybe<Scalars['String']>;
  /** 選択したオプションID（複数選択） */
  multiSelectQuestionnaireOptionId?: Maybe<Scalars['Int']>;
  /** 質問ID */
  questionnaireId: Scalars['ID'];
  /** 選択したオプションID（単一選択） */
  selectQuestionnaireOptionId?: Maybe<Scalars['Int']>;
};

/** au英語動画 */
export type AuVideo = {
  __typename?: 'AuVideo';
  /** 分野（カテゴリー） */
  categories: Array<AuVideoCategory>;
  /** 公開終了日時 */
  closedAt?: Maybe<Scalars['DateTime']>;
  /** id */
  id: Scalars['ID'];
  /** JStreamのID */
  jStreamMId: Scalars['String'];
  /** レベル */
  level?: Maybe<AuVideoLevel>;
  /** 動画名 */
  name: Scalars['String'];
  /** 並び順 */
  order: Scalars['Int'];
  /**
   * どのplanに紐づくか
   * 紐付いていない場合はサンプル動画
   */
  plan?: Maybe<Plan>;
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** 評価 */
  rating?: Maybe<Scalars['Float']>;
  /** 評価数 */
  ratingCount: Scalars['Int'];
};

/** マスタ「au英語の分野」 */
export type AuVideoCategory = {
  __typename?: 'AuVideoCategory';
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
  /** カテゴリー階層 */
  rank: AuVideoCategoryRank;
};

export enum AuVideoCategoryRank {
  One = 'One',
  Three = 'Three',
  Two = 'Two'
}

/** マスタ「au英語レベル」 */
export type AuVideoLevel = {
  __typename?: 'AuVideoLevel';
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
};

/** 動画に対するau英語動画受講後アンケート詳細 */
export type AuVideoRatingDetail = {
  __typename?: 'AuVideoRatingDetail';
  /** 対象の動画 */
  auVideo: AuVideo;
  /** 回答年月日 */
  createdAt: Scalars['DateTime'];
  /** カスタマー情報 */
  customer: Customer;
  /** 評価コメント */
  freeTextValue?: Maybe<Scalars['String']>;
  /** au英語動画受講後アンケートID */
  id: Scalars['ID'];
  /** 5段階評価の値 */
  rating: Scalars['Int'];
};

/** au英語動画受講後アンケート一覧 */
export type AuVideoRatingDetails = {
  __typename?: 'AuVideoRatingDetails';
  /** 取得したau英語動画視聴後アンケートの配列 */
  nodes: Array<AuVideoRatingDetail>;
  /** 全件数 */
  totalCount: Scalars['Int'];
};

/** au英語動画一覧 */
export type AuVideos = {
  __typename?: 'AuVideos';
  /** 取得したau英語動画の配列 */
  nodes: Array<AuVideo>;
  /** 全件数 */
  totalCount: Scalars['Int'];
};

/** au英語動画の検索条件 */
export type AuVideosFilterInput = {
  /** 分野（カテゴリー） */
  categoryId?: InputMaybe<Scalars['String']>;
  /** 公開終了日時に対する検索条件 */
  closedAt?: InputMaybe<DateTimeFilterInput>;
  /** J-Streamの動画ID */
  jStreamMId?: InputMaybe<Scalars['String']>;
  /** レベル */
  levelId?: InputMaybe<Scalars['String']>;
  /**
   * どのPlanに紐づくか。
   * 値がnullの場合は検索条件に含まず、プランに紐づかない動画を指定する場合は`null`を配列の要素に指定する。
   * プランを検索条件に含まない場合：planIds: null
   * プランに紐付かない動画を検索条件にする場合：planIds: [null]
   */
  planIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** 公開開始日時に対する検索条件 */
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  /** ソートの対象にする項目 */
  sort?: InputMaybe<AuVideosSortField>;
};

/** ソートの対象にする項目 */
export enum AuVideosSortField {
  /** J-Streamの動画IDの昇順 */
  JStreamMId = 'jStreamMId',
  /** 並び順の昇順 */
  Order = 'order'
}

/** 月額会員 */
export type BillingCustomer = {
  __typename?: 'BillingCustomer';
  /** 解約日 */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** 顧客ID */
  customerId: Scalars['String'];
  /** 契約終了日 */
  expiredAt?: Maybe<Scalars['DateTime']>;
  /** 月額商品の注文ID */
  id: Scalars['ID'];
  /** メルマガ許諾 */
  mailMagazineAgreement: Scalars['Boolean'];
  /** 決済方法 */
  payService: Scalars['Int'];
  /** 契約しているプラン */
  plan: Plan;
  /** 会員プロフィール */
  profile: CustomerProfile;
  /** 申込日 */
  submittedAt: Scalars['DateTime'];
};

export type BillingCustomerFilterInput = {
  /** 会員ID(メールアドレス) */
  memberId: Scalars['String'];
};

/** 月額会員一覧 */
export type BillingCustomers = {
  __typename?: 'BillingCustomers';
  nodes: Array<BillingCustomer>;
  totalCount: Scalars['Int'];
};

export type CancelAuthorizedCourseExecutionStatus = {
  __typename?: 'CancelAuthorizedCourseExecutionStatus';
  status: StepFunctionsExecutionStatus;
};

export type CancelSoldCourseExecutionStatus = {
  __typename?: 'CancelSoldCourseExecutionStatus';
  status: StepFunctionsExecutionStatus;
};

/** クラス */
export type Clazz = {
  __typename?: 'Clazz';
  /** 任意に設定できるクラスID */
  anyClassId?: Maybe<Scalars['String']>;
  /** 申込者数の表示/非表示 */
  applicantCountVisibility: Scalars['Boolean'];
  /** 申し込みキャンセル人数 */
  canceledCount?: Maybe<Scalars['Int']>;
  /** 定員 */
  capacity: Scalars['Int'];
  /** コース */
  course?: Maybe<Course>;
  /** コースID */
  courseId: Scalars['ID'];
  /** 開催場所 */
  eventLocation: Scalars['String'];
  /** クラスID */
  id: Scalars['ID'];
  /** 授業一覧 */
  lessons?: Maybe<Array<Lesson>>;
  /** クラス名 */
  name: Scalars['String'];
  /** 公開設定 */
  published?: Maybe<Scalars['Boolean']>;
  /** 販売終了日時 */
  saleEndedAt?: Maybe<Scalars['DateTime']>;
  /** 販売開始日時 */
  saleStartedAt?: Maybe<Scalars['DateTime']>;
  /** クラスのシステムID */
  systemId: Scalars['String'];
};

/** 継続課金の不整合一覧 */
export type ContBillPaymentMismatches = {
  __typename?: 'ContBillPaymentMismatches';
  nodes: Array<PaymentMismatch>;
  totalCount: Scalars['Int'];
};

export type ContBillPaymentMismatchesFilterInput = {
  /** 継続課金ID */
  continueAccountId?: InputMaybe<Scalars['String']>;
};

/** 問い合わせ（CSV ダウンロード用） */
export type Contact = {
  __typename?: 'Contact';
  /** 連絡先情報（非会員のみ） */
  address?: Maybe<ContactAddress>;
  /** 問い合わせ種別情報 */
  category: ContactCategory;
  /** 問い合わせ内容 */
  content?: Maybe<Scalars['String']>;
  /** 作成日時 */
  createdAt: Scalars['DateTime'];
  /** カスタマー情報（会員のみ） */
  customer?: Maybe<Customer>;
  /** 問い合わせ履歴 */
  histories?: Maybe<Array<ContactHistory>>;
  /** 問い合わせID */
  id: Scalars['ID'];
  /** 問い合わせ経路 */
  route: ContactRoute;
  /** サービス種別 */
  serviceKind: ServiceKind;
  /** 問い合わせ番号 */
  systemId: Scalars['String'];
};

/** 問い合わせ時の連絡先（CSVダウンロード用） */
export type ContactAddress = {
  __typename?: 'ContactAddress';
  /** 問い合わせ情報ID */
  contactId?: Maybe<Scalars['ID']>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** 連絡先メールアドレス */
  email?: Maybe<Scalars['String']>;
  /** 姓 */
  familyName?: Maybe<Scalars['String']>;
  /** 姓のフリガナ */
  familyNameKana?: Maybe<Scalars['String']>;
  /** 名 */
  givenName?: Maybe<Scalars['String']>;
  /** 名のフリガナ */
  givenNameKana?: Maybe<Scalars['String']>;
  /** 問い合わせ連絡ID */
  id: Scalars['ID'];
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** 問い合わせ時の連絡先（画面表示用＝個人情報は除外） */
export type ContactAddressForDisplay = {
  __typename?: 'ContactAddressForDisplay';
  /** 問い合わせ情報ID */
  contactId?: Maybe<Scalars['ID']>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** 問い合わせ連絡ID */
  id: Scalars['ID'];
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** 問い合わせ時の連絡先入力 */
export type ContactAddressInput = {
  /** 連絡先メールアドレス */
  email?: InputMaybe<Scalars['String']>;
  /** 姓 */
  familyName?: InputMaybe<Scalars['String']>;
  /** 姓のフリガナ */
  familyNameKana?: InputMaybe<Scalars['String']>;
  /** 名 */
  givenName?: InputMaybe<Scalars['String']>;
  /** 名のフリガナ */
  givenNameKana?: InputMaybe<Scalars['String']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

/** 問い合わせ種別 */
export type ContactCategory = {
  __typename?: 'ContactCategory';
  /** 問い合わせ種別ID */
  id: Scalars['ID'];
  /** 問い合わせ種別 */
  value: Scalars['String'];
};

/** 問い合わせ（画面表示用＝個人情報は除外） */
export type ContactForDisplay = {
  __typename?: 'ContactForDisplay';
  /** 連絡先情報（非会員のみ） */
  address?: Maybe<ContactAddressForDisplay>;
  /** 問い合わせ種別情報 */
  category: ContactCategory;
  /** 問い合わせ内容 */
  content?: Maybe<Scalars['String']>;
  /** 作成日時 */
  createdAt: Scalars['DateTime'];
  /** カスタマー情報（会員のみ） */
  customerId?: Maybe<Scalars['String']>;
  /** 問い合わせ履歴 */
  histories?: Maybe<Array<ContactHistory>>;
  /** 問い合わせID */
  id: Scalars['ID'];
  /** 問い合わせ経路 */
  route: ContactRoute;
  /** 問い合わせ番号 */
  systemId: Scalars['String'];
};

/** 問い合わせ履歴 */
export type ContactHistory = {
  __typename?: 'ContactHistory';
  /** お問い合わせ情報 */
  contact?: Maybe<Contact>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** 問い合わせ履歴番号 */
  id: Scalars['ID'];
  /** 対応内容 */
  memo?: Maybe<Scalars['String']>;
  /** ひとつ前のサービス種別 */
  oldServiceKind?: Maybe<ServiceKind>;
  /** ひとつ前のステータス */
  oldStatus?: Maybe<ContactStatus>;
  /** 現在のサービス種別 */
  serviceKind?: Maybe<ServiceKind>;
  /** 現在のステータス */
  status?: Maybe<ContactStatus>;
  /** 担当者のEmail */
  supporterEmail?: Maybe<Scalars['String']>;
  /** 担当者の姓 */
  supporterFamilyName?: Maybe<Scalars['String']>;
  /** 担当者の名 */
  supporterGivenName?: Maybe<Scalars['String']>;
  /** 担当者のID */
  supporterId?: Maybe<Scalars['ID']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** お問い合わせ経路 */
export enum ContactRoute {
  /** メールからの問い合わせ */
  Email = 'email',
  /** 問い合わせフォームからの問い合わせ */
  Form = 'form',
  /** その他からの問い合わせ */
  Others = 'others',
  /** 電話からの問い合わせ */
  Tel = 'tel'
}

/** 問い合わせサービス種別 */
export type ContactServiceKind = {
  __typename?: 'ContactServiceKind';
  /** サービス種別名 */
  name: Scalars['String'];
};

/** お問い合わせ状況 */
export enum ContactStatus {
  /** お問い合わせ対応状況：対応中 */
  InProgress = 'InProgress',
  /** お問い合わせ対応状況：対応済 */
  Supported = 'Supported',
  /** お問い合わせ対応状況：未対応 */
  Unsupported = 'Unsupported'
}

/** 問い合わせ一覧（CSVダウンロード用） */
export type Contacts = {
  __typename?: 'Contacts';
  nodes: Array<Contact>;
  totalCount: Scalars['Int'];
};

/** 問い合わせ一覧（画面表示用＝個人情報は除外） */
export type ContactsForDisplay = {
  __typename?: 'ContactsForDisplay';
  nodes: Array<ContactForDisplay>;
  totalCount: Scalars['Int'];
};

/** コンテンツ詳細項目のカテゴリ */
export enum ContentDetailCategory {
  /** 説明 */
  Description = 'description',
  /** 注意事項 */
  Notes = 'notes',
  /** おすすめ */
  Recommendation = 'recommendation'
}

/** コンテンツイメージ */
export type ContentImage = {
  __typename?: 'ContentImage';
  /** コンテンツイメージID */
  id: Scalars['ID'];
  /** コンテンツ画像のファイル名 */
  name: Scalars['String'];
  /** コンテンツ画像の表示順 */
  order: Scalars['Int'];
  /** 画像のURL */
  url: Scalars['String'];
};

/** コンテンツ教材 */
export type ContentTeachingMaterial = {
  __typename?: 'ContentTeachingMaterial';
  /** コンテンツ教材のID */
  id: Scalars['ID'];
  /** コンテンツ教材のファイル名 */
  name: Scalars['String'];
  /** コンテンツ教材のURL */
  url: Scalars['String'];
};

/** コンテンツターゲットタイプ */
export enum ContentsTargetType {
  Age = 'age',
  Grade = 'grade',
  None = 'none'
}

export type CorporationCsv = {
  aist2EndDate: Scalars['String'];
  aist2StartDate: Scalars['String'];
  corporationName: Scalars['String'];
  email: Scalars['String'];
};

/** 法人CSV一覧のCSVアップロード結果 */
export type CorporationCsvUploadHistoryData = {
  __typename?: 'CorporationCsvUploadHistoryData';
  /** 登録失敗数 */
  failedCount: Scalars['Int'];
  /** CSVファイル名 */
  fileName: Scalars['String'];
  /** ファイルパス */
  filePath?: Maybe<Scalars['String']>;
  /** 法人CSVid */
  id: Scalars['ID'];
  /** 登録成功数 */
  successesCount: Scalars['Int'];
  /** アップロード結果 */
  uploadResult: UploadResult;
  /** アップロード日時 */
  uploadTime: Scalars['DateTime'];
};

/** 法人CSV一覧の絞り込み条件 */
export type CorporationCsvUploadHistoryFilterInput = {
  /** 終了日時 */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** CSVファイル名 */
  fileName?: InputMaybe<Scalars['String']>;
  /** 開始日時 */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** アップロード結果 */
  uploadResults?: InputMaybe<Array<UploadResult>>;
};

/** 法人CSV一覧の取得結果 */
export type CorporationCsvUploadHistoryResult = {
  __typename?: 'CorporationCsvUploadHistoryResult';
  /** CSV情報 */
  csvData?: Maybe<Array<CorporationCsvUploadHistoryData>>;
  /** 最大ページ数 */
  maxPageNum: Scalars['Int'];
  /** 次ページの番号 */
  nextPageNum?: Maybe<Scalars['Int']>;
  /** 現在のページ番号 */
  nowPageNum: Scalars['Int'];
  /** 前ページの番号 */
  previousPageNum?: Maybe<Scalars['Int']>;
};

/** コース */
export type Course = {
  __typename?: 'Course';
  /** クラス */
  clazzes: Array<Clazz>;
  /** コースID（ユーザー管理用） */
  courseId?: Maybe<Scalars['String']>;
  /** コース詳細 */
  details: Array<CourseDetail>;
  /** コースID */
  id: Scalars['ID'];
  /** コース画像 */
  images?: Maybe<Array<CourseImage>>;
  /** 授業 */
  lessonMasters?: Maybe<Array<LessonMaster>>;
  /** マスタ「カテゴリ（レベル）」Entity */
  levelEntity?: Maybe<Level>;
  /** レベルID */
  levelId?: Maybe<Scalars['String']>;
  /** コース名 */
  name: Scalars['String'];
  /** コースの並び順 */
  order: Scalars['Int'];
  /** マスタ「カテゴリ（事業者）」Entity */
  organizer?: Maybe<Organizer>;
  /** コース概要 */
  overview: Scalars['String'];
  /** プレビュートークン */
  previewToken?: Maybe<CoursePreviewToken>;
  /** コース価格 */
  price: CoursePrice;
  /** 公開設定 */
  published: Scalars['Boolean'];
  /** アンケートに回答がすでにあるか */
  questionnaireAnswered: Scalars['Boolean'];
  /** アンケート */
  questionnaires?: Maybe<Array<Questionnaire>>;
  /** マスタ「カテゴリ（科目）」Entity */
  subjectEntity?: Maybe<Subject>;
  /** マスタ「カテゴリ（科目）」Entity（複数） */
  subjects?: Maybe<Array<Subject>>;
  /** コースのシステムID */
  systemId: Scalars['String'];
  /** コースターゲット */
  targets?: Maybe<CourseTarget>;
  /** 教材 */
  teachingMaterials?: Maybe<Array<CourseTeachingMaterial>>;
  /** コース動画 */
  videos?: Maybe<Array<CourseVideo>>;
};

/** コース詳細 */
export type CourseDetail = {
  __typename?: 'CourseDetail';
  /** コース詳細項目のカテゴリ */
  category: CourseDetailCategory;
  /** コース詳細項目の説明 */
  description: Scalars['String'];
  /** コース詳細ID */
  id?: Maybe<Scalars['ID']>;
};

/** コース詳細項目のカテゴリ */
export enum CourseDetailCategory {
  /** 説明 */
  Description = 'description',
  /** 当日の流れ */
  Lessonflow = 'lessonflow',
  /** 注意事項 */
  Notes = 'notes',
  /** 準備物 */
  Preparation = 'preparation',
  /** おすすめ */
  Recommendation = 'recommendation'
}

/** コースイメージ */
export type CourseImage = {
  __typename?: 'CourseImage';
  /** コースイメージID */
  id: Scalars['ID'];
  /** コース画像のファイル名 */
  name: Scalars['String'];
  /** コース画像の表示順 */
  order: Scalars['Int'];
  /** 画像のURL */
  url: Scalars['String'];
};

export type CourseImageOrderInput = {
  /** コースイメージID */
  id: Scalars['ID'];
  /** コース画像の表示順 */
  order: Scalars['Int'];
};

/** コースプレビュートークン情報 */
export type CoursePreviewToken = {
  __typename?: 'CoursePreviewToken';
  /** トークンID */
  id: Scalars['ID'];
  /** トークン情報 */
  token: Scalars['String'];
};

/** CoursePrice */
export type CoursePrice = {
  __typename?: 'CoursePrice';
  /** 料金の種類 */
  type: CoursePriceType;
  /** 料金 */
  value?: Maybe<Scalars['Int']>;
  /** 料金（税抜） */
  valueNoTax?: Maybe<Scalars['Int']>;
};

/** CoursePriceの登録 */
export type CoursePriceInput = {
  /** 料金の種類 */
  type: CoursePriceType;
  /** 料金（税抜） */
  valueNoTax?: InputMaybe<Scalars['Int']>;
};

/** コース料金の種類 */
export enum CoursePriceType {
  /** 無料 */
  Free = 'free',
  /** 従量課金 */
  Once = 'once'
}

/** コースターゲット */
export type CourseTarget = {
  __typename?: 'CourseTarget';
  /** from */
  from?: Maybe<Scalars['String']>;
  /** to */
  to?: Maybe<Scalars['String']>;
  /** ターゲットタイプ */
  type: CourseTargetType;
};

/** コースターゲットの登録 */
export type CourseTargetInput = {
  /** from */
  from?: InputMaybe<Scalars['String']>;
  /** to */
  to?: InputMaybe<Scalars['String']>;
  /** ターゲットタイプ */
  type: CourseTargetType;
};

/** コースターゲットタイプ */
export enum CourseTargetType {
  Age = 'age',
  Grade = 'grade',
  None = 'none'
}

/** コース教材 */
export type CourseTeachingMaterial = {
  __typename?: 'CourseTeachingMaterial';
  /** コース教材のID */
  id: Scalars['ID'];
  /** コース教材のファイル名 */
  name: Scalars['String'];
  /** コース教材のURL */
  url: Scalars['String'];
};

/** コース動画 */
export type CourseVideo = {
  __typename?: 'CourseVideo';
  /** コース動画ID */
  id: Scalars['ID'];
  /** 動画のURL */
  url: Scalars['String'];
};

/** CourseVideoのinput */
export type CourseVideoInput = {
  /** コースID */
  courseId?: InputMaybe<Scalars['ID']>;
  /** コース動画ID */
  id?: InputMaybe<Scalars['ID']>;
  /** コース動画のurl */
  url: Scalars['String'];
};

/** コース一覧 */
export type Courses = {
  __typename?: 'Courses';
  nodes: Array<Course>;
  totalCount: Scalars['Int'];
};

/** コース一覧 input */
export type CoursesFilterInput = {
  /** 検索文字列 */
  searchWord?: InputMaybe<Scalars['String']>;
};

/** お知らせ情報の登録 */
export type CreateAnnouncementInput = {
  /** 本文 */
  body: Scalars['String'];
  /** 種別（お知らせ、メンテナンス、キャンペーン） */
  kind: Scalars['String'];
  /** 公開終了日時 */
  publishEndedAt: Scalars['DateTime'];
  /** 公開開始日時 */
  publishStartedAt: Scalars['DateTime'];
  /** 件名 */
  subject: Scalars['String'];
};

/** マスタ「au英語の分野」作成 input */
export type CreateAuVideoCategoryInput = {
  /** 名前 */
  name: Scalars['String'];
};

/** au英語の動画追加の入力 */
export type CreateAuVideoInput = {
  /** 分野（カテゴリー） */
  categoryIds: Array<Scalars['String']>;
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** JStreamのID */
  jStreamMId: Scalars['String'];
  /** レベル */
  levelId?: InputMaybe<Scalars['String']>;
  /** 動画名 */
  name: Scalars['String'];
  /** どのplanに紐づくか */
  planId?: InputMaybe<Scalars['String']>;
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
};

/** マスタ「au英語レベル」作成 input */
export type CreateAuVideoLevelInput = {
  /** 名前 */
  name: Scalars['String'];
};

/** クラスと授業の登録 */
export type CreateClassAndLessonsInput = {
  /** 任意に設定できるクラスID */
  anyClassId?: InputMaybe<Scalars['String']>;
  /** 申込者数の表示/非表示 */
  applicantCountVisibility: Scalars['Boolean'];
  /** ZoomURL自動発行 */
  autoCreateZoomURL: Scalars['Boolean'];
  /** 定員 */
  capacity: Scalars['Int'];
  /** コースID */
  courseId: Scalars['String'];
  /** 開催場所 */
  eventLocation: Scalars['String'];
  /** 授業一覧 */
  lessons: Array<LessonInput>;
  /** クラス名 */
  name?: InputMaybe<Scalars['String']>;
  /** 公開設定 */
  published?: InputMaybe<Scalars['Boolean']>;
  /** 販売終了日時 */
  saleEndedAt?: InputMaybe<Scalars['DateTime']>;
  /** 販売開始日時 */
  saleStartedAt?: InputMaybe<Scalars['DateTime']>;
};

/** お問い合わせ履歴の登録 */
export type CreateContactHistoryInput = {
  /** 問い合わせID */
  contactId: Scalars['ID'];
  /** 対応内容 */
  memo?: InputMaybe<Scalars['String']>;
  /** 変更前のステータス */
  oldStatus?: InputMaybe<ContactStatus>;
  /** サービス種別 */
  serviceKind: ServiceKind;
  /** ステータス */
  status: ContactStatus;
};

/** お問い合わせ情報の登録 */
export type CreateContactInput = {
  /** 連絡先 */
  address?: InputMaybe<ContactAddressInput>;
  /** 問い合わせ種別ID */
  categoryId: Scalars['ID'];
  /** 問い合わせ内容 */
  content: Scalars['String'];
  /** 問い合わせ会員ID（会員の場合） */
  customerId?: InputMaybe<Scalars['String']>;
  /** 問い合わせ経路 */
  route: ContactRoute;
  /** サービス種別 */
  serviceKind: ServiceKind;
};

/** コース詳細の登録 */
export type CreateCourseDetailInput = {
  /** コース詳細項目のカテゴリ */
  category: CourseDetailCategory;
  /** コース詳細項目の説明 */
  description: Scalars['String'];
};

/** コースの登録 */
export type CreateCourseInput = {
  /** コースID（ユーザー管理用） */
  courseId?: InputMaybe<Scalars['String']>;
  /** コース詳細 */
  details: Array<CreateCourseDetailInput>;
  /** 授業マスター */
  lessonMasters: Array<CreateLessonMasterInput>;
  /** マスタ「カテゴリ（レベル）」ID */
  levelId?: InputMaybe<Scalars['String']>;
  /** コース名 */
  name: Scalars['String'];
  /** マスタ「カテゴリ（事業者）」ID */
  organizerId?: InputMaybe<Scalars['String']>;
  /** コース概要 */
  overview: Scalars['String'];
  /** コース価格 */
  price: CoursePriceInput;
  /**
   * """
   * アンケート
   * """
   */
  questionnaires?: InputMaybe<Array<CreateQuestionnaireInput>>;
  /** マスタ「カテゴリ（科目）」ID */
  subjectIds?: InputMaybe<Array<Scalars['String']>>;
  /** コースターゲット */
  targets?: InputMaybe<CourseTargetInput>;
  /** コース動画 */
  videos?: InputMaybe<Array<CourseVideoInput>>;
};

export type CreateCustomerNoteInput = {
  /** カスタマーID */
  customerId: Scalars['String'];
  /** 顧客情報メモ */
  note?: InputMaybe<Scalars['String']>;
};

export type CreateDiscountInput = {
  /** コード */
  code: Scalars['String'];
  /** 説明 */
  description?: InputMaybe<Scalars['String']>;
  /** 月額クーポンの場合の割引期間（月） */
  durationMonths?: InputMaybe<Scalars['Int']>;
  /** 有効期限 */
  endedAt: Scalars['DateTime'];
  /** コース限定クーポンの場合のコースIDリスト */
  limitedCourseIds?: InputMaybe<Array<Scalars['String']>>;
  /** 名前 */
  name: Scalars['String'];
  /** 価格（税抜き） */
  priceValueNoTax: Scalars['Int'];
  /** 発効日時 */
  startedAt: Scalars['DateTime'];
  /** 種別 */
  type: DiscountType;
};

/** 有識者登録の入力データ */
export type CreateExpertInput = {
  /** 詳細ページのパス文字列 */
  alias: Scalars['String'];
  /** 有識者の著作情報 */
  booksListText?: InputMaybe<Scalars['String']>;
  /** 経歴 */
  career?: InputMaybe<Scalars['String']>;
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** 所属 */
  company?: InputMaybe<Scalars['String']>;
  /** 有識者のfacebook URL */
  facebookUrl?: InputMaybe<Scalars['String']>;
  /** 有識者の姓 */
  familyName: Scalars['String'];
  /** 有識者の姓・フリガナ */
  familyNameKana: Scalars['String'];
  /** 有識者の名 */
  givenName: Scalars['String'];
  /** 有識者の名・フリガナ */
  givenNameKana: Scalars['String'];
  /** 有識者のinstagram URL */
  instagramUrl?: InputMaybe<Scalars['String']>;
  /** 役職 */
  position?: InputMaybe<Scalars['String']>;
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** 有識者の公式サイトURL */
  siteUrl?: InputMaybe<Scalars['String']>;
  /** 肩書 */
  title: Scalars['String'];
  /** 有識者のtwitter URL */
  twitterUrl?: InputMaybe<Scalars['String']>;
  /** 有識者のwikipedia URL */
  wikipediaUrl?: InputMaybe<Scalars['String']>;
  /** 有識者のyoutube URL */
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** 外部教師の登録 */
export type CreateExternalUserInput = {
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['String']>;
  /** 出身国 */
  birthplace?: InputMaybe<Scalars['String']>;
  /** 姓 */
  familyName: Scalars['String'];
  /** 姓のフリガナ */
  familyNameKana?: InputMaybe<Scalars['String']>;
  /** 性別 */
  gender: Gender;
  /** 名 */
  givenName: Scalars['String'];
  /** 名のフリガナ */
  givenNameKana?: InputMaybe<Scalars['String']>;
  /** 趣味 */
  hobby?: InputMaybe<Scalars['String']>;
  /** メッセージ */
  message?: InputMaybe<Scalars['String']>;
  /** 自己紹介 */
  selfIntroduction?: InputMaybe<Scalars['String']>;
  /** ステータス */
  status: EmployeeStatus;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
  /** ユーザーID */
  userId: Scalars['EmailAddress'];
  /** 教師歴 */
  yearsOfTeaching?: InputMaybe<Scalars['Int']>;
};

/** マスタ「分野」作成 input */
export type CreateFieldInput = {
  /** エイリアス */
  alias: Scalars['String'];
  /** 分野名 */
  name: Scalars['String'];
  /** サブタイトル */
  subTitle: Scalars['String'];
  /** 説明文 */
  summary: Scalars['String'];
};

/** 授業マスターの登録 */
export type CreateLessonMasterInput = {
  /** 授業名 */
  name: Scalars['String'];
  /** 授業の表示順 */
  order: Scalars['Int'];
};

/** マスタ「レベル」作成 input */
export type CreateLevelInput = {
  /** 名前 */
  name: Scalars['String'];
  /** ステータス */
  status?: InputMaybe<Scalars['Boolean']>;
};

/** マスタ「事業者」作成 input */
export type CreateOrganizerInput = {
  /** 名前 */
  name: Scalars['String'];
};

/** アンケートの登録 */
export type CreateQuestionnaireInput = {
  /** 選択条件 */
  condition?: InputMaybe<SelectableOptionConditionType>;
  /** 最大値のラベル */
  maxLabel?: InputMaybe<Scalars['String']>;
  /** メモリの最大値 */
  maxScale?: InputMaybe<Scalars['Int']>;
  /** 最小値のラベル */
  minLabel?: InputMaybe<Scalars['String']>;
  /** アンケートオプション */
  options?: InputMaybe<Array<QuestionnaireOptionInput>>;
  /** アンケートの順番 */
  order: Scalars['Int'];
  /** アンケート項目が必須か否か */
  required: Scalars['Boolean'];
  /** 複数選択できる数 */
  selectableNumber?: InputMaybe<Scalars['Int']>;
  /** アンケート項目のタイトル */
  title: Scalars['String'];
  /** アンケート項目の種類 */
  typename: QuestionnaireType;
};

/** マスタ「カテゴリ（科目）」作成 input */
export type CreateSubjectInput = {
  /** 名前 */
  name: Scalars['String'];
  /** ステータス */
  status: Scalars['Boolean'];
};

/** 動画追加の入力 */
export type CreateVideoInput = {
  /** J-Streamの動画ID */
  jStreamMId: Scalars['String'];
  /** 動画のタイトル */
  name: Scalars['String'];
  /** 順番 */
  order: Scalars['Int'];
};

/** シリーズ追加の入力 */
export type CreateVideoLessonInput = {
  /** 詳細ページのパス文字列 */
  alias: Scalars['String'];
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** 説明文 */
  description: Scalars['String'];
  /** 有識者 */
  expertId: Scalars['String'];
  /** 分野名 */
  fieldId: Scalars['String'];
  /** サンプル動画 */
  jStreamSampleMId: Scalars['String'];
  /** タイトル */
  name: Scalars['String'];
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** カテゴリー */
  videoTagId: Scalars['String'];
  /** 動画 */
  videos: Array<CreateVideoInput>;
};

/** マスタ「動画タグ」作成 input */
export type CreateVideoTagInput = {
  /** 名前 */
  name: Scalars['String'];
  /** ステータス */
  status: Scalars['Boolean'];
};

export type CurrentServiceKind = {
  __typename?: 'CurrentServiceKind';
  id: Scalars['ID'];
  key: ServiceKind;
};

/** 会員（CSV ダウンロード用） */
export type Customer = {
  __typename?: 'Customer';
  /** 同意した規約リスト */
  agreedTerms?: Maybe<Array<Terms>>;
  /** 規約同意状況 */
  agreements: Array<Agreement>;
  /** 連携済みau ID */
  auId?: Maybe<Scalars['String']>;
  /** 会員登録年月日 */
  createdAt: Scalars['DateTime'];
  /** 会員登録時サービス */
  customerServices: Array<CustomerService>;
  /** System ID */
  id: Scalars['ID'];
  /** 会員プロフィール */
  profile?: Maybe<CustomerProfile>;
  /** カスタマー新規登録 */
  registration?: Maybe<CustomerRegistration>;
};

export type CustomerFilterInput = {
  /** 氏名 */
  customerName: Scalars['String'];
  /** フリガナ */
  customerNameKana: Scalars['String'];
  /** 退会済みユーザーを含むかどうか */
  isDeletedUserIncluded: Scalars['Boolean'];
  /** 会員ID(メールアドレス) */
  memberId: Scalars['String'];
  /** 会員登録年月日(開始) */
  registerFrom?: InputMaybe<Scalars['String']>;
  /** 会員登録年月日(終了) */
  registerTo?: InputMaybe<Scalars['String']>;
  /** 会員登録時サービス */
  searchCustomerServiceKind?: InputMaybe<Array<Scalars['String']>>;
  /** 電話番号（ハイフンなし） */
  tel: Scalars['String'];
};

/** 会員（画面表示用 ＝ 個人情報を除外） */
export type CustomerForDisplay = {
  __typename?: 'CustomerForDisplay';
  /** 同意した規約リスト */
  agreedTerms?: Maybe<Array<Terms>>;
  /** 規約同意状況 */
  agreements: Array<Agreement>;
  /** 連携済みau ID */
  auId?: Maybe<Scalars['String']>;
  /** 会員登録年月日 */
  createdAt: Scalars['DateTime'];
  /** System ID */
  id: Scalars['ID'];
};

/** 会員プロフィール */
export type CustomerProfile = {
  __typename?: 'CustomerProfile';
  /** 年齢 */
  age: Scalars['Int'];
  /** 生年月日 */
  birthday: Scalars['String'];
  /** 市区町村 */
  city: Scalars['String'];
  /** カスタマーID */
  customerId: Scalars['String'];
  /** 姓 */
  familyName: Scalars['String'];
  /** 姓のフリガナ */
  familyNameKana: Scalars['String'];
  /** 性別 */
  gender: Gender;
  /** 名 */
  givenName: Scalars['String'];
  /** 名のフリガナ */
  givenNameKana: Scalars['String'];
  /** 番地・アパートマンション名・部屋番号 */
  houseNumber: Scalars['String'];
  id: Scalars['ID'];
  /** 会員ID(メールアドレス) */
  memberId?: Maybe<Scalars['String']>;
  /** スタッフ向け顧客情報メモ */
  note?: Maybe<UserNote>;
  /** 保護者情報 */
  parentProfile?: Maybe<ParentsProfile>;
  /** 郵便番号 */
  postalCode: Scalars['String'];
  /** 都道府県 */
  prefecture: Scalars['String'];
  /** 会員の興味のあるカテゴリー */
  subjects: Array<Subject>;
  /** 電話番号 */
  tel: Scalars['String'];
  /** 社会人向け属性情報 */
  userAttribute?: Maybe<UserAttribute>;
};

/** 新規登録データ */
export type CustomerRegistration = {
  __typename?: 'CustomerRegistration';
  /** カスタマーID */
  customerId: Scalars['String'];
  /** 登録キー */
  eventKey: Scalars['String'];
  /** 新規登録ID */
  id: Scalars['ID'];
};

/** 会員サービス情報 */
export type CustomerService = {
  __typename?: 'CustomerService';
  /** カスタマーID */
  customerId: Scalars['String'];
  /** サービス種別名 */
  serviceKindName: Scalars['String'];
};

/** 会員一覧（CSV ダウンロード用） */
export type Customers = {
  __typename?: 'Customers';
  nodes: Array<Customer>;
  totalCount: Scalars['Int'];
};

/** 会員一覧（画面表示用 ＝ 個人情報を除外） */
export type CustomersForDisplay = {
  __typename?: 'CustomersForDisplay';
  nodes: Array<CustomerForDisplay>;
  totalCount: Scalars['Int'];
};

/**
 * 日時に対する検索条件
 * startAt <= 検索対象の日時 <= endAt の条件を表す
 */
export type DateTimeFilterInput = {
  /** 期間の終了日時 */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** 期間の開始日時 */
  startAt?: InputMaybe<Scalars['DateTime']>;
};

/** クラスと授業の削除 */
export type DeleteClassAndLessonsInput = {
  /** クラスID */
  clazzId: Scalars['ID'];
};

/** コースの削除 */
export type DeleteCourseInput = {
  /** コースID */
  courseId: Scalars['ID'];
};

export type DeleteLessonMasterTeachingMaterialInput = {
  teachingMaterialIds: Array<Scalars['String']>;
};

export type DeleteProductImagesInput = {
  imageIds: Array<Scalars['String']>;
  productType: ProductType;
};

export type DeleteTeachingMaterialsInput = {
  productType: ProductType;
  teachingMaterialIds: Array<Scalars['String']>;
};

export type Discount = {
  __typename?: 'Discount';
  /** コード */
  code: Scalars['String'];
  /** 作成日時 */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** 説明 */
  description?: Maybe<Scalars['String']>;
  /** 割引期間(月) */
  durationMonths?: Maybe<Scalars['Int']>;
  /** 有効期限 */
  endedAt: Scalars['DateTime'];
  /** 物理ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
  /** 価格（税込み） */
  priceValue: Scalars['Int'];
  /** 価格（税抜き） */
  priceValueNoTax: Scalars['Int'];
  /** 発効日時 */
  startedAt: Scalars['DateTime'];
  /**
   * 種別
   * ※ enum DiscountType の値は String
   */
  type: Scalars['String'];
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * ##
 * コース限定クーポンに紐づくコースのスキーマ
 * 既存の定義でも代用できるが不要な必須項目が増えたりする場合があるので別途定義
 * ##
 */
export type DiscountCourse = {
  __typename?: 'DiscountCourse';
  /** コース ID */
  id: Scalars['ID'];
  /** コース名 */
  name: Scalars['String'];
  /** システム ID */
  systemId: Scalars['String'];
};

export { DiscountType };

export type Discounts = {
  __typename?: 'Discounts';
  /** データリスト */
  nodes: Array<Discount>;
  /** 総数 */
  totalCount: Scalars['Int'];
};

/** ユーザー（スタッフ）のステータス */
export enum EmployeeStatus {
  /** 有効状態 */
  Active = 'active',
  /** 無効状態 */
  Inactive = 'inactive'
}

/** 有識者 */
export type Expert = {
  __typename?: 'Expert';
  /** 詳細ページのパス文字列 */
  alias: Scalars['String'];
  /** 写真が表示されない時に表示される文言 */
  alt: Scalars['String'];
  /** 有識者の著作情報 */
  booksListText?: Maybe<Scalars['String']>;
  /** 経歴 */
  career: Scalars['String'];
  /** 公開終了日時 */
  closedAt?: Maybe<Scalars['DateTime']>;
  /** 所属 */
  company: Scalars['String'];
  /** facebook URL */
  facebookUrl?: Maybe<Scalars['String']>;
  /** 有識者の姓 */
  familyName: Scalars['String'];
  /** 有識者の姓・フリガナ */
  familyNameKana: Scalars['String'];
  /** 有識者の名 */
  givenName: Scalars['String'];
  /** 有識者の名・フリガナ */
  givenNameKana: Scalars['String'];
  /** 宣材写真のURL */
  headshot?: Maybe<Scalars['URL']>;
  /** 有識者ID */
  id: Scalars['ID'];
  /** instagram URL */
  instagramUrl?: Maybe<Scalars['String']>;
  /** 役職 */
  position: Scalars['String'];
  /** プロフィール写真のURL */
  profilePhoto?: Maybe<Scalars['URL']>;
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** 公式サイトURL */
  siteUrl?: Maybe<Scalars['String']>;
  /** 肩書 */
  title: Scalars['String'];
  /** twitter URL */
  twitterUrl?: Maybe<Scalars['String']>;
  /** ビデオレッスン */
  videoLessons: Array<VideoLesson>;
  /** wikipedia URL */
  wikipediaUrl?: Maybe<Scalars['String']>;
  /** youtube URL */
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** 登録した有識者画像情報 */
export type ExpertImagePresignedPostResult = {
  __typename?: 'ExpertImagePresignedPostResult';
  headshot?: Maybe<PresignedPostResult>;
  profilePhoto?: Maybe<PresignedPostResult>;
};

/** 有識者一覧の検索結果 */
export type Experts = {
  __typename?: 'Experts';
  /** 有識者のリスト */
  nodes: Array<Expert>;
  /** 全件数 */
  totalCount: Scalars['Int'];
};

/** 有識者一覧の検索条件 */
export type ExpertsFilterInput = {
  /** 有識者名 */
  name?: InputMaybe<Scalars['String']>;
};

/** 注目の動画 */
export type FeaturedVideo = {
  __typename?: 'FeaturedVideo';
  /** サムネイル画像のファイル名 */
  fileName: Scalars['String'];
  /** id */
  id: Scalars['ID'];
  /** 注目の動画名（イベントアクション名） */
  name: Scalars['String'];
  /** 注目の動画の順番 */
  order: Scalars['Int'];
  /** 注目の動画の遷移先 */
  path: Scalars['String'];
  /** サムネイル画像のS3ファイルパス */
  thumbnailUrl: Scalars['URL'];
};

/** マスタ「分野」 */
export type Field = {
  __typename?: 'Field';
  /** エイリアス */
  alias: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
  /** サブタイトル */
  subTitle: Scalars['String'];
  /** 説明文 */
  summary: Scalars['String'];
};

/** マスタ「分野」一覧 */
export type Fields = {
  __typename?: 'Fields';
  nodes: Array<Field>;
  totalCount: Scalars['Int'];
};

/** 検索用input：content, teacherで使用 */
export type FilterInput = {
  searchWord?: InputMaybe<Scalars['String']>;
  serviceKind?: InputMaybe<Scalars['String']>;
};

export enum Gender {
  /** 男性 */
  Man = 'man',
  /** 回答しない */
  None = 'none',
  /** その他 */
  Other = 'other',
  /** 女性 */
  Woman = 'woman'
}

/** 有識者画像保存用URL作成の入力データ */
export type GenerateUploadExpertImageUrlInput = {
  /** 有識者ID */
  expertId: Scalars['ID'];
  /** 宣材写真のファイル名 */
  headShotFileName?: InputMaybe<Scalars['String']>;
  /** プロフィール写真のファイル名 */
  profilePhotoFileName?: InputMaybe<Scalars['String']>;
};

/** シリーズの画像保存用URL作成の入力データ */
export type GenerateUploadVideoLessonImageUrlInput = {
  /** 分野から探すカードのファイル名 */
  fileName: Scalars['String'];
  /** シリーズID */
  videoLessonId: Scalars['String'];
};

/** GMO決済トランザクション */
export type GmoPaymentTransaction = {
  __typename?: 'GmoPaymentTransaction';
  accessId?: Maybe<Scalars['String']>;
  accessPass?: Maybe<Scalars['String']>;
  accountTimeingKbn?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  errCode?: Maybe<Scalars['String']>;
  errInf?: Maybe<Scalars['String']>;
  firstPaymentDate?: Maybe<Scalars['DateTime']>;
  firstStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order: Order;
  paymentDay?: Maybe<Scalars['Int']>;
  price: GmoPrice;
  typename?: Maybe<Scalars['String']>;
};

export type GmoPrice = {
  __typename?: 'GmoPrice';
  amount: Scalars['Int'];
  tax: Scalars['Int'];
  type: PriceType;
};

export type Handler = {
  __typename?: 'Handler';
  /** 姓 */
  familyName: Scalars['String'];
  /** 名 */
  givenName: Scalars['String'];
  /** 従業員システムID */
  id: Scalars['ID'];
  /** 従業員ID */
  userId: Scalars['String'];
};

/** 授業 */
export type Lesson = {
  __typename?: 'Lesson';
  /** 任意に設定できる授業ID */
  anyLessonId?: Maybe<Scalars['String']>;
  /** クラス */
  clazz?: Maybe<Clazz>;
  /** クラスID */
  clazzId: Scalars['ID'];
  /** 終了日時 */
  endedAt: Scalars['DateTime'];
  /** 授業ID */
  id: Scalars['ID'];
  /** 授業マスター */
  lessonMaster: LessonMaster;
  /** 授業マスターID */
  lessonMasterId: Scalars['ID'];
  /** 授業のURL */
  lessonUrl?: Maybe<Scalars['String']>;
  /** 開催場所種別 */
  locationType: LocationType;
  /** 出席者数 */
  participantsCount: Scalars['Int'];
  /** 開始日時 */
  startedAt: Scalars['DateTime'];
  /** 授業のシステムID */
  systemId: Scalars['String'];
  /** 担当教師 */
  teachers: Array<User>;
  /** Zoomの授業参加URL */
  zoomJoinUrl?: Maybe<Scalars['String']>;
  /** Zoomの授業開始URL */
  zoomStartUrl?: Maybe<Scalars['String']>;
};

/** 授業の登録 */
export type LessonInput = {
  /** 任意に設定できる授業ID */
  anyLessonId?: InputMaybe<Scalars['String']>;
  /** 終了日時 */
  endedAt?: InputMaybe<Scalars['DateTime']>;
  /** 授業マスターID */
  lessonMasterId: Scalars['ID'];
  /** 授業のURL */
  lessonUrl?: InputMaybe<Scalars['String']>;
  /** 開催場所種別 */
  locationType: LocationType;
  /** 開始日時 */
  startedAt?: InputMaybe<Scalars['DateTime']>;
  /** 担当教師ID */
  teacherIds: Array<Scalars['String']>;
};

/** 授業マスター */
export type LessonMaster = {
  __typename?: 'LessonMaster';
  /** 授業マスターID */
  id: Scalars['ID'];
  /** 授業名 */
  name: Scalars['String'];
  /** 授業の順番 */
  order: Scalars['Int'];
  /** 授業終了後に配布する教材 */
  teachingMaterials?: Maybe<Array<LessonMasterTeachingMaterial>>;
};

/** 授業マスタ教材（授業終了後に配布する教材） */
export type LessonMasterTeachingMaterial = {
  __typename?: 'LessonMasterTeachingMaterial';
  /** 授業マスタ教材のID */
  id: Scalars['ID'];
  /** 授業マスタ教材のファイル名 */
  name: Scalars['String'];
  /** 授業マスタ教材のURL */
  url: Scalars['String'];
};

/** 授業一覧 */
export type Lessons = {
  __typename?: 'Lessons';
  nodes: Array<Lesson>;
  totalCount: Scalars['Int'];
};

/** マスタ「レベル」 */
export type Level = {
  __typename?: 'Level';
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
  /** ステータス */
  status: Scalars['Boolean'];
  /** システムID */
  systemId: Scalars['String'];
};

export type LevelFilterInput = {
  /** ステータスがアクティブかどうか */
  active?: InputMaybe<Scalars['Boolean']>;
  /** 検索テキスト */
  searchWord?: InputMaybe<Scalars['String']>;
};

/** マスタ「レベル」一覧 */
export type Levels = {
  __typename?: 'Levels';
  nodes: Array<Level>;
  totalCount: Scalars['Int'];
};

/** 開催場所種別 */
export enum LocationType {
  /** その他の場所 */
  Others = 'others',
  /** Zoom */
  Zoom = 'zoom'
}

export type MismatchHandlingHistory = {
  __typename?: 'MismatchHandlingHistory';
  /** 作成日時 */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * 更新者
   * ※User型は情報過多のため型定義している
   */
  handler?: Maybe<Handler>;
  /** 対応状況 */
  handlingStatus?: Maybe<Scalars['String']>;
  /** 対応履歴ID */
  id?: Maybe<Scalars['String']>;
  /** 対応履歴 */
  note?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MismatchHandlingHistoryInput = {
  /** 従業員システムID */
  employeeId: Scalars['String'];
  /** 対応状況 */
  handlingStatus: Scalars['String'];
  /** 対応履歴 */
  note: Scalars['String'];
  /** 不整合ID */
  paymentMismatchId: Scalars['String'];
};

export { MplProcessedDataKind };

export type Mutation = {
  __typename?: 'Mutation';
  /** コースのオーソリ取消 */
  cancelAuthorizedCourse: StartCancelAuthorizedCourseResult;
  /** コースの売上取消 */
  cancelSoldCourse: StartCancelSoldCourseResult;
  /** ZoomUser有効性確認 */
  checkEnableZoomUser: Scalars['Boolean'];
  /** お知らせ情報の登録 */
  createAnnouncement: Announcement;
  /** クラスと授業の新規登録 */
  createClassAndLessons?: Maybe<Clazz>;
  /** お問い合わせ情報の登録 */
  createContact: Contact;
  /** お問い合わせ履歴の登録 */
  createContactHistory: ContactHistory;
  /** コースの新規登録 */
  createCourse: Course;
  /** コースのプレビュートークン作成 */
  createCoursePreviewToken: CoursePreviewToken;
  /** スタッフ向け顧客情報メモ登録 */
  createCustomerNote: UserNote;
  createDiscount: Discount;
  /** 有識者を登録する */
  createExpert: Expert;
  /** 外部教師の登録 */
  createExternalUser: User;
  /** マスタ「分野」作成 */
  createField?: Maybe<Field>;
  /** マスタ「レベル」作成 */
  createLevel?: Maybe<Level>;
  /** 不整合対応履歴の作成 */
  createMismatchHandlingHistory?: Maybe<MismatchHandlingHistory>;
  /** マスタ「事業者」作成 */
  createOrganizer: Organizer;
  /** マスタ「カテゴリ（科目）」作成 */
  createSubject?: Maybe<Subject>;
  /** シリーズを追加する */
  createVideoLesson: VideoLesson;
  /** マスタ「動画タグ」作成 */
  createVideoTag: VideoTag;
  /** ZoomのURLの作成 */
  createZoomURL: Scalars['JSONObject'];
  /** クラスと授業の削除 */
  deleteClassAndLessons: Scalars['Boolean'];
  /** お問い合わせ情報の削除（論理削除） */
  deleteContactLogically: Scalars['Boolean'];
  /** コースの削除 */
  deleteCourse: Scalars['Boolean'];
  /** コースのプレビュートークン削除 */
  deleteCoursePreviewToken: Scalars['Boolean'];
  deleteDiscount: Discount;
  /** 授業マスタ教材ファイルの削除 */
  deleteLessonMasterTeachingMaterials: Scalars['Boolean'];
  /** コンテンツ画像の削除 */
  deleteProductImages: Scalars['Boolean'];
  /** コンテンツ教材の削除 */
  deleteTeachingMaterials: Scalars['Boolean'];
  /** アバター画像ファイル保存用URLの作成 */
  generateUploadAvatorUrl?: Maybe<PresignedPostResult>;
  /** コース画像ファイル保存用URLの作成 */
  generateUploadCourseImageUrl?: Maybe<PresignedPostResult>;
  /** コース教材ファイル保存用URLの作成 */
  generateUploadCourseTeachingMaterialUrl?: Maybe<PresignedPostResult>;
  /** 有識者画像（プロフィール画像・アイコン画像）保存用URL作成 */
  generateUploadExpertImageUrl: ExpertImagePresignedPostResult;
  /** 注目の動画画像保存用URL作成 */
  generateUploadFeaturedVideoImageUrl?: Maybe<PresignedPostResult>;
  /** 授業教材ファイル保存用URLの作成 */
  generateUploadLessonMasterTeachingMaterialUrl?: Maybe<PresignedPostResult>;
  /** シリーズ画像（分野から探す）保存用URL作成 */
  generateUploadVideoLessonImageUrl: PresignedPostResult;
  /** お知らせ情報の更新 */
  updateAnnouncement: Announcement;
  /** クラスと授業の更新 */
  updateClassAndLessons?: Maybe<Clazz>;
  /** コースの更新 */
  updateCourse: Course;
  /** コース画像情報更新 */
  updateCourseImageOrders?: Maybe<Array<CourseImage>>;
  /** コースの並び順更新 */
  updateCourseOrders: Array<Course>;
  updateDiscount: Discount;
  /** 有識者を更新する */
  updateExpert: Expert;
  /** 注目の動画を更新する */
  updateFeaturedVideos: Array<FeaturedVideo>;
  /** マスタ「分野」更新 */
  updateField?: Maybe<Field>;
  /** マスタ「レベル」更新 */
  updateLevel?: Maybe<Level>;
  /** マスタ「事業者」更新 */
  updateOrganizer: Organizer;
  /** 不整合情報の更新(対応状況の更新に用いる) */
  updatePaymentMismatch: PaymentMismatch;
  /** プロフィールの更新 */
  updateProfile?: Maybe<User>;
  /** マスタ「カテゴリ（科目）」更新 */
  updateSubject?: Maybe<Subject>;
  /** マスタ「カテゴリ（科目）」の並び順更新 */
  updateSubjectOrders: Array<Subject>;
  /** 従業員情報の更新 */
  updateUser?: Maybe<User>;
  /** シリーズを更新する */
  updateVideoLesson: VideoLesson;
  /** マスタ「動画タグ」更新 */
  updateVideoTag: VideoTag;
  /** 法人CSVのアップロード */
  uploadCorporationCsv: UploadCorporationCsvResult;
};


export type MutationCancelAuthorizedCourseArgs = {
  paymentId: Scalars['String'];
};


export type MutationCancelSoldCourseArgs = {
  paymentId: Scalars['String'];
};


export type MutationCreateAnnouncementArgs = {
  input?: InputMaybe<CreateAnnouncementInput>;
};


export type MutationCreateClassAndLessonsArgs = {
  input: CreateClassAndLessonsInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContactHistoryArgs = {
  input: CreateContactHistoryInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateCoursePreviewTokenArgs = {
  courseId: Scalars['ID'];
};


export type MutationCreateCustomerNoteArgs = {
  input: CreateCustomerNoteInput;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountInput;
};


export type MutationCreateExpertArgs = {
  input: CreateExpertInput;
};


export type MutationCreateExternalUserArgs = {
  input: CreateExternalUserInput;
};


export type MutationCreateFieldArgs = {
  input: CreateFieldInput;
};


export type MutationCreateLevelArgs = {
  input: CreateLevelInput;
};


export type MutationCreateMismatchHandlingHistoryArgs = {
  input: MismatchHandlingHistoryInput;
};


export type MutationCreateOrganizerArgs = {
  input: CreateOrganizerInput;
};


export type MutationCreateSubjectArgs = {
  input: CreateSubjectInput;
};


export type MutationCreateVideoLessonArgs = {
  input: CreateVideoLessonInput;
};


export type MutationCreateVideoTagArgs = {
  input: CreateVideoTagInput;
};


export type MutationDeleteClassAndLessonsArgs = {
  input: DeleteClassAndLessonsInput;
};


export type MutationDeleteContactLogicallyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCourseArgs = {
  input: DeleteCourseInput;
};


export type MutationDeleteCoursePreviewTokenArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLessonMasterTeachingMaterialsArgs = {
  input: DeleteLessonMasterTeachingMaterialInput;
};


export type MutationDeleteProductImagesArgs = {
  input: DeleteProductImagesInput;
};


export type MutationDeleteTeachingMaterialsArgs = {
  input: DeleteTeachingMaterialsInput;
};


export type MutationGenerateUploadAvatorUrlArgs = {
  fileName: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationGenerateUploadCourseImageUrlArgs = {
  courseId: Scalars['ID'];
  courseImageId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  order: Scalars['Int'];
};


export type MutationGenerateUploadCourseTeachingMaterialUrlArgs = {
  courseId: Scalars['ID'];
  fileName: Scalars['String'];
  teachingMaterialId?: InputMaybe<Scalars['ID']>;
};


export type MutationGenerateUploadExpertImageUrlArgs = {
  input: GenerateUploadExpertImageUrlInput;
};


export type MutationGenerateUploadFeaturedVideoImageUrlArgs = {
  featuredVideoId: Scalars['ID'];
  featuredVideoImageId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  order: Scalars['Int'];
};


export type MutationGenerateUploadLessonMasterTeachingMaterialUrlArgs = {
  fileName: Scalars['String'];
  lessonMasterId: Scalars['ID'];
  lessonMasterTeachingMaterialId?: InputMaybe<Scalars['ID']>;
};


export type MutationGenerateUploadVideoLessonImageUrlArgs = {
  input: GenerateUploadVideoLessonImageUrlInput;
};


export type MutationUpdateAnnouncementArgs = {
  input?: InputMaybe<UpdateAnnouncementInput>;
};


export type MutationUpdateClassAndLessonsArgs = {
  input: UpdateClassAndLessonsInput;
};


export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationUpdateCourseImageOrdersArgs = {
  input: UpdateCourseImageOrdersInput;
};


export type MutationUpdateCourseOrdersArgs = {
  input: UpdateCourseOrdersInput;
};


export type MutationUpdateDiscountArgs = {
  input: UpdateDiscountInput;
};


export type MutationUpdateExpertArgs = {
  input: UpdateExpertInput;
};


export type MutationUpdateFeaturedVideosArgs = {
  input: Array<UpdateFeaturedVideoInput>;
};


export type MutationUpdateFieldArgs = {
  input: UpdateFieldInput;
};


export type MutationUpdateLevelArgs = {
  input: UpdateLevelInput;
};


export type MutationUpdateOrganizerArgs = {
  input: UpdateOrganizerInput;
};


export type MutationUpdatePaymentMismatchArgs = {
  input: UpdatePaymentMismatchInput;
};


export type MutationUpdateProfileArgs = {
  input: ProfileInput;
};


export type MutationUpdateSubjectArgs = {
  input: UpdateSubjectInput;
};


export type MutationUpdateSubjectOrdersArgs = {
  input: UpdateSubjectOrdersInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUpdateVideoLessonArgs = {
  input: UpdateVideoLessonInput;
};


export type MutationUpdateVideoTagArgs = {
  input: UpdateVideoTagInput;
};


export type MutationUploadCorporationCsvArgs = {
  input: UploadCorporationCsvInput;
};

/** 注文 */
export type Order = {
  __typename?: 'Order';
  /** キャンセル日時 */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** 顧客情報 */
  customer?: Maybe<Customer>;
  /** id */
  id: Scalars['ID'];
  /** 商品名 */
  name: Scalars['String'];
  /** 申込年月日 */
  submittedAt?: Maybe<Scalars['DateTime']>;
  /** システムID（加盟店管理番号）(例：A01312153) */
  systemId: Scalars['String'];
};

export { OrderStatus };

/** 事業者 */
export type Organizer = {
  __typename?: 'Organizer';
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
};

/** マスタ「事業者」フィルター input */
export type OrganizerFilterInput = {
  /** 検索テキスト */
  searchWord?: InputMaybe<Scalars['String']>;
};

/** マスタ「事業者」一覧 */
export type Organizers = {
  __typename?: 'Organizers';
  /** 事業者のリスト */
  nodes: Array<Organizer>;
  /** 全件数 */
  totalCount: Scalars['Int'];
};

/** 保護者情報 */
export type ParentsProfile = {
  __typename?: 'ParentsProfile';
  /** 生年月日 */
  birthday: Scalars['String'];
  /** メールアドレス */
  email: Scalars['String'];
  /** 姓 */
  familyName: Scalars['String'];
  /** 姓のフリガナ */
  familyNameKana: Scalars['String'];
  /** 名 */
  givenName: Scalars['String'];
  /** 名のフリガナ */
  givenNameKana: Scalars['String'];
  /** 電話番号 */
  tel: Scalars['String'];
};

/** 参加者 */
export type Participant = {
  __typename?: 'Participant';
  /** 参加者の年齢 */
  age: Scalars['Int'];
  /** 申込日 */
  applicatedAt: Scalars['DateTime'];
  /** 参加者のユーザID */
  customerId: Scalars['ID'];
  /** 参加者の性別 */
  gender: Gender;
  /** 参加者の学年 */
  grade: Scalars['String'];
};

/** 参加者一覧 */
export type Participants = {
  __typename?: 'Participants';
  nodes: Array<Participant>;
  totalCount: Scalars['Int'];
};

/**
 * 決済詳細
 *   ※ 【サービス/商品提供年月日】
 *   ※１：コンテンツの場合は購入日＝申込日
 *   ※２：コースの場合は第１回目の授業の年月日 --> 画面でコースのクラス一覧を取得する
 */
export type Payment = {
  __typename?: 'Payment';
  /** オーソリ取消/売上取消が可能か */
  cancelable: PaymentCancelable;
  /** キャンセル日時 */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /**
   * クラスID
   * ※ コースの場合は第１回目の授業の年月日を取得するための元ネタ
   */
  clazzId?: Maybe<Scalars['String']>;
  /** コンテンツ名 */
  contentName?: Maybe<Scalars['String']>;
  /** システムID（コンテンツ） */
  contentSytemId?: Maybe<Scalars['String']>;
  /** コース名 */
  courseName?: Maybe<Scalars['String']>;
  /** システムID（コース） */
  courseSytemId?: Maybe<Scalars['String']>;
  /** カスタマーID */
  customerId?: Maybe<Scalars['String']>;
  /** 会員氏名 */
  customerName?: Maybe<Scalars['String']>;
  /** 会員氏名カナ */
  customerNameKana?: Maybe<Scalars['String']>;
  /** GMO初月決済ステータス */
  gmoFirstPaymentStatus?: Maybe<Scalars['String']>;
  /** gmo決済トランザクション */
  gmoPaymentTransaction?: Maybe<GmoPaymentTransaction>;
  /** GMO自動売上(次月以降)決済ステータス */
  gmoRecurringPaymentStatus?: Maybe<Scalars['String']>;
  /** 決済ID */
  id: Scalars['ID'];
  /** 授業一覧情報 */
  lessons?: Maybe<Array<Lesson>>;
  /** 会員ID（メールアドレス） */
  memberId?: Maybe<Scalars['String']>;
  /** 申込番号 */
  orderId?: Maybe<Scalars['String']>;
  /** 決済番号 */
  payInfoNo?: Maybe<Scalars['String']>;
  /**
   * 決済ステータス
   * ※ PaymentStatus の値が int なので
   */
  paymentStatus?: Maybe<Scalars['Int']>;
  /** 決済トランザクション */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** プラン名 */
  planName?: Maybe<Scalars['String']>;
  /** 売上金額(税込) */
  priceValue?: Maybe<Scalars['Int']>;
  /** 売上金額(税抜) */
  priceValueNoTax?: Maybe<Scalars['Int']>;
  /**
   * 最終処理年月日
   * ※ payment テーブルの processDateTime
   */
  processDateTime?: Maybe<Scalars['DateTime']>;
  /** 領収書 */
  receipt?: Maybe<Receipt>;
  /** 決済年月日 */
  soldDateTime?: Maybe<Scalars['DateTime']>;
  /** 申込年月日 */
  submittedAt?: Maybe<Scalars['DateTime']>;
  /**
   * 課金種別
   * ※ PaymentType の値が enum と大文字小文字が違うので
   */
  typename?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** 課金タイミング区分 */
export enum PaymentAccountTimingKbn {
  /** 月末日 */
  EndOfMonth = 'EndOfMonth',
  /** 日指定 */
  SpecifiedDate = 'SpecifiedDate'
}

/** Paymentをオーソリ取消/売上取消可能か */
export enum PaymentCancelable {
  /** オーソリ取消可能 */
  CancelAuthory = 'cancelAuthory',
  /** 売上取消可能 */
  CancelSold = 'cancelSold',
  /** 取消不可能 */
  Never = 'never'
}

export type PaymentInput = {
  /** ID */
  id?: InputMaybe<Scalars['ID']>;
  /** 決済情報番号 */
  payInfoNo?: InputMaybe<Scalars['String']>;
  /** 決済種別 */
  paymentType?: InputMaybe<Scalars['String']>;
};

export type PaymentMismatch = {
  __typename?: 'PaymentMismatch';
  /** 継続課金ID */
  continueAccountId?: Maybe<Scalars['String']>;
  /** 検知日時 */
  detectedDateTime?: Maybe<Scalars['DateTime']>;
  /** 対応状況 */
  handlingStatus?: Maybe<Scalars['String']>;
  /** 決済ID */
  id: Scalars['ID'];
  /** 対象年月日（かんたん決済 CSV 取得 API の引数の値） */
  payDataYYYYMMDD?: Maybe<Scalars['String']>;
  /** 決済情報番号 */
  payInfoNo?: Maybe<Scalars['String']>;
  /** 決済情報 */
  payment?: Maybe<Payment>;
  /** 決済不整合CSVの配列 */
  paymentMismatchCsvs: Array<PaymentMismatchCsv>;
  /**
   * 決済トランザクション
   * 継続課金におけるnotExitInMPLでは、paymentが存在しないためpaymentTransactionも追加している
   */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** サービスID */
  serviceId?: Maybe<Scalars['String']>;
  /** 不整合項目 */
  type?: Maybe<Scalars['String']>;
};

export type PaymentMismatchCsv = {
  __typename?: 'PaymentMismatchCsv';
  /** 調整年月日 */
  adjustedDateTime?: Maybe<Scalars['String']>;
  /**
   * au one-Id
   * システムauIDは流出してはいけない情報なので「あり」か「なし」として表示する
   */
  auOneId?: Maybe<Scalars['String']>;
  /** オーソリ年月日 */
  authDateTime?: Maybe<Scalars['String']>;
  /** 取消年月日 */
  cancelDateTime?: Maybe<Scalars['String']>;
  /** 請求年月日 */
  claimDateTime?: Maybe<Scalars['String']>;
  /** 摘要（商品名） */
  commodity?: Maybe<Scalars['String']>;
  /** 継続課金ID */
  continueAccountId?: Maybe<Scalars['String']>;
  /** 不整合csv情報ID */
  id: Scalars['ID'];
  /** 加盟店ID */
  memberId?: Maybe<Scalars['String']>;
  /** 加盟店管理番号（申込番号） */
  memberManageNo?: Maybe<Scalars['String']>;
  /** 備考 */
  note?: Maybe<Scalars['String']>;
  /** OpenID */
  openId?: Maybe<Scalars['String']>;
  /** 決済情報番号 */
  payInfoNo?: Maybe<Scalars['String']>;
  /** 支払方法 */
  paymtd?: Maybe<Scalars['String']>;
  /** 正負号（空白 / + / -） */
  priceSign?: Maybe<Scalars['String']>;
  /** 金額 */
  priceValue?: Maybe<Scalars['String']>;
  /** 最終処理年月日 */
  processDateTime?: Maybe<Scalars['String']>;
  /** 処理種別 */
  processType?: Maybe<Scalars['String']>;
  /** 返金処理年月日 */
  refundDateTime?: Maybe<Scalars['String']>;
  /** 予約領域１（オーソリ時点の支払方法） */
  reserved1?: Maybe<Scalars['String']>;
  /** 予約領域２（未使用） */
  reserved2?: Maybe<Scalars['String']>;
  /** 予約領域3 */
  reserved3?: Maybe<Scalars['String']>;
  /** 予約領域4 */
  reserved4?: Maybe<Scalars['String']>;
  /** 処理結果コード */
  resultCode?: Maybe<Scalars['String']>;
  /** サービスID */
  serviceId?: Maybe<Scalars['String']>;
  /** サービス名略称 */
  serviceShortName?: Maybe<Scalars['String']>;
  /** 売上確定日 */
  soldDateTime?: Maybe<Scalars['String']>;
  /** ステータス */
  status?: Maybe<Scalars['Int']>;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
};

export { PaymentMismatchStatus };

/** 不整合情報 */
export type PaymentMismatchSummary = {
  __typename?: 'PaymentMismatchSummary';
  /** 検知日時 */
  detectedDateTime?: Maybe<Scalars['DateTime']>;
  /** 対応状況 */
  handlingStatus?: Maybe<Scalars['String']>;
  /** 決済ID */
  id: Scalars['ID'];
  /** 不整合の作成日または対応履歴を更新した最終日時 */
  latestUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** 対象年月日（かんたん決済 CSV 取得 API の引数の値） */
  payDataYYYYMMDD?: Maybe<Scalars['String']>;
  /** 決済情報番号 */
  payInfoNo?: Maybe<Scalars['String']>;
  /** 決済ステータス */
  paymentStatus?: Maybe<Scalars['Int']>;
  /** 不整合項目 */
  type?: Maybe<Scalars['String']>;
};

export { PaymentMismatchType };

/** 不整合一覧 */
export type PaymentMismatches = {
  __typename?: 'PaymentMismatches';
  nodes: Array<PaymentMismatchSummary>;
  totalCount: Scalars['Int'];
};

export type PaymentMismatchesFilterInput = {
  /** 対応状況 */
  handlingStatus?: InputMaybe<Array<Scalars['String']>>;
  /** 決済情報番号 */
  payInfoNo?: InputMaybe<Scalars['String']>;
};

export { PaymentStatus };

/** 決済情報（CSV ダウンロード用） */
export type PaymentSummary = {
  __typename?: 'PaymentSummary';
  /** コンテンツ名 */
  contentName?: Maybe<Scalars['String']>;
  /** システムID（コンテンツ） */
  contentSytemId?: Maybe<Scalars['String']>;
  /** コース名 */
  courseName?: Maybe<Scalars['String']>;
  /** システムID（コース） */
  courseSytemId?: Maybe<Scalars['String']>;
  /** お客様番号（customer.id） */
  customerId?: Maybe<Scalars['String']>;
  /** 会員氏名 */
  customerName?: Maybe<Scalars['String']>;
  /** 決済ID */
  id: Scalars['ID'];
  /** 会員ID（メールアドレス） */
  memberId?: Maybe<Scalars['String']>;
  /** 申込番号 */
  orderId?: Maybe<Scalars['String']>;
  /** 事業者名 */
  organizerName?: Maybe<Scalars['String']>;
  /** 決済番号 */
  payInfoNo?: Maybe<Scalars['String']>;
  /** 決済方法 */
  payService?: Maybe<Scalars['Int']>;
  /**
   * 決済ステータス
   * ※ PaymentStatus の値が int なので
   */
  paymentStatus?: Maybe<Scalars['Int']>;
  /** プラン名 */
  planName?: Maybe<Scalars['String']>;
  /** 売上金額(税込) */
  priceValue?: Maybe<Scalars['Int']>;
  /** 売上金額(税抜) */
  priceValueNoTax?: Maybe<Scalars['Int']>;
  /** 決済年月日 */
  soldDateTime?: Maybe<Scalars['DateTime']>;
  /** 申込年月日 */
  submittedAt?: Maybe<Scalars['DateTime']>;
  /**
   * 課金種別
   * ※ PaymentType の値が enum と大文字小文字が違うので
   */
  typename?: Maybe<Scalars['String']>;
};

/** 決済情報（画面表示用 ＝ 個人情報を除外） */
export type PaymentSummaryForDisplay = {
  __typename?: 'PaymentSummaryForDisplay';
  /** コンテンツ名 */
  contentName?: Maybe<Scalars['String']>;
  /** システムID（コンテンツ） */
  contentSytemId?: Maybe<Scalars['String']>;
  /** コース名 */
  courseName?: Maybe<Scalars['String']>;
  /** システムID（コース） */
  courseSytemId?: Maybe<Scalars['String']>;
  /** お客様番号（customer.id） */
  customerId?: Maybe<Scalars['String']>;
  /** GMO初月決済ステータス */
  gmoFirstPaymentStatus?: Maybe<Scalars['String']>;
  /** GMO自動売上(次月以降)決済ステータス */
  gmoRecurringPaymentStatus?: Maybe<Scalars['String']>;
  /** 決済ID */
  id: Scalars['ID'];
  /** 申込番号 */
  orderId?: Maybe<Scalars['String']>;
  /** 決済番号 */
  payInfoNo?: Maybe<Scalars['String']>;
  /** 決済方法 */
  payService?: Maybe<Scalars['Int']>;
  /**
   * 決済ステータス
   * ※ PaymentStatus の値が int なので
   */
  paymentStatus?: Maybe<Scalars['Int']>;
  /** プラン名 */
  planName?: Maybe<Scalars['String']>;
  /** 売上金額(税込) */
  priceValue?: Maybe<Scalars['Int']>;
  /** 売上金額(税抜) */
  priceValueNoTax?: Maybe<Scalars['Int']>;
  /** 決済年月日 */
  soldDateTime?: Maybe<Scalars['DateTime']>;
  /** 申込年月日 */
  submittedAt?: Maybe<Scalars['DateTime']>;
  /**
   * 課金種別
   * ※ PaymentType の値が enum と大文字小文字が違うので
   */
  typename?: Maybe<Scalars['String']>;
};

/** 決済トランザクション */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  /** 課金タイミング区分 */
  accountTimingKbn?: Maybe<PaymentAccountTimingKbn>;
  /** 継続課金ID */
  continueAccountId: Scalars['String'];
  /** 継続課金の毎月の支払日 */
  firstPaymentDate?: Maybe<Scalars['DateTime']>;
  /** 決済トランザクションID */
  id: Scalars['ID'];
  /** 注文 */
  order: Order;
  /** 継続課金の毎月の支払日 */
  paymentDay?: Maybe<Scalars['Int']>;
  /** 継続課金の毎月の支払日 */
  paymtd?: Maybe<Paymtd>;
  /** 継続課金の毎月の支払日 */
  price: Price;
};

export { PaymentTransactionStatus };

export { PaymentType };

/** 決済一覧（CSV ダウンロード用） */
export type Payments = {
  __typename?: 'Payments';
  nodes: Array<PaymentSummary>;
  totalCount: Scalars['Int'];
};

export type PaymentsFilterInput = {
  /** コンテンツ名orシステムID（コンテンツ） */
  contentName?: InputMaybe<Scalars['String']>;
  /** コース名orシステムID（コース） */
  courseName?: InputMaybe<Scalars['String']>;
  /** 氏名 */
  customerName?: InputMaybe<Scalars['String']>;
  /** フリガナ */
  customerNameKana?: InputMaybe<Scalars['String']>;
  /**
   * GMO初月決済ステータス
   * ※ GmoFirstPaymentStatuses の値が String 型のため
   */
  gmoFirstPaymentStatuses?: InputMaybe<Array<Scalars['String']>>;
  /**
   * GMO自動売上(次月以降)決済ステータス
   * ※ GmoFirstPaymentStatuses の値が String 型のため
   */
  gmoRecurringPaymentStatuses?: InputMaybe<Array<Scalars['String']>>;
  /** 会員ID(メールアドレス) */
  memberId?: InputMaybe<Scalars['String']>;
  /** 申込年月日(開始) */
  orderFrom?: InputMaybe<Scalars['String']>;
  /** フリガナ */
  orderId?: InputMaybe<Scalars['String']>;
  /** 申込年月日(終了) */
  orderTo?: InputMaybe<Scalars['String']>;
  /** 決済年月日(開始) */
  paymentFrom?: InputMaybe<Scalars['String']>;
  /**
   * 決済方法
   * ※ PaymentServices の値が int 型のため
   */
  paymentServices?: InputMaybe<Array<Scalars['Int']>>;
  /**
   * かんたん決済ステータス
   * ※ PaymentStatuses の値が int 型のため
   */
  paymentStatuses?: InputMaybe<Array<Scalars['Int']>>;
  /** 決済年月日(終了) */
  paymentTo?: InputMaybe<Scalars['String']>;
  /** プランIDのリスト */
  planIds?: InputMaybe<Array<Scalars['String']>>;
};

/** 決済一覧（画面表示用 ＝ 個人情報を除外） */
export type PaymentsForDisplay = {
  __typename?: 'PaymentsForDisplay';
  nodes: Array<PaymentSummaryForDisplay>;
  totalCount: Scalars['Int'];
};

export enum Paymtd {
  /** auPAY残高 */
  AuPay = 'AuPay',
  /** auPAYカード */
  AuPayCard = 'AuPayCard',
  /** 通信料金合算 */
  Combined = 'Combined',
  /** クレジット・カード */
  Credit = 'Credit',
  /** WebMoney */
  WebMoney = 'WebMoney'
}

/** 月額プラン */
export type Plan = {
  __typename?: 'Plan';
  /** プランid */
  id: Scalars['ID'];
  /** プラン名 */
  name: Scalars['String'];
  /** 価格 */
  price: Price;
};

/** 署名付URL発行：content,course,userで使用 */
export type PresignedPostResult = {
  __typename?: 'PresignedPostResult';
  fields: Scalars['JSONObject'];
  url: Scalars['URL'];
};

/** Price */
export type Price = {
  __typename?: 'Price';
  /** 月額の初月金額(税込) */
  initialValue?: Maybe<Scalars['Int']>;
  /** 月額の初月金額(税抜) */
  initialValueNoTax?: Maybe<Scalars['Int']>;
  /** 料金の種類 */
  type: PriceType;
  /** 金額または次月以降金額(税込) */
  value?: Maybe<Scalars['Int']>;
  /** 金額または次月以降金額(税抜) */
  valueNoTax?: Maybe<Scalars['Int']>;
};

/** Priceの登録 */
export type PriceInput = {
  /** 月額の初月金額(税抜) */
  initialValueNoTax?: InputMaybe<Scalars['Int']>;
  /** 料金の種類 */
  type: PriceType;
  /** 金額または次月以降金額(税抜) */
  valueNoTax?: InputMaybe<Scalars['Int']>;
};

export { PriceType };

/**
 * プロダクトの種類
 * コンテンツ OR コース
 */
export enum ProductType {
  Content = 'content',
  Course = 'course'
}

/**
 * プロフィールの更新
 * ※ UserInputからstatus,roleIdsを除いたもの
 */
export type ProfileInput = {
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['String']>;
  /** 出身国 */
  birthplace?: InputMaybe<Scalars['String']>;
  /** メールアドレス */
  email: Scalars['EmailAddress'];
  /** 姓のフリガナ */
  familyNameKana?: InputMaybe<Scalars['String']>;
  /** 性別 */
  gender: Gender;
  /** 名のフリガナ */
  givenNameKana?: InputMaybe<Scalars['String']>;
  /** 趣味 */
  hobby?: InputMaybe<Scalars['String']>;
  /** 従業員システムID */
  id: Scalars['ID'];
  /** メッセージ */
  message?: InputMaybe<Scalars['String']>;
  /** 自己紹介 */
  selfIntroduction?: InputMaybe<Scalars['String']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
  /** 教師歴 */
  yearsOfTeaching?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /** 有効なマスタ「カテゴリ（科目）」を全件取得 */
  activeSubjects: Subjects;
  /** 特定のお知らせ項目の取得 */
  announcement: Announcement;
  /** お知らせ項目のリスト取得 */
  announcements: Announcements;
  /** 一度でもアンケートの回答があったコース一覧の取得 */
  answeredCourses: Courses;
  /** 月額会員一覧取得 */
  billingCustomers: BillingCustomers;
  /** コースオーソリ取消の実行状況を取得 */
  cancelAuthorizedCourseExecutionStatus: CancelAuthorizedCourseExecutionStatus;
  /** コース売上取消の実行状況を取得 */
  cancelSoldCourseExecutionStatus: CancelSoldCourseExecutionStatus;
  /** クラス取得 */
  clazz: Clazz;
  /** 継続課金の不整合一覧の取得 */
  contBillPaymentMismatches: ContBillPaymentMismatches;
  /** 特定のお問い合わせの取得 */
  contact: Contact;
  /** 問い合わせ項目のリスト取得 */
  contactCategories: Array<ContactCategory>;
  /** 問い合わせ一覧の取得（CSVダウンロード用） */
  contacts: Contacts;
  /** 問い合わせ一覧の取得（画面表示用＝個人情報は除外） */
  contactsForDisplay: ContactsForDisplay;
  /** 法人CSVアップロード履歴の取得 */
  corporationCsvUploadHistory: CorporationCsvUploadHistoryResult;
  /** 特定のコースの取得 */
  course: Course;
  /** コース一覧の取得 */
  courses: Courses;
  /** 特定の会員情報の取得 */
  customer: Customer;
  /** 会員一覧取得（CSV ダウンロード用） */
  customers: Customers;
  /** 会員一覧取得（画面表示用 ＝ 個人情報を除外） */
  customersForDisplay: CustomersForDisplay;
  /** 割引詳細取得 */
  discount: Discount;
  /**
   * 割引詳細取得 by コード
   * ※ 重複チェック
   */
  discountByCode?: Maybe<Discount>;
  /** コース限定クーポンに紐づくコース・リスト */
  discountCourses: Array<DiscountCourse>;
  /** 割引リスト取得 */
  discounts: Discounts;
  /** 指定のユーザーIDがいるかどうか */
  existUser: Scalars['Boolean'];
  /** 特定の有識者を取得する */
  expert: Expert;
  /** 有識者の一覧を取得する */
  experts: Experts;
  /** 注目の動画一覧を取得する */
  featuredVideos: Array<FeaturedVideo>;
  /** マスタ「分野」一覧の取得 */
  fields: Fields;
  hasAdminAuthority: Scalars['Boolean'];
  isLoggedIn?: Maybe<Scalars['Boolean']>;
  /** レッスン取得 */
  lesson: Lesson;
  /** 授業一覧取得 */
  lessons: Lessons;
  /** マスタ「レベル」一覧の取得 */
  levels: Levels;
  /** クーポンの最大割引額を取得 */
  maximumDiscountAmount: Scalars['Int'];
  /** ログインしているユーザーの情報を取得 */
  me: User;
  /** 不整合情報に紐づく対応履歴の取得 */
  mismatchHandlingHistories?: Maybe<Array<MismatchHandlingHistory>>;
  /** マスタ「事業者」一覧の取得 */
  organizers: Organizers;
  /** 参加者一覧取得 */
  participants: Participants;
  /** 決済詳細取得 */
  payment: Payment;
  /** 不整合詳細の取得 */
  paymentMismatch: PaymentMismatch;
  /** 不整合が発生した際の該当するかんたん決済csvデータの取得 */
  paymentMismatchCsv?: Maybe<Array<PaymentMismatchCsv>>;
  /** 不整合一覧の取得 */
  paymentMismatches: PaymentMismatches;
  /** 決済一覧取得（CSV ダウンロード用） */
  payments: Payments;
  /** 決済一覧取得（画面表示用 ＝ 個人情報を除外） */
  paymentsForDisplay: PaymentsForDisplay;
  /** プランの一覧を取得する */
  plans: Array<Plan>;
  /** 公開中のコース一覧の取得 */
  publishedCourses: Courses;
  /** コースIDに紐づくアンケートの回答一覧を取得 */
  questionnaireAnswers: QuestionnaireAnswers;
  /** サービス種別一覧を取得するクエリ */
  services: Array<Service>;
  /** マスタ「カテゴリ（科目）」一覧の取得 */
  subjects: Subjects;
  /** 教師一覧を取得 */
  teachers: Users;
  /** 法人CSVアップロードの結果確認 */
  uploadCorporationCsvCheckResult: UploadCorporationCsvCheckResult;
  /** 特定の教師/スタッフ/管理者を取得 */
  user: User;
  /** 教師/スタッフ/管理者一覧を取得 */
  users: Users;
  /** 特定のVideoLessonを取得する */
  videoLesson: VideoLesson;
  /** 社会人動画受講後アンケートの詳細一覧を取得する */
  videoLessonRatingDetails: VideoLessonRatingDetails;
  /** 社会人動画受講後アンケートのサマリーを取得する */
  videoLessonRatingSummaries: VideoLessonRatingSummaries;
  /** マスタ「動画タグ」一覧の取得 */
  videoTags: VideoTags;
};


export type QueryAnnouncementArgs = {
  id: Scalars['ID'];
};


export type QueryAnnouncementsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAnsweredCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBillingCustomersArgs = {
  filter?: InputMaybe<BillingCustomerFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCancelAuthorizedCourseExecutionStatusArgs = {
  executionARN: Scalars['String'];
};


export type QueryCancelSoldCourseExecutionStatusArgs = {
  executionARN: Scalars['String'];
};


export type QueryClazzArgs = {
  id: Scalars['ID'];
};


export type QueryContBillPaymentMismatchesArgs = {
  filter?: InputMaybe<ContBillPaymentMismatchesFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryContactArgs = {
  id: Scalars['ID'];
};


export type QueryContactsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryContactsForDisplayArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCorporationCsvUploadHistoryArgs = {
  filter?: InputMaybe<CorporationCsvUploadHistoryFilterInput>;
  page: Scalars['Int'];
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
};


export type QueryCoursesArgs = {
  filter?: InputMaybe<CoursesFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomersForDisplayArgs = {
  filter?: InputMaybe<CustomerFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryDiscountArgs = {
  id: Scalars['ID'];
};


export type QueryDiscountByCodeArgs = {
  code: Scalars['String'];
};


export type QueryDiscountCoursesArgs = {
  discountId: Scalars['ID'];
};


export type QueryDiscountsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryExistUserArgs = {
  userId: Scalars['String'];
};


export type QueryExpertArgs = {
  id: Scalars['ID'];
};


export type QueryExpertsArgs = {
  filter?: InputMaybe<ExpertsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFieldsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryLessonArgs = {
  id: Scalars['ID'];
};


export type QueryLessonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryLevelsArgs = {
  filter?: InputMaybe<LevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMaximumDiscountAmountArgs = {
  serviceKindId: Scalars['String'];
};


export type QueryMismatchHandlingHistoriesArgs = {
  paymentMismatchId: Scalars['String'];
};


export type QueryOrganizersArgs = {
  filter?: InputMaybe<OrganizerFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryParticipantsArgs = {
  lessonId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentArgs = {
  input: PaymentInput;
};


export type QueryPaymentMismatchArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentMismatchCsvArgs = {
  paymentMismatchId: Scalars['String'];
};


export type QueryPaymentMismatchesArgs = {
  filter?: InputMaybe<PaymentMismatchesFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentsArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentsForDisplayArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQuestionnaireAnswersArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTeachersArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryUploadCorporationCsvCheckResultArgs = {
  corporationCsvId: Scalars['String'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryVideoLessonArgs = {
  id: Scalars['ID'];
};


export type QueryVideoTagsArgs = {
  filter?: InputMaybe<VideoTagFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** アンケート */
export type Questionnaire = {
  __typename?: 'Questionnaire';
  /** 選択条件 */
  condition?: Maybe<SelectableOptionConditionType>;
  /** アンケートID */
  id: Scalars['ID'];
  /** 最大値のラベル */
  maxLabel?: Maybe<Scalars['String']>;
  /** メモリの最大値 */
  maxScale?: Maybe<Scalars['Int']>;
  /** 最小値のラベル */
  minLabel?: Maybe<Scalars['String']>;
  /** アンケートオプション */
  options?: Maybe<Array<QuestionnaireOption>>;
  /** アンケートの順番 */
  order: Scalars['Int'];
  /** アンケート項目が必須か否か */
  required: Scalars['Boolean'];
  /** 複数選択できる数 */
  selectableNumber?: Maybe<Scalars['Int']>;
  /** アンケート項目のタイトル */
  title: Scalars['String'];
  /**
   * アンケート項目の種類
   * ※ QuestionnaireType の値と異なるケースがあるためString（FreeTextQuestionnaire）
   */
  typename: Scalars['String'];
};

/** アンケートの情報と回答者情報 */
export type QuestionnaireAnswer = {
  __typename?: 'QuestionnaireAnswer';
  /** アンケートの回答 */
  answers?: Maybe<Array<Answer>>;
  /** クラス情報 ※将来的にコンテンツが増えるかもしれないので必須にしない */
  clazz?: Maybe<Clazz>;
  /** コース情報 ※将来的にコンテンツが増えるかもしれないので必須にしない */
  course?: Maybe<Course>;
  /** 会員情報 */
  customer: Customer;
  /** オーダーID※CSV出力には利用しないが、行の識別子として取得。 */
  orderId: Scalars['ID'];
  /** 申込年月日（購入日時） ※回答しているのでNULLはないはずだが、DB上はありえるので許容。 */
  submittedAt?: Maybe<Scalars['DateTime']>;
};

/** アンケートの回答一覧 */
export type QuestionnaireAnswers = {
  __typename?: 'QuestionnaireAnswers';
  nodes: Array<QuestionnaireAnswer>;
  totalCount: Scalars['Int'];
};

/** アンケートオプション */
export type QuestionnaireOption = {
  __typename?: 'QuestionnaireOption';
  /** アンケートオプションID */
  id: Scalars['ID'];
  /** アンケートオプション表示名 */
  name: Scalars['String'];
};

/** アンケートオプションの登録 */
export type QuestionnaireOptionInput = {
  /** アンケートオプション表示名 */
  name: Scalars['String'];
};

/** アンケート項目の種類 */
export enum QuestionnaireType {
  /** 自由記述 */
  FreeTextQuestionnaire = 'FreeTextQuestionnaire',
  /** 均等メモリ */
  LinearScaleQuestionnaire = 'LinearScaleQuestionnaire',
  /** 複数選択項目 */
  MultiSelectQuestionnaire = 'MultiSelectQuestionnaire',
  /** 自由記述（DB用。TABLE定義の関係上、自由記述のtypenameがQuestionnaireに変換されてしまうため。） */
  Questionnaire = 'Questionnaire',
  /** 選択項目 */
  SelectQuestionnaire = 'SelectQuestionnaire'
}

export type Receipt = {
  __typename?: 'Receipt';
  /** ダウンロード期限 */
  expiredAt: Scalars['DateTime'];
  /** ダウンロード履歴 */
  history: Array<ReceiptHistory>;
};

export type ReceiptHistory = {
  __typename?: 'ReceiptHistory';
  /** id */
  id: Scalars['ID'];
  /** 領収書発行日時 */
  issuedAt: Scalars['DateTime'];
  /** 発行回数 */
  revision: Scalars['Int'];
  /** ダウンロードURL */
  url: Scalars['URL'];
};

/** ロール */
export type Role = {
  __typename?: 'Role';
  /** デフォルトロールかどうか */
  defaultValue: Scalars['Boolean'];
  /** ロールの説明 */
  description: Scalars['String'];
  /** ロールID */
  id: Scalars['ID'];
  /** ロール名 */
  name: Scalars['String'];
};

/** アンケート選択項目条件 */
export enum SelectableOptionConditionType {
  /** 等しい */
  Equal = 'equal',
  /** 以下 */
  LessThanOrEqual = 'lessThanOrEqual'
}

export type Service = {
  __typename?: 'Service';
  /** id */
  id: Scalars['ID'];
  /** key */
  key: ServiceKind;
  /** サービス名 */
  name: Scalars['String'];
  /** サービス省略名(AEON, 社会人, 小学生) */
  shortName: Scalars['String'];
};

export enum ServiceKind {
  /** STUDYPF */
  Aeon = 'Aeon',
  /** 共創事業 */
  AuEnglish = 'AuEnglish',
  /** KANOPUS トライアル */
  ElementarySchool = 'ElementarySchool',
  /** 社会人 */
  LiberalArts = 'LiberalArts'
}

export type StartCancelAuthorizedCourseResult = {
  __typename?: 'StartCancelAuthorizedCourseResult';
  executionARN?: Maybe<Scalars['String']>;
  failedReason?: Maybe<StepFunctionsCannotStartReason>;
};

export type StartCancelSoldCourseResult = {
  __typename?: 'StartCancelSoldCourseResult';
  executionARN?: Maybe<Scalars['String']>;
  failedReason?: Maybe<StepFunctionsCannotStartReason>;
};

/** 決済関連のStep Functionsを実行できない理由 */
export enum StepFunctionsCannotStartReason {
  /** 売上確定バッチ処理の終了を待つ必要がある */
  NeedToWaitSettleSeminarBatch = 'NeedToWaitSettleSeminarBatch'
}

export enum StepFunctionsExecutionStatus {
  /** 中断 */
  Aborted = 'ABORTED',
  /** 失敗 */
  Failed = 'FAILED',
  /** 実行中 */
  Running = 'RUNNING',
  /** 成功 */
  Succeeded = 'SUCCEEDED',
  /** タイムアウト */
  TimedOut = 'TIMED_OUT'
}

/** マスタ「カテゴリ（科目）」 */
export type Subject = {
  __typename?: 'Subject';
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
  /** 並び順 */
  order: Scalars['Int'];
  /** ステータス */
  status: Scalars['Boolean'];
  /** システムID */
  systemId: Scalars['String'];
};

export type SubjectFilterInput = {
  /** ステータスがアクティブかどうか */
  active?: InputMaybe<Scalars['Boolean']>;
  /** 検索テキスト */
  searchWord?: InputMaybe<Scalars['String']>;
};

/** マスタ「カテゴリ（科目）」一覧 */
export type Subjects = {
  __typename?: 'Subjects';
  nodes: Array<Subject>;
  totalCount: Scalars['Int'];
};

/** 規約 */
export type Terms = {
  __typename?: 'Terms';
  /** 規約キー */
  key: Scalars['String'];
  /** 規約名 */
  name: Scalars['String'];
  /** バージョン */
  version: Scalars['String'];
};

/** お知らせ情報の登録 */
export type UpdateAnnouncementInput = {
  /** 本文 */
  body: Scalars['String'];
  /** お知らせID */
  id: Scalars['ID'];
  /** 種別（お知らせ、メンテナンス、キャンペーン） */
  kind: Scalars['String'];
  /** 公開終了日時 */
  publishEndedAt: Scalars['DateTime'];
  /** 公開開始日時 */
  publishStartedAt: Scalars['DateTime'];
  /** 件名 */
  subject: Scalars['String'];
};

/** マスタ「au英語の分野」更新 input */
export type UpdateAuVideoCategoryInput = {
  /** id */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
};

/** au英語の動画更新の入力 */
export type UpdateAuVideoInput = {
  /** 分野（カテゴリー） */
  categoryIds: Array<Scalars['String']>;
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** id */
  id: Scalars['ID'];
  /** JStreamのID */
  jStreamMId: Scalars['String'];
  /** レベル */
  levelId?: InputMaybe<Scalars['String']>;
  /** 動画名 */
  name: Scalars['String'];
  /** どのplanに紐づくか */
  planId?: InputMaybe<Scalars['String']>;
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
};

/** マスタ「au英語レベル」更新 input */
export type UpdateAuVideoLevelInput = {
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
};

/** au英語の動画の並び順更新 input */
export type UpdateAuVideoOrdersInput = {
  /** ID */
  ids: Array<Scalars['ID']>;
};

/** 複数のau英語動画の更新入力の分野を更新する際に選択できる項目 */
export enum UpdateAuVideosCategoryOption {
  /** 更新しない */
  NoChange = 'NoChange'
}

/** 複数のau英語動画の更新入力 */
export type UpdateAuVideosInput = {
  /**
   * 分野（カテゴリー）
   * 変更しない場合は `UpdateAuVideosCategoryOption.NoChange` を指定する。
   * カテゴリとの紐付けを解除する場合は `null` を指定する。
   *
   * e.g. 第一分野を変更せずに、第二分野をid=2に変更し、第三分野を削除するケース
   * categoryIds=[NoChange, "2", null]
   */
  categoryIds: Array<InputMaybe<Scalars['String']>>;
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** 更新するau英語動画のidの配列 */
  ids: Array<Scalars['ID']>;
  /** レベル */
  levelId?: InputMaybe<Scalars['String']>;
  /**
   * どのPlanに紐づくか。
   * 値がnullの場合は更新せず、プランに紐づかない動画に更新する場合は`null`を配列の要素に指定する。
   * プランを更新しない場合：planIds: null
   * プランに紐付かない動画に更新する場合：planIds: [null]
   */
  planIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** 公開開始日時 */
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

/** クラスと授業の更新 */
export type UpdateClassAndLessonsInput = {
  /** 任意に設定できるクラスID */
  anyClassId?: InputMaybe<Scalars['String']>;
  /** 申込者数の表示/非表示 */
  applicantCountVisibility?: InputMaybe<Scalars['Boolean']>;
  /** 定員 */
  capacity?: InputMaybe<Scalars['Int']>;
  /** コースID */
  courseId?: InputMaybe<Scalars['String']>;
  /** 開催場所 */
  eventLocation?: InputMaybe<Scalars['String']>;
  /** クラスID */
  id: Scalars['String'];
  /** 授業一覧 */
  lessons?: InputMaybe<Array<UpdateLessonInput>>;
  /** クラス名 */
  name?: InputMaybe<Scalars['String']>;
  /** 公開設定 */
  published?: InputMaybe<Scalars['Boolean']>;
  /** 販売終了日時 */
  saleEndedAt?: InputMaybe<Scalars['DateTime']>;
  /** 販売開始日時 */
  saleStartedAt?: InputMaybe<Scalars['DateTime']>;
};

/** コース詳細の更新 */
export type UpdateCourseDetailInput = {
  /** コース詳細項目のカテゴリ */
  category: CourseDetailCategory;
  /** コース詳細項目の説明 */
  description: Scalars['String'];
  /** コース詳細項目のID */
  id?: InputMaybe<Scalars['ID']>;
};

/** CourseImageの更新 input */
export type UpdateCourseImageOrdersInput = {
  courseImages: Array<CourseImageOrderInput>;
};

/** コースの更新 */
export type UpdateCourseInput = {
  /** コースID（ユーザー管理用） */
  courseId?: InputMaybe<Scalars['String']>;
  /** コース詳細 */
  details: Array<UpdateCourseDetailInput>;
  /** ID */
  id: Scalars['ID'];
  /** マスタ「カテゴリ（レベル）」ID */
  levelId?: InputMaybe<Scalars['String']>;
  /** コース名 */
  name: Scalars['String'];
  /** マスタ「カテゴリ（事業者）」ID */
  organizerId?: InputMaybe<Scalars['String']>;
  /** コース概要 */
  overview: Scalars['String'];
  /** コース価格 */
  price: CoursePriceInput;
  /** 公開設定 */
  published?: InputMaybe<Scalars['Boolean']>;
  /** アンケート */
  questionnaires?: InputMaybe<Array<CreateQuestionnaireInput>>;
  /** マスタ「カテゴリ（科目）」ID */
  subjectIds?: InputMaybe<Array<Scalars['String']>>;
  /** コースターゲット */
  targets?: InputMaybe<CourseTargetInput>;
  /** コース動画 */
  videos?: InputMaybe<Array<CourseVideoInput>>;
};

/** コースの並び順更新 input */
export type UpdateCourseOrdersInput = {
  /** ID */
  ids: Array<Scalars['ID']>;
};

export type UpdateDiscountInput = {
  /** 説明 */
  description?: InputMaybe<Scalars['String']>;
  /** 有効期限 */
  endedAt?: InputMaybe<Scalars['DateTime']>;
  /** 物理ID */
  id: Scalars['String'];
  /** コース限定クーポンの場合のコースIDリスト */
  limitedCourseIds?: InputMaybe<Array<Scalars['String']>>;
  /** 名前 */
  name?: InputMaybe<Scalars['String']>;
  /** 発効日時 */
  startedAt?: InputMaybe<Scalars['DateTime']>;
  /** 種別 */
  type: DiscountType;
};

/** 有識者更新の入力データ */
export type UpdateExpertInput = {
  /** 詳細ページのパス文字列 */
  alias: Scalars['String'];
  /** 有識者の著作情報 */
  booksListText?: InputMaybe<Scalars['String']>;
  /** 経歴 */
  career?: InputMaybe<Scalars['String']>;
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** 所属 */
  company?: InputMaybe<Scalars['String']>;
  /** 有識者のfacebook URL */
  facebookUrl?: InputMaybe<Scalars['String']>;
  /** 有識者の姓 */
  familyName: Scalars['String'];
  /** 有識者の姓・フリガナ */
  familyNameKana: Scalars['String'];
  /** 有識者の名 */
  givenName: Scalars['String'];
  /** 有識者の名・フリガナ */
  givenNameKana: Scalars['String'];
  /** 有識者ID */
  id: Scalars['ID'];
  /** 有識者のinstagram URL */
  instagramUrl?: InputMaybe<Scalars['String']>;
  /** 役職 */
  position?: InputMaybe<Scalars['String']>;
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** 有識者の公式サイトURL */
  siteUrl?: InputMaybe<Scalars['String']>;
  /** 肩書 */
  title: Scalars['String'];
  /** 有識者のtwitter URL */
  twitterUrl?: InputMaybe<Scalars['String']>;
  /** 有識者のwikipedia URL */
  wikipediaUrl?: InputMaybe<Scalars['String']>;
  /** 有識者のyoutube URL */
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateFeaturedVideoInput = {
  /** 注目の動画名（イベントアクション名） */
  name: Scalars['String'];
  /** 注目の動画の順番 */
  order: Scalars['Int'];
  /** 注目の動画の遷移先 */
  path: Scalars['String'];
};

/** マスタ「分野」更新 input */
export type UpdateFieldInput = {
  /** エイリアス */
  alias: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** 分野名 */
  name: Scalars['String'];
  /** サブタイトル */
  subTitle: Scalars['String'];
  /** 説明文 */
  summary: Scalars['String'];
};

/** 授業の更新 */
export type UpdateLessonInput = {
  /** 任意に設定できる授業ID */
  anyLessonId?: InputMaybe<Scalars['String']>;
  /** 終了日時 */
  endedAt?: InputMaybe<Scalars['DateTime']>;
  /** 授業ID */
  id: Scalars['String'];
  /** 授業マスターID */
  lessonMasterId: Scalars['ID'];
  /** 授業のURL */
  lessonUrl?: InputMaybe<Scalars['String']>;
  /** 開催場所種別 */
  locationType: LocationType;
  /** 開始日時 */
  startedAt?: InputMaybe<Scalars['DateTime']>;
  /** 担当教師ID */
  teacherIds: Array<Scalars['String']>;
};

/** 授業マスターの更新 */
export type UpdateLessonMasterInput = {
  /** 授業IDマスターID */
  id: Scalars['ID'];
  /** 授業名 */
  name: Scalars['String'];
  /** 授業の表示順 */
  order: Scalars['Int'];
};

/** マスタ「レベル」更新 input */
export type UpdateLevelInput = {
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name?: InputMaybe<Scalars['String']>;
  /** ステータス */
  status?: InputMaybe<Scalars['Boolean']>;
};

/** マスタ「事業者」更新 input */
export type UpdateOrganizerInput = {
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
};

export type UpdatePaymentMismatchInput = {
  /** 対応状況 */
  handlingStatus: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
};

/** マスタ「カテゴリ（科目）」更新 input */
export type UpdateSubjectInput = {
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name?: InputMaybe<Scalars['String']>;
  /** ステータス */
  status?: InputMaybe<Scalars['Boolean']>;
};

/** マスタ「カテゴリ（科目）」の並び順更新 input */
export type UpdateSubjectOrdersInput = {
  /** ID */
  ids: Array<Scalars['ID']>;
};

/** 動画編集の入力 */
export type UpdateVideoInput = {
  /** 動画ID */
  id: Scalars['ID'];
  /** J-Streamの動画ID */
  jStreamMId: Scalars['String'];
  /** 動画のタイトル */
  name: Scalars['String'];
  /** 順番 */
  order: Scalars['Int'];
};

/** シリーズ更新の入力 */
export type UpdateVideoLessonInput = {
  /** 詳細ページのパス文字列 */
  alias: Scalars['String'];
  /** 公開終了日時 */
  closedAt?: InputMaybe<Scalars['DateTime']>;
  /** 説明文 */
  description: Scalars['String'];
  /** 分野名 */
  fieldId: Scalars['String'];
  /** シリーズID */
  id: Scalars['ID'];
  /** サンプル動画 */
  jStreamSampleMId: Scalars['String'];
  /** タイトル */
  name: Scalars['String'];
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** カテゴリー */
  videoTagId: Scalars['String'];
  /**
   * 動画。
   * 既存の動画はこの動画と置き換えられます。(このリストに含まれない動画は削除されます。)
   */
  videos: Array<UpdateVideoInput>;
};

/** マスタ「動画タグ」更新 input */
export type UpdateVideoTagInput = {
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name?: InputMaybe<Scalars['String']>;
  /** ステータス */
  status?: InputMaybe<Scalars['Boolean']>;
};

/** 法人CSVアップロード結果確認 */
export type UploadCorporationCsvCheckResult = {
  __typename?: 'UploadCorporationCsvCheckResult';
  /** 処理数 */
  count: Scalars['Int'];
  /** 登録失敗数 */
  failedCount: Scalars['Int'];
  /** ファイル名 */
  fileName: Scalars['String'];
  /** ファイルパス */
  filePath: Scalars['String'];
  /** アップロード結果 */
  uploadResult: UploadResult;
};

export type UploadCorporationCsvInput = {
  csvRows: Array<CorporationCsv>;
  fileName: Scalars['String'];
};

/** 法人CSVアップロード結果 */
export type UploadCorporationCsvResult = {
  __typename?: 'UploadCorporationCsvResult';
  /** 法人csvID */
  corporationCsvId: Scalars['ID'];
};

/** アップロード結果 */
export enum UploadResult {
  /** 失敗 */
  Failed = 'failed',
  /** 一部成功 */
  ParticalSuccess = 'particalSuccess',
  /** 処理中 */
  Processing = 'processing',
  /** 成功 */
  Success = 'success'
}

/** 従業員 */
export type User = {
  __typename?: 'User';
  /** 画像URL */
  avator?: Maybe<Scalars['String']>;
  /** 生年月日 */
  birthday?: Maybe<Scalars['String']>;
  /** 出身国 */
  birthplace?: Maybe<Scalars['String']>;
  currentServiceKind?: Maybe<CurrentServiceKind>;
  /** メールアドレス */
  email: Scalars['EmailAddress'];
  /** 外部講師かどうか */
  extra: Scalars['Boolean'];
  /** 姓 */
  familyName: Scalars['String'];
  /** 姓のフリガナ */
  familyNameKana?: Maybe<Scalars['String']>;
  /** 性別 */
  gender: Gender;
  /** 名 */
  givenName: Scalars['String'];
  /** 名のフリガナ */
  givenNameKana?: Maybe<Scalars['String']>;
  /** 趣味 */
  hobby?: Maybe<Scalars['String']>;
  /** 従業員システムID */
  id: Scalars['ID'];
  /** メッセージ */
  message?: Maybe<Scalars['String']>;
  /** ロール */
  roles: Array<Role>;
  /** 自己紹介 */
  selfIntroduction?: Maybe<Scalars['String']>;
  /** ステータス */
  status: EmployeeStatus;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
  /** サービス別権限 */
  useableServiceKinds: Array<Service>;
  /** 従業員ID */
  userId: Scalars['String'];
  /** 教師歴 */
  yearsOfTeaching?: Maybe<Scalars['Int']>;
};

/** 社会人向け属性情報 */
export type UserAttribute = {
  __typename?: 'UserAttribute';
  /** 年収 */
  annualIncome: Scalars['String'];
  /** 業種 */
  industry: Scalars['String'];
  /** 職種 */
  jobTitle: Scalars['String'];
  /** 職業 */
  occupation: Scalars['String'];
  /** 役職 */
  position: Scalars['String'];
};

export type UserFilterInput = {
  /** 外部講師かどうか */
  extra?: InputMaybe<Scalars['Boolean']>;
  /** 検索テキスト */
  searchWord?: InputMaybe<Scalars['String']>;
};

/** 従業員情報の更新 */
export type UserInput = {
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['String']>;
  /** 出身国 */
  birthplace?: InputMaybe<Scalars['String']>;
  /** メールアドレス */
  email: Scalars['EmailAddress'];
  /** 姓のフリガナ */
  familyNameKana?: InputMaybe<Scalars['String']>;
  /** 性別 */
  gender: Gender;
  /** 名のフリガナ */
  givenNameKana?: InputMaybe<Scalars['String']>;
  /** 趣味 */
  hobby?: InputMaybe<Scalars['String']>;
  /** 従業員システムID */
  id: Scalars['ID'];
  /** メッセージ */
  message?: InputMaybe<Scalars['String']>;
  /** ロール */
  roleIds: Array<Scalars['String']>;
  /** 自己紹介 */
  selfIntroduction?: InputMaybe<Scalars['String']>;
  /** サービス別権限 */
  serviceKindIds: Array<Scalars['ID']>;
  /** ステータス */
  status: EmployeeStatus;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
  /** 教師歴 */
  yearsOfTeaching?: InputMaybe<Scalars['Int']>;
};

/** スタッフ向け顧客情報メモ */
export type UserNote = {
  __typename?: 'UserNote';
  /** 作成日時 */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** メモ */
  note?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** 従業員一覧 */
export type Users = {
  __typename?: 'Users';
  nodes: Array<User>;
  totalCount: Scalars['Int'];
};

/** 動画 */
export type Video = {
  __typename?: 'Video';
  /** 動画ID */
  id: Scalars['ID'];
  /** J-Streamの動画ID */
  jStreamMId: Scalars['String'];
  /** 動画のタイトル */
  name: Scalars['String'];
  /** 順番 */
  order: Scalars['Int'];
};

/**
 * ビデオレッスン。
 * シリーズとも言う。
 */
export type VideoLesson = {
  __typename?: 'VideoLesson';
  /** 詳細ページのパス文字列 */
  alias: Scalars['String'];
  /** 公開終了日時 */
  closedAt?: Maybe<Scalars['DateTime']>;
  /** 説明文 */
  description: Scalars['String'];
  /** 有識者 */
  expert: Expert;
  /** 分野名 */
  field: Field;
  /** LPの分野ラインナップに表示する画像 */
  fieldItemImg?: Maybe<Scalars['URL']>;
  /** レッスンID */
  id: Scalars['ID'];
  /** サンプル動画 */
  jStreamSampleMId: Scalars['String'];
  /** タイトル */
  name: Scalars['String'];
  /** 公開開始日時 */
  publishedAt: Scalars['DateTime'];
  /** カテゴリー */
  videoTag?: Maybe<VideoTag>;
  /** 動画 */
  videos: Array<Video>;
};

/** 動画に対する社会人動画受講後アンケート詳細 */
export type VideoLessonRatingDetail = {
  __typename?: 'VideoLessonRatingDetail';
  /** 回答年月日 */
  createdAt: Scalars['DateTime'];
  /** カスタマー情報 */
  customer: Customer;
  /** 評価コメント */
  freeTextValue?: Maybe<Scalars['String']>;
  /** 社会人動画受講後アンケートID */
  id: Scalars['ID'];
  /** 5段階評価の値 */
  rating: Scalars['Int'];
  /** 対象の動画 */
  video: Video;
  /** 対象のビデオレッスン(シリーズ) */
  videoLesson: VideoLesson;
};

/** 社会人動画受講後アンケート詳細のページネーションタイプ */
export type VideoLessonRatingDetails = {
  __typename?: 'VideoLessonRatingDetails';
  /** 社会人動画受講後アンケート詳細のリスト */
  nodes: Array<VideoLessonRatingDetail>;
  /** アンケート回答の全件数 */
  totalCount: Scalars['Int'];
};

/** 社会人動画受講後アンケートのサマリーのページネーションタイプ */
export type VideoLessonRatingSummaries = {
  __typename?: 'VideoLessonRatingSummaries';
  /** 社会人動画受講後アンケートサマリーのリスト */
  nodes: Array<VideoLessonRatingSummary>;
  /** サマリーの全件数 */
  totalCount: Scalars['Int'];
};

/** VideoLessonに対する社会人動画受講後アンケートサマリー */
export type VideoLessonRatingSummary = {
  __typename?: 'VideoLessonRatingSummary';
  /** ID */
  id: Scalars['ID'];
  /** 評価 */
  rating?: Maybe<Scalars['Float']>;
  /** 対象のVideoLesson */
  videoLesson: VideoLesson;
  /** 動画に対する社会人動画受講後アンケートサマリーのリスト */
  videoRatingSummaries: Array<VideoRatingSummary>;
};

/** 動画に対する社会人動画受講後アンケートサマリー */
export type VideoRatingSummary = {
  __typename?: 'VideoRatingSummary';
  /** ID */
  id: Scalars['ID'];
  /** 評価(平均値) */
  rating?: Maybe<Scalars['Float']>;
  /** 評価数 */
  ratingCount: Scalars['Int'];
  /** 対象の動画 */
  video: Video;
};

/** 動画タグ */
export type VideoTag = {
  __typename?: 'VideoTag';
  /** ID */
  id: Scalars['ID'];
  /** 名前 */
  name: Scalars['String'];
  /** ステータス */
  status: Scalars['Boolean'];
};

/** マスタ「動画タグ」フィルター input */
export type VideoTagFilterInput = {
  /** ステータスがアクティブかどうか */
  active?: InputMaybe<Scalars['Boolean']>;
  /** 検索テキスト */
  searchWord?: InputMaybe<Scalars['String']>;
};

/** マスタ「動画タグ」一覧 */
export type VideoTags = {
  __typename?: 'VideoTags';
  /** 動画タグのリスト */
  nodes: Array<VideoTag>;
  /** 全件数 */
  totalCount: Scalars['Int'];
};

export type IsUserLoggedInQueryVariables = Exact<{ [key: string]: never; }>;


export type IsUserLoggedInQuery = { __typename?: 'Query', isLoggedIn?: boolean | null };

export type CourseSelectorRowFragment = { __typename?: 'Course', id: string, systemId: string, name: string };

export type CoursesForMultiSelectorQueryVariables = Exact<{
  filter?: InputMaybe<CoursesFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CoursesForMultiSelectorQuery = { __typename?: 'Query', courses: { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string }> } };

export type CustomersTableRowFragment = { __typename?: 'Customer', id: string, createdAt: Date, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string } | null };

export type CustomerSearchResultsFragment = { __typename?: 'Customers', totalCount: number, nodes: Array<{ __typename?: 'Customer', id: string, createdAt: Date, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string } | null }> };

export type AvatorFragment = { __typename?: 'User', familyName: string, givenName: string };

export type UseableSerivceFragment = { __typename?: 'Service', id: string, name: string, key: ServiceKind, shortName: string };

export type MeFragment = { __typename?: 'User', familyName: string, givenName: string, useableServiceKinds: Array<{ __typename?: 'Service', id: string, name: string, key: ServiceKind, shortName: string }>, currentServiceKind?: { __typename?: 'CurrentServiceKind', id: string, key: ServiceKind } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', familyName: string, givenName: string, useableServiceKinds: Array<{ __typename?: 'Service', id: string, name: string, key: ServiceKind, shortName: string }>, currentServiceKind?: { __typename?: 'CurrentServiceKind', id: string, key: ServiceKind } | null } };

export type LevelFragment = { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean };

export type LevelsResultFragment = { __typename?: 'Levels', totalCount: number, nodes: Array<{ __typename?: 'Level', id: string, systemId: string, name: string, status: boolean }> };

export type LevelsQueryVariables = Exact<{
  filter?: InputMaybe<LevelFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LevelsQuery = { __typename?: 'Query', levels: { __typename?: 'Levels', totalCount: number, nodes: Array<{ __typename?: 'Level', id: string, systemId: string, name: string, status: boolean }> } };

export type OrganizerFragment = { __typename?: 'Organizer', id: string, name: string };

export type OrganizersResultFragment = { __typename?: 'Organizers', totalCount: number, nodes: Array<{ __typename?: 'Organizer', id: string, name: string }> };

export type OrganizersQueryVariables = Exact<{
  filter?: InputMaybe<OrganizerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type OrganizersQuery = { __typename?: 'Query', organizers: { __typename?: 'Organizers', totalCount: number, nodes: Array<{ __typename?: 'Organizer', id: string, name: string }> } };

export type SubjectSelectorItemFragment = { __typename?: 'Subject', id: string, name: string, status: boolean };

export type UserDetailFragment = { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> };

export type AnnouncementPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AnnouncementPageQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', id: string, systemId: string, kind: string, subject: string, body: string, publishStartedAt: Date, publishEndedAt: Date } };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: UpdateAnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement: { __typename?: 'Announcement', id: string } };

export type AnnouncementForEditPageFragment = { __typename?: 'Announcement', id: string, systemId: string, kind: string, publishStartedAt: Date, publishEndedAt: Date, subject: string, body: string, published: boolean };

export type AnnouncementsEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AnnouncementsEditPageQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', id: string, systemId: string, kind: string, publishStartedAt: Date, publishEndedAt: Date, subject: string, body: string, published: boolean } };

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: { __typename?: 'Announcement', id: string } };

export type AnnouncementsTableRowFragment = { __typename?: 'Announcement', id: string, systemId: string, kind: string, subject: string, published: boolean };

export type AnnouncementsFragment = { __typename?: 'Announcements', totalCount: number, nodes: Array<{ __typename?: 'Announcement', id: string, systemId: string, kind: string, subject: string, published: boolean }> };

export type AnnouncementsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AnnouncementsQuery = { __typename?: 'Query', announcements: { __typename?: 'Announcements', totalCount: number, nodes: Array<{ __typename?: 'Announcement', id: string, systemId: string, kind: string, subject: string, published: boolean }> } };

export type CategoriesDnDTableItemFragment = { __typename?: 'Subject', id: string, systemId: string, name: string, order: number };

export type UpdateSubjectOrdersMutationVariables = Exact<{
  input: UpdateSubjectOrdersInput;
}>;


export type UpdateSubjectOrdersMutation = { __typename?: 'Mutation', updateSubjectOrders: Array<{ __typename?: 'Subject', id: string, order: number }> };

export type CategoriesSortPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesSortPageQuery = { __typename?: 'Query', activeSubjects: { __typename?: 'Subjects', totalCount: number, nodes: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, order: number }> } };

export type ClassUpdateResultFragment = { __typename?: 'Clazz', id: string, systemId: string, course?: { __typename?: 'Course', published: boolean } | null };

export type UpdateClassAndLessonsMutationVariables = Exact<{
  input: UpdateClassAndLessonsInput;
}>;


export type UpdateClassAndLessonsMutation = { __typename?: 'Mutation', updateClassAndLessons?: { __typename?: 'Clazz', id: string, systemId: string, course?: { __typename?: 'Course', published: boolean } | null } | null };

export type ClassForEditPageFragment = { __typename?: 'Clazz', id: string, anyClassId?: string | null, systemId: string, courseId: string, published?: boolean | null, name: string, capacity: number, applicantCountVisibility: boolean, eventLocation: string, course?: { __typename?: 'Course', systemId: string, name: string } | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, anyLessonId?: string | null, lessonUrl?: string | null, startedAt: Date, endedAt: Date, participantsCount: number, teachers: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, extra: boolean }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null };

export type ClassEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClassEditPageQuery = { __typename?: 'Query', clazz: { __typename?: 'Clazz', id: string, anyClassId?: string | null, systemId: string, courseId: string, published?: boolean | null, name: string, capacity: number, applicantCountVisibility: boolean, eventLocation: string, course?: { __typename?: 'Course', systemId: string, name: string } | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, anyLessonId?: string | null, lessonUrl?: string | null, startedAt: Date, endedAt: Date, participantsCount: number, teachers: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, extra: boolean }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null } };

export type ClassNewResultFragment = { __typename?: 'Clazz', id: string, systemId: string };

export type CreateClassAndLessonsMutationVariables = Exact<{
  input: CreateClassAndLessonsInput;
}>;


export type CreateClassAndLessonsMutation = { __typename?: 'Mutation', createClassAndLessons?: { __typename?: 'Clazz', id: string, systemId: string } | null };

export type CourseForCreatingClassFragment = { __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, name: string, order: number }> | null };

export type TeachersTableRowFragment = { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, status: EmployeeStatus, extra: boolean, roles: Array<{ __typename?: 'Role', name: string }> };

export type TeachersTableFragment = { __typename?: 'Users', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, status: EmployeeStatus, extra: boolean, roles: Array<{ __typename?: 'Role', name: string }> }> };

export type CourseForCreatingClassQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseForCreatingClassQuery = { __typename?: 'Query', course: { __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, name: string, order: number }> | null } };

export type TeachersQueryVariables = Exact<{
  filter?: InputMaybe<FilterInput>;
}>;


export type TeachersQuery = { __typename?: 'Query', teachers: { __typename?: 'Users', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, status: EmployeeStatus, extra: boolean, roles: Array<{ __typename?: 'Role', name: string }> }> } };

export type ClazzDetailFragment = { __typename?: 'Clazz', id: string, systemId: string, courseId: string, anyClassId?: string | null, name: string, eventLocation: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, course?: { __typename?: 'Course', name: string } | null, lessons?: Array<{ __typename?: 'Lesson', id: string, anyLessonId?: string | null, participantsCount: number, lessonUrl?: string | null, startedAt: Date, endedAt: Date, teachers: Array<{ __typename?: 'User', givenName: string, familyName: string }>, lessonMaster: { __typename?: 'LessonMaster', name: string, order: number, id: string } }> | null };

export type DeleteClazzAndLessonsMutationVariables = Exact<{
  input: DeleteClassAndLessonsInput;
}>;


export type DeleteClazzAndLessonsMutation = { __typename?: 'Mutation', deleteClassAndLessons: boolean };

export type ClazzQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClazzQuery = { __typename?: 'Query', clazz: { __typename?: 'Clazz', id: string, systemId: string, courseId: string, anyClassId?: string | null, name: string, eventLocation: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, course?: { __typename?: 'Course', name: string } | null, lessons?: Array<{ __typename?: 'Lesson', id: string, anyLessonId?: string | null, participantsCount: number, lessonUrl?: string | null, startedAt: Date, endedAt: Date, teachers: Array<{ __typename?: 'User', givenName: string, familyName: string }>, lessonMaster: { __typename?: 'LessonMaster', name: string, order: number, id: string } }> | null } };

export type ContactPageFragment = { __typename?: 'Contact', id: string, systemId: string, content?: string | null, route: ContactRoute, createdAt: Date, serviceKind: ServiceKind, category: { __typename?: 'ContactCategory', id: string, value: string }, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string } | null } | null, address?: { __typename?: 'ContactAddress', id: string, familyName?: string | null, givenName?: string | null, familyNameKana?: string | null, givenNameKana?: string | null, email?: string | null, tel?: string | null } | null, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, oldServiceKind?: ServiceKind | null, serviceKind?: ServiceKind | null, memo?: string | null, supporterId?: string | null, supporterEmail?: string | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null };

export type DeleteContactPageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContactPageMutation = { __typename?: 'Mutation', deleteContactLogically: boolean };

export type ContactPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactPageQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string, systemId: string, content?: string | null, route: ContactRoute, createdAt: Date, serviceKind: ServiceKind, category: { __typename?: 'ContactCategory', id: string, value: string }, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string } | null } | null, address?: { __typename?: 'ContactAddress', id: string, familyName?: string | null, givenName?: string | null, familyNameKana?: string | null, givenNameKana?: string | null, email?: string | null, tel?: string | null } | null, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, oldServiceKind?: ServiceKind | null, serviceKind?: ServiceKind | null, memo?: string | null, supporterId?: string | null, supporterEmail?: string | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null }, services: Array<{ __typename?: 'Service', id: string, key: ServiceKind, shortName: string }> };

export type ContactCategoryFragment = { __typename?: 'ContactCategory', id: string, value: string };

export type CreateContactResultFragment = { __typename?: 'Contact', id: string };

export type CreateContactHistoryResultFragment = { __typename?: 'ContactHistory', id: string };

export type ContactServiceInputFragment = { __typename?: 'Service', id: string, key: ServiceKind, shortName: string };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string } };

export type CreateContactHistoryMutationVariables = Exact<{
  input: CreateContactHistoryInput;
}>;


export type CreateContactHistoryMutation = { __typename?: 'Mutation', createContactHistory: { __typename?: 'ContactHistory', id: string } };

export type ContactSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactSelectOptionsQuery = { __typename?: 'Query', contactCategories: Array<{ __typename?: 'ContactCategory', id: string, value: string }>, services: Array<{ __typename?: 'Service', id: string, key: ServiceKind, shortName: string }> };

export type CustomerSearchResultsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerSearchResultsQuery = { __typename?: 'Query', hasAdminAuthority: boolean, customers: { __typename?: 'Customers', totalCount: number, nodes: Array<{ __typename?: 'Customer', id: string, createdAt: Date, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string } | null }> } };

export type ContactsTableRowFragment = { __typename?: 'ContactForDisplay', id: string, systemId: string, route: ContactRoute, content?: string | null, customerId?: string | null, createdAt: Date, category: { __typename?: 'ContactCategory', id: string, value: string }, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null };

export type ContactsCsvRowFragment = { __typename?: 'Contact', id: string, systemId: string, route: ContactRoute, content?: string | null, createdAt: Date, category: { __typename?: 'ContactCategory', id: string, value: string }, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string } | null } | null, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null, address?: { __typename?: 'ContactAddress', id: string, familyName?: string | null, givenName?: string | null } | null };

export type ContactsFragment = { __typename?: 'ContactsForDisplay', totalCount: number, nodes: Array<{ __typename?: 'ContactForDisplay', id: string, systemId: string, route: ContactRoute, content?: string | null, customerId?: string | null, createdAt: Date, category: { __typename?: 'ContactCategory', id: string, value: string }, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null }> };

export type ContactCsvDownloadsFragment = { __typename?: 'Contacts', totalCount: number, nodes: Array<{ __typename?: 'Contact', id: string, systemId: string, route: ContactRoute, content?: string | null, createdAt: Date, category: { __typename?: 'ContactCategory', id: string, value: string }, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string } | null } | null, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null, address?: { __typename?: 'ContactAddress', id: string, familyName?: string | null, givenName?: string | null } | null }> };

export type ContactsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ContactsQuery = { __typename?: 'Query', hasAdminAuthority: boolean, contactsForDisplay: { __typename?: 'ContactsForDisplay', totalCount: number, nodes: Array<{ __typename?: 'ContactForDisplay', id: string, systemId: string, route: ContactRoute, content?: string | null, customerId?: string | null, createdAt: Date, category: { __typename?: 'ContactCategory', id: string, value: string }, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null }> } };

export type ContactCsvDownloadsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ContactCsvDownloadsQuery = { __typename?: 'Query', contacts: { __typename?: 'Contacts', totalCount: number, nodes: Array<{ __typename?: 'Contact', id: string, systemId: string, route: ContactRoute, content?: string | null, createdAt: Date, category: { __typename?: 'ContactCategory', id: string, value: string }, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string } | null } | null, histories?: Array<{ __typename?: 'ContactHistory', id: string, oldStatus?: ContactStatus | null, status?: ContactStatus | null, supporterFamilyName?: string | null, supporterGivenName?: string | null, createdAt?: Date | null }> | null, address?: { __typename?: 'ContactAddress', id: string, familyName?: string | null, givenName?: string | null } | null }> } };

export type CorporationUploadedCsvFragment = { __typename?: 'CorporationCsvUploadHistoryData', id: string, uploadResult: UploadResult, fileName: string, uploadTime: Date, successesCount: number, failedCount: number, filePath?: string | null };

export type CorporationPageHistoryFragment = { __typename?: 'CorporationCsvUploadHistoryResult', nowPageNum: number, previousPageNum?: number | null, nextPageNum?: number | null, maxPageNum: number, csvData?: Array<{ __typename?: 'CorporationCsvUploadHistoryData', id: string, uploadResult: UploadResult, fileName: string, uploadTime: Date, successesCount: number, failedCount: number, filePath?: string | null }> | null };

export type UploadCorporationCsvMutationVariables = Exact<{
  input: UploadCorporationCsvInput;
}>;


export type UploadCorporationCsvMutation = { __typename?: 'Mutation', uploadCorporationCsv: { __typename?: 'UploadCorporationCsvResult', corporationCsvId: string } };

export type CorporationPageQueryVariables = Exact<{
  page: Scalars['Int'];
  filter?: InputMaybe<CorporationCsvUploadHistoryFilterInput>;
}>;


export type CorporationPageQuery = { __typename?: 'Query', corporationCsvUploadHistory: { __typename?: 'CorporationCsvUploadHistoryResult', nowPageNum: number, previousPageNum?: number | null, nextPageNum?: number | null, maxPageNum: number, csvData?: Array<{ __typename?: 'CorporationCsvUploadHistoryData', id: string, uploadResult: UploadResult, fileName: string, uploadTime: Date, successesCount: number, failedCount: number, filePath?: string | null }> | null } };

export type UploadCorporationCsvCheckResultQueryVariables = Exact<{
  corporationCsvId: Scalars['String'];
}>;


export type UploadCorporationCsvCheckResultQuery = { __typename?: 'Query', uploadCorporationCsvCheckResult: { __typename?: 'UploadCorporationCsvCheckResult', uploadResult: UploadResult, fileName: string, count: number, failedCount: number, filePath: string } };

export type CoursePageFragment = { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, published: boolean, overview: string, organizer?: { __typename?: 'Organizer', id: string, name: string } | null, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, levelEntity?: { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', id: string, name: string, url: string, order: number }> | null, videos?: Array<{ __typename?: 'CourseVideo', id: string, url: string }> | null, details: Array<{ __typename?: 'CourseDetail', id?: string | null, category: CourseDetailCategory, description: string }>, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, order: number, name: string, teachingMaterials?: Array<{ __typename?: 'LessonMasterTeachingMaterial', id: string, name: string, url: string }> | null }> | null, clazzes: Array<{ __typename?: 'Clazz', id: string, systemId: string, courseId: string, name: string, anyClassId?: string | null, eventLocation: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, lessonMasterId: string, clazzId: string, startedAt: Date, endedAt: Date, locationType: LocationType, participantsCount: number, teachers: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, email: string, status: EmployeeStatus, gender: Gender, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string, defaultValue: boolean }> }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null }>, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null };

export type DeleteCourseMutationVariables = Exact<{
  input: DeleteCourseInput;
}>;


export type DeleteCourseMutation = { __typename?: 'Mutation', deleteCourse: boolean };

export type CoursePageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CoursePageQuery = { __typename?: 'Query', course: { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, published: boolean, overview: string, organizer?: { __typename?: 'Organizer', id: string, name: string } | null, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, levelEntity?: { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', id: string, name: string, url: string, order: number }> | null, videos?: Array<{ __typename?: 'CourseVideo', id: string, url: string }> | null, details: Array<{ __typename?: 'CourseDetail', id?: string | null, category: CourseDetailCategory, description: string }>, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, order: number, name: string, teachingMaterials?: Array<{ __typename?: 'LessonMasterTeachingMaterial', id: string, name: string, url: string }> | null }> | null, clazzes: Array<{ __typename?: 'Clazz', id: string, systemId: string, courseId: string, name: string, anyClassId?: string | null, eventLocation: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, lessonMasterId: string, clazzId: string, startedAt: Date, endedAt: Date, locationType: LocationType, participantsCount: number, teachers: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, email: string, status: EmployeeStatus, gender: Gender, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string, description: string, defaultValue: boolean }> }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null }>, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null } };

export type CourseEditConfirmFragment = { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, overview: string, published: boolean, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', url: string }> | null, videos?: Array<{ __typename?: 'CourseVideo', url: string }> | null, details: Array<{ __typename?: 'CourseDetail', category: CourseDetailCategory, description: string }>, lessonMasters?: Array<{ __typename?: 'LessonMaster', order: number, name: string }> | null };

export type UpdateCourseMutationVariables = Exact<{
  input: UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse: { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, overview: string, published: boolean, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', url: string }> | null, videos?: Array<{ __typename?: 'CourseVideo', url: string }> | null, details: Array<{ __typename?: 'CourseDetail', category: CourseDetailCategory, description: string }>, lessonMasters?: Array<{ __typename?: 'LessonMaster', order: number, name: string }> | null } };

export type DeleteCourseTeachingMaterialsMutationVariables = Exact<{
  input: DeleteTeachingMaterialsInput;
}>;


export type DeleteCourseTeachingMaterialsMutation = { __typename?: 'Mutation', deleteTeachingMaterials: boolean };

export type DeleteLessonMasterTeachingMaterialsMutationVariables = Exact<{
  input: DeleteLessonMasterTeachingMaterialInput;
}>;


export type DeleteLessonMasterTeachingMaterialsMutation = { __typename?: 'Mutation', deleteLessonMasterTeachingMaterials: boolean };

export type DeleteCourseProductImagesMutationVariables = Exact<{
  input: DeleteProductImagesInput;
}>;


export type DeleteCourseProductImagesMutation = { __typename?: 'Mutation', deleteProductImages: boolean };

export type UpdateCourseImageOrdersMutationVariables = Exact<{
  input: UpdateCourseImageOrdersInput;
}>;


export type UpdateCourseImageOrdersMutation = { __typename?: 'Mutation', updateCourseImageOrders?: Array<{ __typename?: 'CourseImage', id: string, order: number }> | null };

export type CourseForEditPageFragment = { __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, published: boolean, overview: string, questionnaireAnswered: boolean, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, name: string, order: number, teachingMaterials?: Array<{ __typename?: 'LessonMasterTeachingMaterial', id: string, name: string, url: string }> | null }> | null, organizer?: { __typename?: 'Organizer', id: string, name: string } | null, levelEntity?: { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean } | null, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, details: Array<{ __typename?: 'CourseDetail', id?: string | null, category: CourseDetailCategory, description: string }>, images?: Array<{ __typename?: 'CourseImage', id: string, order: number, name: string, url: string }> | null, videos?: Array<{ __typename?: 'CourseVideo', id: string, url: string }> | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null };

export type CoursesEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
  selectorsLimit?: InputMaybe<Scalars['Int']>;
}>;


export type CoursesEditPageQuery = { __typename?: 'Query', course: { __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, published: boolean, overview: string, questionnaireAnswered: boolean, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, name: string, order: number, teachingMaterials?: Array<{ __typename?: 'LessonMasterTeachingMaterial', id: string, name: string, url: string }> | null }> | null, organizer?: { __typename?: 'Organizer', id: string, name: string } | null, levelEntity?: { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean } | null, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, details: Array<{ __typename?: 'CourseDetail', id?: string | null, category: CourseDetailCategory, description: string }>, images?: Array<{ __typename?: 'CourseImage', id: string, order: number, name: string, url: string }> | null, videos?: Array<{ __typename?: 'CourseVideo', id: string, url: string }> | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null }, organizers: { __typename?: 'Organizers', totalCount: number, nodes: Array<{ __typename?: 'Organizer', id: string, name: string }> }, subjects: { __typename?: 'Subjects', totalCount: number, nodes: Array<{ __typename?: 'Subject', id: string, name: string, status: boolean }> }, levels: { __typename?: 'Levels', totalCount: number, nodes: Array<{ __typename?: 'Level', id: string, systemId: string, name: string, status: boolean }> } };

export type CourseNewFragment = { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, overview: string, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', url: string }> | null, details: Array<{ __typename?: 'CourseDetail', category: CourseDetailCategory, description: string }>, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, order: number, name: string, teachingMaterials?: Array<{ __typename?: 'LessonMasterTeachingMaterial', url: string }> | null }> | null };

export type CreateCourseMutationVariables = Exact<{
  input: CreateCourseInput;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse: { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, overview: string, targets?: { __typename?: 'CourseTarget', type: CourseTargetType, from?: string | null, to?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', url: string }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', url: string }> | null, details: Array<{ __typename?: 'CourseDetail', category: CourseDetailCategory, description: string }>, lessonMasters?: Array<{ __typename?: 'LessonMaster', id: string, order: number, name: string, teachingMaterials?: Array<{ __typename?: 'LessonMasterTeachingMaterial', url: string }> | null }> | null } };

export type GenerateUploadCourseTeachingMaterialUrlMutationVariables = Exact<{
  courseId: Scalars['ID'];
  fileName: Scalars['String'];
}>;


export type GenerateUploadCourseTeachingMaterialUrlMutation = { __typename?: 'Mutation', generateUploadCourseTeachingMaterialUrl?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null };

export type GenerateUploadLessonMasterTeachingMaterialUrlMutationVariables = Exact<{
  lessonMasterId: Scalars['ID'];
  fileName: Scalars['String'];
}>;


export type GenerateUploadLessonMasterTeachingMaterialUrlMutation = { __typename?: 'Mutation', generateUploadLessonMasterTeachingMaterialUrl?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null };

export type GenerateUploadCourseImageUrlMutationVariables = Exact<{
  courseId: Scalars['ID'];
  fileName: Scalars['String'];
  order: Scalars['Int'];
  courseImageId?: InputMaybe<Scalars['ID']>;
}>;


export type GenerateUploadCourseImageUrlMutation = { __typename?: 'Mutation', generateUploadCourseImageUrl?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null };

export type CoursesNewPageQueryVariables = Exact<{
  selectorsLimit?: InputMaybe<Scalars['Int']>;
}>;


export type CoursesNewPageQuery = { __typename?: 'Query', organizers: { __typename?: 'Organizers', totalCount: number, nodes: Array<{ __typename?: 'Organizer', id: string, name: string }> }, subjects: { __typename?: 'Subjects', totalCount: number, nodes: Array<{ __typename?: 'Subject', id: string, name: string, status: boolean }> }, levels: { __typename?: 'Levels', totalCount: number, nodes: Array<{ __typename?: 'Level', id: string, systemId: string, name: string, status: boolean }> } };

export type ClazzItemFragment = { __typename?: 'Clazz', id: string, anyClassId?: string | null, systemId: string, courseId: string, name: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, participantsCount: number, teachers: Array<{ __typename?: 'User', familyName: string, givenName: string }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null };

export type CoursesItemFragment = { __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', id: string, order: number, name: string, url: string }> | null, clazzes: Array<{ __typename?: 'Clazz', id: string, anyClassId?: string | null, systemId: string, courseId: string, name: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, participantsCount: number, teachers: Array<{ __typename?: 'User', familyName: string, givenName: string }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null }> };

export type CoursesFragment = { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', id: string, order: number, name: string, url: string }> | null, clazzes: Array<{ __typename?: 'Clazz', id: string, anyClassId?: string | null, systemId: string, courseId: string, name: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, participantsCount: number, teachers: Array<{ __typename?: 'User', familyName: string, givenName: string }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null }> }> };

export type CoursesForCoursesPageQueryVariables = Exact<{
  filter?: InputMaybe<CoursesFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CoursesForCoursesPageQuery = { __typename?: 'Query', courses: { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string, courseId?: string | null, subjects?: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> | null, price: { __typename?: 'CoursePrice', type: CoursePriceType, valueNoTax?: number | null }, images?: Array<{ __typename?: 'CourseImage', id: string, order: number, name: string, url: string }> | null, clazzes: Array<{ __typename?: 'Clazz', id: string, anyClassId?: string | null, systemId: string, courseId: string, name: string, capacity: number, applicantCountVisibility: boolean, canceledCount?: number | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, participantsCount: number, teachers: Array<{ __typename?: 'User', familyName: string, givenName: string }>, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string } }> | null }> }> } };

export type CoursesDnDTableItemFragment = { __typename?: 'Course', id: string, systemId: string, name: string, order: number, clazzes: Array<{ __typename?: 'Clazz', published?: boolean | null, lessons?: Array<{ __typename?: 'Lesson', startedAt: Date, endedAt: Date }> | null }> };

export type UpdateCourseOrdersMutationVariables = Exact<{
  input: UpdateCourseOrdersInput;
}>;


export type UpdateCourseOrdersMutation = { __typename?: 'Mutation', updateCourseOrders: Array<{ __typename?: 'Course', id: string, order: number }> };

export type CoursesSortPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CoursesSortPageQuery = { __typename?: 'Query', publishedCourses: { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string, order: number, clazzes: Array<{ __typename?: 'Clazz', published?: boolean | null, lessons?: Array<{ __typename?: 'Lesson', startedAt: Date, endedAt: Date }> | null }> }> } };

export type BillingCustomersTableRowFragment = { __typename?: 'BillingCustomer', id: string, customerId: string, payService: number, submittedAt: Date, canceledAt?: Date | null, plan: { __typename?: 'Plan', id: string, name: string } };

export type CustomerBillingSearchResultsFragment = { __typename?: 'BillingCustomers', totalCount: number, nodes: Array<{ __typename?: 'BillingCustomer', id: string, customerId: string, payService: number, submittedAt: Date, canceledAt?: Date | null, plan: { __typename?: 'Plan', id: string, name: string } }> };

export type BillingCustomersCsvRowFragment = { __typename?: 'BillingCustomer', id: string, customerId: string, submittedAt: Date, canceledAt?: Date | null, mailMagazineAgreement: boolean, profile: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string }, plan: { __typename?: 'Plan', id: string, name: string } };

export type CustomerBillingSearchResultsCsvFragment = { __typename?: 'BillingCustomers', totalCount: number, nodes: Array<{ __typename?: 'BillingCustomer', id: string, customerId: string, submittedAt: Date, canceledAt?: Date | null, mailMagazineAgreement: boolean, profile: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string }, plan: { __typename?: 'Plan', id: string, name: string } }> };

export type CustomerBillingSearchResultsQueryVariables = Exact<{
  filter?: InputMaybe<BillingCustomerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerBillingSearchResultsQuery = { __typename?: 'Query', hasAdminAuthority: boolean, billingCustomers: { __typename?: 'BillingCustomers', totalCount: number, nodes: Array<{ __typename?: 'BillingCustomer', id: string, customerId: string, payService: number, submittedAt: Date, canceledAt?: Date | null, plan: { __typename?: 'Plan', id: string, name: string } }> } };

export type CustomerBillingCsvDownloadQueryVariables = Exact<{
  filter?: InputMaybe<BillingCustomerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerBillingCsvDownloadQuery = { __typename?: 'Query', billingCustomers: { __typename?: 'BillingCustomers', totalCount: number, nodes: Array<{ __typename?: 'BillingCustomer', id: string, customerId: string, submittedAt: Date, canceledAt?: Date | null, mailMagazineAgreement: boolean, profile: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string }, plan: { __typename?: 'Plan', id: string, name: string } }> } };

export type CustomerFragment = { __typename?: 'Customer', id: string, auId?: string | null, createdAt: Date, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, gender: Gender, tel: string, birthday: string, age: number, postalCode: string, prefecture: string, city: string, houseNumber: string, subjects: Array<{ __typename?: 'Subject', id: string, name: string }>, parentProfile?: { __typename?: 'ParentsProfile', birthday: string, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, email: string } | null, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null, note?: { __typename?: 'UserNote', note?: string | null } | null } | null, agreements: Array<{ __typename?: 'Agreement', status: AgreementStatus, updatedAt: Date, terms: { __typename?: 'Terms', name: string, version: string } }>, customerServices: Array<{ __typename?: 'CustomerService', serviceKindName: string }> };

export type CreateCustomerNoteMutationVariables = Exact<{
  input: CreateCustomerNoteInput;
}>;


export type CreateCustomerNoteMutation = { __typename?: 'Mutation', createCustomerNote: { __typename?: 'UserNote', note?: string | null } };

export type CustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, auId?: string | null, createdAt: Date, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, gender: Gender, tel: string, birthday: string, age: number, postalCode: string, prefecture: string, city: string, houseNumber: string, subjects: Array<{ __typename?: 'Subject', id: string, name: string }>, parentProfile?: { __typename?: 'ParentsProfile', birthday: string, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, email: string } | null, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null, note?: { __typename?: 'UserNote', note?: string | null } | null } | null, agreements: Array<{ __typename?: 'Agreement', status: AgreementStatus, updatedAt: Date, terms: { __typename?: 'Terms', name: string, version: string } }>, customerServices: Array<{ __typename?: 'CustomerService', serviceKindName: string }> } };

export type ServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'Service', id: string, key: ServiceKind, shortName: string }> };

export type CustomerCsvRowFragment = { __typename?: 'Customer', id: string, createdAt: Date, agreedTerms?: Array<{ __typename?: 'Terms', key: string }> | null, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string, age: number, subjects: Array<{ __typename?: 'Subject', name: string }>, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null } | null, customerServices: Array<{ __typename?: 'CustomerService', serviceKindName: string }>, registration?: { __typename?: 'CustomerRegistration', eventKey: string } | null };

export type CustomerCsvDownloadsFragment = { __typename?: 'Customers', totalCount: number, nodes: Array<{ __typename?: 'Customer', id: string, createdAt: Date, agreedTerms?: Array<{ __typename?: 'Terms', key: string }> | null, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string, age: number, subjects: Array<{ __typename?: 'Subject', name: string }>, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null } | null, customerServices: Array<{ __typename?: 'CustomerService', serviceKindName: string }>, registration?: { __typename?: 'CustomerRegistration', eventKey: string } | null }> };

export type CustomerIdsSearchResultQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerIdsSearchResultQuery = { __typename?: 'Query', hasAdminAuthority: boolean, customersForDisplay: { __typename?: 'CustomersForDisplay', totalCount: number, nodes: Array<{ __typename?: 'CustomerForDisplay', id: string }> } };

export type CustomerCsvDownloadsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerCsvDownloadsQuery = { __typename?: 'Query', hasAdminAuthority: boolean, customers: { __typename?: 'Customers', totalCount: number, nodes: Array<{ __typename?: 'Customer', id: string, createdAt: Date, agreedTerms?: Array<{ __typename?: 'Terms', key: string }> | null, profile?: { __typename?: 'CustomerProfile', memberId?: string | null, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, tel: string, age: number, subjects: Array<{ __typename?: 'Subject', name: string }>, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null } | null, customerServices: Array<{ __typename?: 'CustomerService', serviceKindName: string }>, registration?: { __typename?: 'CustomerRegistration', eventKey: string } | null }> } };

export type UpdateDiscountMutationVariables = Exact<{
  input: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount: { __typename?: 'Discount', id: string } };

export type EditingDiscountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditingDiscountQuery = { __typename?: 'Query', discount: { __typename?: 'Discount', id: string, type: string, code: string, name: string, description?: string | null, durationMonths?: number | null, priceValue: number, priceValueNoTax: number, startedAt: Date, endedAt: Date }, discountCourses: Array<{ __typename?: 'DiscountCourse', id: string, systemId: string, name: string }> };

export type CreateDiscountMutationVariables = Exact<{
  input: CreateDiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount: { __typename?: 'Discount', id: string } };

export type DiscountsFragment = { __typename?: 'Discounts', totalCount: number, nodes: Array<{ __typename?: 'Discount', id: string, type: string, code: string, name: string, description?: string | null, priceValue: number, priceValueNoTax: number, durationMonths?: number | null, startedAt: Date, endedAt: Date }> };

export type DeleteDiscountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDiscountMutation = { __typename?: 'Mutation', deleteDiscount: { __typename?: 'Discount', id: string } };

export type DiscountsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type DiscountsQuery = { __typename?: 'Query', discounts: { __typename?: 'Discounts', totalCount: number, nodes: Array<{ __typename?: 'Discount', id: string, type: string, code: string, name: string, description?: string | null, priceValue: number, priceValueNoTax: number, durationMonths?: number | null, startedAt: Date, endedAt: Date }> } };

export type DiscountByCodeOnNewQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type DiscountByCodeOnNewQuery = { __typename?: 'Query', discountByCode?: { __typename?: 'Discount', id: string, type: string, code: string, name: string, description?: string | null, priceValue: number, priceValueNoTax: number, startedAt: Date, endedAt: Date } | null };

export type MaximumDiscountAmountQueryVariables = Exact<{
  serviceKindId: Scalars['String'];
}>;


export type MaximumDiscountAmountQuery = { __typename?: 'Query', maximumDiscountAmount: number };

export type UpdateExpertMutationVariables = Exact<{
  input: UpdateExpertInput;
}>;


export type UpdateExpertMutation = { __typename?: 'Mutation', updateExpert: { __typename?: 'Expert', id: string } };

export type GenerateUploadExpertImageUrlMutationVariables = Exact<{
  input: GenerateUploadExpertImageUrlInput;
}>;


export type GenerateUploadExpertImageUrlMutation = { __typename?: 'Mutation', generateUploadExpertImageUrl: { __typename?: 'ExpertImagePresignedPostResult', profilePhoto?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null, headshot?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null } };

export type ExpertEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExpertEditPageQuery = { __typename?: 'Query', expert: { __typename?: 'Expert', id: string, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, company: string, position: string, title: string, career: string, alias: string, profilePhoto?: string | null, headshot?: string | null, alt: string, publishedAt: Date, closedAt?: Date | null, booksListText?: string | null, siteUrl?: string | null, twitterUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, youtubeUrl?: string | null, wikipediaUrl?: string | null } };

export type CreateExpertMutationVariables = Exact<{
  input: CreateExpertInput;
}>;


export type CreateExpertMutation = { __typename?: 'Mutation', createExpert: { __typename?: 'Expert', id: string } };

export type ExpertPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExpertPageQuery = { __typename?: 'Query', expert: { __typename?: 'Expert', id: string, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, company: string, position: string, title: string, career: string, alias: string, profilePhoto?: string | null, headshot?: string | null, alt: string, publishedAt: Date, closedAt?: Date | null, booksListText?: string | null, siteUrl?: string | null, twitterUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, youtubeUrl?: string | null, wikipediaUrl?: string | null } };

export type ExpertCardFragment = { __typename?: 'Expert', id: string, familyName: string, givenName: string, profilePhoto?: string | null, publishedAt: Date, videoLessons: Array<{ __typename?: 'VideoLesson', id: string, name: string, publishedAt: Date, closedAt?: Date | null, alias: string, field: { __typename?: 'Field', alias: string } }> };

export type VideoLessonCardFragment = { __typename?: 'VideoLesson', id: string, name: string, publishedAt: Date, closedAt?: Date | null, alias: string, field: { __typename?: 'Field', alias: string } };

export type ExpertsPageQueryVariables = Exact<{
  filter?: InputMaybe<ExpertsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ExpertsPageQuery = { __typename?: 'Query', experts: { __typename?: 'Experts', totalCount: number, nodes: Array<{ __typename?: 'Expert', id: string, familyName: string, givenName: string, profilePhoto?: string | null, publishedAt: Date, videoLessons: Array<{ __typename?: 'VideoLesson', id: string, name: string, publishedAt: Date, closedAt?: Date | null, alias: string, field: { __typename?: 'Field', alias: string } }> }> } };

export type ExpertDetailFragment = { __typename?: 'Expert', id: string, familyName: string, givenName: string, familyNameKana: string, givenNameKana: string, company: string, position: string, title: string, career: string, alias: string, profilePhoto?: string | null, headshot?: string | null, alt: string, publishedAt: Date, closedAt?: Date | null, booksListText?: string | null, siteUrl?: string | null, twitterUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, youtubeUrl?: string | null, wikipediaUrl?: string | null };

export type GenerateUploadFeaturedVideoImageUrlMutationVariables = Exact<{
  featuredVideoId: Scalars['ID'];
  featuredVideoImageId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  order: Scalars['Int'];
}>;


export type GenerateUploadFeaturedVideoImageUrlMutation = { __typename?: 'Mutation', generateUploadFeaturedVideoImageUrl?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null };

export type UpdateFeaturedVideosMutationVariables = Exact<{
  input: Array<UpdateFeaturedVideoInput> | UpdateFeaturedVideoInput;
}>;


export type UpdateFeaturedVideosMutation = { __typename?: 'Mutation', updateFeaturedVideos: Array<{ __typename?: 'FeaturedVideo', id: string, name: string, order: number, path: string, fileName: string, thumbnailUrl: string }> };

export type FeaturedVideoEditFragment = { __typename?: 'FeaturedVideo', id: string, name: string, order: number, path: string, fileName: string, thumbnailUrl: string };

export type FeaturedVideosEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedVideosEditPageQuery = { __typename?: 'Query', featuredVideos: Array<{ __typename?: 'FeaturedVideo', id: string, name: string, order: number, path: string, fileName: string, thumbnailUrl: string }> };

export type FeaturedVideosPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedVideosPageQuery = { __typename?: 'Query', featuredVideos: Array<{ __typename?: 'FeaturedVideo', id: string, name: string, order: number, path: string, thumbnailUrl: string }> };

export type ParticipantTableRowFragment = { __typename?: 'Participant', customerId: string, gender: Gender, age: number, grade: string, applicatedAt: Date };

export type ParticipantTableFragment = { __typename?: 'Participants', totalCount: number, nodes: Array<{ __typename?: 'Participant', customerId: string, gender: Gender, age: number, grade: string, applicatedAt: Date }> };

export type LessonParticipantsPageItemFragment = { __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date, participantsCount: number, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string, capacity: number, course?: { __typename?: 'Course', id: string, systemId: string, name: string } | null } | null };

export type LessonParticipantsPageQueryVariables = Exact<{
  lessonId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LessonParticipantsPageQuery = { __typename?: 'Query', participants: { __typename?: 'Participants', totalCount: number, nodes: Array<{ __typename?: 'Participant', customerId: string, gender: Gender, age: number, grade: string, applicatedAt: Date }> }, lesson: { __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date, participantsCount: number, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string, capacity: number, course?: { __typename?: 'Course', id: string, systemId: string, name: string } | null } | null } };

export type LessonItemRowFragment = { __typename?: 'Lesson', id: string, lessonUrl?: string | null, startedAt: Date, endedAt: Date, locationType: LocationType, zoomStartUrl?: string | null, participantsCount: number, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string, capacity: number, applicantCountVisibility: boolean, course?: { __typename?: 'Course', id: string, systemId: string, name: string, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null } | null } | null };

export type LessonsResultsFragment = { __typename?: 'Lessons', totalCount: number, nodes: Array<{ __typename?: 'Lesson', id: string, lessonUrl?: string | null, startedAt: Date, endedAt: Date, locationType: LocationType, zoomStartUrl?: string | null, participantsCount: number, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string, capacity: number, applicantCountVisibility: boolean, course?: { __typename?: 'Course', id: string, systemId: string, name: string, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null } | null } | null }> };

export type LessonsMeResultsFragment = { __typename?: 'User', id: string, familyName: string, givenName: string, roles: Array<{ __typename?: 'Role', id: string, name: string }> };

export type LessonsPageQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LessonsPageQuery = { __typename?: 'Query', lessons: { __typename?: 'Lessons', totalCount: number, nodes: Array<{ __typename?: 'Lesson', id: string, lessonUrl?: string | null, startedAt: Date, endedAt: Date, locationType: LocationType, zoomStartUrl?: string | null, participantsCount: number, lessonMaster: { __typename?: 'LessonMaster', id: string, order: number, name: string }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string, capacity: number, applicantCountVisibility: boolean, course?: { __typename?: 'Course', id: string, systemId: string, name: string, teachingMaterials?: Array<{ __typename?: 'CourseTeachingMaterial', id: string, name: string, url: string }> | null } | null } | null }> }, me: { __typename?: 'User', id: string, familyName: string, givenName: string, roles: Array<{ __typename?: 'Role', id: string, name: string }> } };

export type FieldCreateFragment = { __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string };

export type FieldUpdateFragment = { __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string };

export type FieldsResultItemFragment = { __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string };

export type FieldsResultFragment = { __typename?: 'Fields', totalCount: number, nodes: Array<{ __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string }> };

export type CreateFieldMutationVariables = Exact<{
  input: CreateFieldInput;
}>;


export type CreateFieldMutation = { __typename?: 'Mutation', createField?: { __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string } | null };

export type UpdateFieldMutationVariables = Exact<{
  input: UpdateFieldInput;
}>;


export type UpdateFieldMutation = { __typename?: 'Mutation', updateField?: { __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string } | null };

export type FieldsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FieldsQuery = { __typename?: 'Query', fields: { __typename?: 'Fields', totalCount: number, nodes: Array<{ __typename?: 'Field', id: string, name: string, subTitle: string, summary: string, alias: string }> } };

export type LevelCreateFragment = { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean };

export type LevelUpdateFragment = { __typename?: 'Level', id: string, name: string, status: boolean };

export type CreateLevelMutationVariables = Exact<{
  input: CreateLevelInput;
}>;


export type CreateLevelMutation = { __typename?: 'Mutation', createLevel?: { __typename?: 'Level', id: string, systemId: string, name: string, status: boolean } | null };

export type UpdateLevelMutationVariables = Exact<{
  input: UpdateLevelInput;
}>;


export type UpdateLevelMutation = { __typename?: 'Mutation', updateLevel?: { __typename?: 'Level', id: string, name: string, status: boolean } | null };

export type MasterPageOrganizerFragment = { __typename?: 'Organizer', id: string, name: string };

export type CreateOrganizerMutationVariables = Exact<{
  input: CreateOrganizerInput;
}>;


export type CreateOrganizerMutation = { __typename?: 'Mutation', createOrganizer: { __typename?: 'Organizer', id: string } };

export type UpdateOrganizerMutationVariables = Exact<{
  input: UpdateOrganizerInput;
}>;


export type UpdateOrganizerMutation = { __typename?: 'Mutation', updateOrganizer: { __typename?: 'Organizer', id: string } };

export type MasterPageOrganizersQueryVariables = Exact<{
  filter?: InputMaybe<OrganizerFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MasterPageOrganizersQuery = { __typename?: 'Query', organizers: { __typename?: 'Organizers', totalCount: number, nodes: Array<{ __typename?: 'Organizer', id: string, name: string }> } };

export type SubjectCreateFragment = { __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean };

export type SubjectUpdateFragment = { __typename?: 'Subject', id: string, name: string, status: boolean };

export type SubjectsResultItemFragment = { __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean };

export type SubjectsResultFragment = { __typename?: 'Subjects', totalCount: number, nodes: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> };

export type CreateSubjectMutationVariables = Exact<{
  input: CreateSubjectInput;
}>;


export type CreateSubjectMutation = { __typename?: 'Mutation', createSubject?: { __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean } | null };

export type UpdateSubjectMutationVariables = Exact<{
  input: UpdateSubjectInput;
}>;


export type UpdateSubjectMutation = { __typename?: 'Mutation', updateSubject?: { __typename?: 'Subject', id: string, name: string, status: boolean } | null };

export type SubjectsQueryVariables = Exact<{
  filter?: InputMaybe<SubjectFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SubjectsQuery = { __typename?: 'Query', subjects: { __typename?: 'Subjects', totalCount: number, nodes: Array<{ __typename?: 'Subject', id: string, systemId: string, name: string, status: boolean }> } };

export type MasterPageVideoTagFragment = { __typename?: 'VideoTag', id: string, name: string, status: boolean };

export type CreateVideoTagMutationVariables = Exact<{
  input: CreateVideoTagInput;
}>;


export type CreateVideoTagMutation = { __typename?: 'Mutation', createVideoTag: { __typename?: 'VideoTag', id: string } };

export type UpdateVideoTagMutationVariables = Exact<{
  input: UpdateVideoTagInput;
}>;


export type UpdateVideoTagMutation = { __typename?: 'Mutation', updateVideoTag: { __typename?: 'VideoTag', id: string } };

export type MasterPageVideoTagsQueryVariables = Exact<{
  filter?: InputMaybe<VideoTagFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MasterPageVideoTagsQuery = { __typename?: 'Query', videoTags: { __typename?: 'VideoTags', totalCount: number, nodes: Array<{ __typename?: 'VideoTag', id: string, name: string, status: boolean }> } };

export type ContBillPaymentMismatchMplStatusFragment = { __typename?: 'PaymentMismatchCsv', id: string, authDateTime?: string | null, soldDateTime?: string | null, adjustedDateTime?: string | null, memberId?: string | null, serviceId?: string | null, auOneId?: string | null, tel?: string | null, openId?: string | null, payInfoNo?: string | null, continueAccountId?: string | null, memberManageNo?: string | null, commodity?: string | null, priceSign?: string | null, priceValue?: string | null, paymtd?: string | null, reserved1?: string | null, reserved2?: string | null, processType?: string | null, processDateTime?: string | null, cancelDateTime?: string | null, claimDateTime?: string | null, refundDateTime?: string | null, note?: string | null, resultCode?: string | null, reserved3?: string | null, serviceShortName?: string | null, reserved4?: string | null, status?: number | null };

export type ContBillPaymentMismatchHeaderFragment = { __typename?: 'PaymentMismatch', id: string, detectedDateTime?: Date | null, type?: string | null, continueAccountId?: string | null };

export type ContBillPaymentDetailFragment = { __typename?: 'PaymentTransaction', id: string, continueAccountId: string, accountTimingKbn?: PaymentAccountTimingKbn | null, paymentDay?: number | null, firstPaymentDate?: Date | null, paymtd?: Paymtd | null, price: { __typename?: 'Price', initialValue?: number | null, value?: number | null }, order: { __typename?: 'Order', id: string, name: string, systemId: string, submittedAt?: Date | null, canceledAt?: Date | null, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null } | null } | null } };

export type ContBillPaymentMismatchDetailFragment = { __typename?: 'PaymentMismatch', id: string, detectedDateTime?: Date | null, type?: string | null, continueAccountId?: string | null, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, continueAccountId: string, accountTimingKbn?: PaymentAccountTimingKbn | null, paymentDay?: number | null, firstPaymentDate?: Date | null, paymtd?: Paymtd | null, price: { __typename?: 'Price', initialValue?: number | null, value?: number | null }, order: { __typename?: 'Order', id: string, name: string, systemId: string, submittedAt?: Date | null, canceledAt?: Date | null, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null } | null } | null } } | null, paymentMismatchCsvs: Array<{ __typename?: 'PaymentMismatchCsv', id: string, authDateTime?: string | null, soldDateTime?: string | null, adjustedDateTime?: string | null, memberId?: string | null, serviceId?: string | null, auOneId?: string | null, tel?: string | null, openId?: string | null, payInfoNo?: string | null, continueAccountId?: string | null, memberManageNo?: string | null, commodity?: string | null, priceSign?: string | null, priceValue?: string | null, paymtd?: string | null, reserved1?: string | null, reserved2?: string | null, processType?: string | null, processDateTime?: string | null, cancelDateTime?: string | null, claimDateTime?: string | null, refundDateTime?: string | null, note?: string | null, resultCode?: string | null, reserved3?: string | null, serviceShortName?: string | null, reserved4?: string | null, status?: number | null }> };

export type ContBillPaymentMismatchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContBillPaymentMismatchQuery = { __typename?: 'Query', paymentMismatch: { __typename?: 'PaymentMismatch', id: string, detectedDateTime?: Date | null, type?: string | null, continueAccountId?: string | null, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, continueAccountId: string, accountTimingKbn?: PaymentAccountTimingKbn | null, paymentDay?: number | null, firstPaymentDate?: Date | null, paymtd?: Paymtd | null, price: { __typename?: 'Price', initialValue?: number | null, value?: number | null }, order: { __typename?: 'Order', id: string, name: string, systemId: string, submittedAt?: Date | null, canceledAt?: Date | null, customer?: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null } | null } | null } } | null, paymentMismatchCsvs: Array<{ __typename?: 'PaymentMismatchCsv', id: string, authDateTime?: string | null, soldDateTime?: string | null, adjustedDateTime?: string | null, memberId?: string | null, serviceId?: string | null, auOneId?: string | null, tel?: string | null, openId?: string | null, payInfoNo?: string | null, continueAccountId?: string | null, memberManageNo?: string | null, commodity?: string | null, priceSign?: string | null, priceValue?: string | null, paymtd?: string | null, reserved1?: string | null, reserved2?: string | null, processType?: string | null, processDateTime?: string | null, cancelDateTime?: string | null, claimDateTime?: string | null, refundDateTime?: string | null, note?: string | null, resultCode?: string | null, reserved3?: string | null, serviceShortName?: string | null, reserved4?: string | null, status?: number | null }> } };

export type ContBillPaymentMismatchesTableRowFragment = { __typename?: 'PaymentMismatch', id: string, detectedDateTime?: Date | null, type?: string | null, continueAccountId?: string | null };

export type ContBillPaymentMismatchResultsFragment = { __typename?: 'ContBillPaymentMismatches', totalCount: number, nodes: Array<{ __typename?: 'PaymentMismatch', id: string, detectedDateTime?: Date | null, type?: string | null, continueAccountId?: string | null }> };

export type ContBillPaymentMismatchesQueryVariables = Exact<{
  filter?: InputMaybe<ContBillPaymentMismatchesFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ContBillPaymentMismatchesQuery = { __typename?: 'Query', contBillPaymentMismatches: { __typename?: 'ContBillPaymentMismatches', totalCount: number, nodes: Array<{ __typename?: 'PaymentMismatch', id: string, detectedDateTime?: Date | null, type?: string | null, continueAccountId?: string | null }> } };

export type PaymentMismatchDetailFragment = { __typename?: 'PaymentMismatch', id: string, payInfoNo?: string | null, handlingStatus?: string | null, detectedDateTime?: Date | null, serviceId?: string | null, type?: string | null, payment?: { __typename?: 'Payment', id: string, payInfoNo?: string | null, orderId?: string | null, customerId?: string | null, memberId?: string | null, customerName?: string | null, customerNameKana?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, typename?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, submittedAt?: Date | null, soldDateTime?: Date | null, processDateTime?: Date | null, clazzId?: string | null, updatedAt?: Date | null, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date }> | null } | null };

export type MismatchHandlingHistoryFragment = { __typename?: 'MismatchHandlingHistory', id?: string | null, handlingStatus?: string | null, note?: string | null, createdAt?: Date | null, updatedAt?: Date | null, handler?: { __typename?: 'Handler', id: string, userId: string, familyName: string, givenName: string } | null };

export type PaymentMismatchCsvFragment = { __typename?: 'PaymentMismatchCsv', id: string, authDateTime?: string | null, soldDateTime?: string | null, adjustedDateTime?: string | null, memberId?: string | null, serviceId?: string | null, tel?: string | null, auOneId?: string | null, openId?: string | null, payInfoNo?: string | null, continueAccountId?: string | null, memberManageNo?: string | null, commodity?: string | null, priceSign?: string | null, priceValue?: string | null, paymtd?: string | null, reserved1?: string | null, reserved2?: string | null };

export type CreateMismatchHandlingHistoryMutationVariables = Exact<{
  input: MismatchHandlingHistoryInput;
}>;


export type CreateMismatchHandlingHistoryMutation = { __typename?: 'Mutation', createMismatchHandlingHistory?: { __typename?: 'MismatchHandlingHistory', id?: string | null, handlingStatus?: string | null, note?: string | null, createdAt?: Date | null, updatedAt?: Date | null, handler?: { __typename?: 'Handler', id: string, userId: string, familyName: string, givenName: string } | null } | null };

export type UpdatePaymentMismatchMutationVariables = Exact<{
  input: UpdatePaymentMismatchInput;
}>;


export type UpdatePaymentMismatchMutation = { __typename?: 'Mutation', updatePaymentMismatch: { __typename?: 'PaymentMismatch', id: string, payInfoNo?: string | null, handlingStatus?: string | null, detectedDateTime?: Date | null, serviceId?: string | null, type?: string | null, payment?: { __typename?: 'Payment', id: string, payInfoNo?: string | null, orderId?: string | null, customerId?: string | null, memberId?: string | null, customerName?: string | null, customerNameKana?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, typename?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, submittedAt?: Date | null, soldDateTime?: Date | null, processDateTime?: Date | null, clazzId?: string | null, updatedAt?: Date | null, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date }> | null } | null } };

export type PaymentMismatchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentMismatchQuery = { __typename?: 'Query', paymentMismatch: { __typename?: 'PaymentMismatch', id: string, payInfoNo?: string | null, handlingStatus?: string | null, detectedDateTime?: Date | null, serviceId?: string | null, type?: string | null, payment?: { __typename?: 'Payment', id: string, payInfoNo?: string | null, orderId?: string | null, customerId?: string | null, memberId?: string | null, customerName?: string | null, customerNameKana?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, typename?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, submittedAt?: Date | null, soldDateTime?: Date | null, processDateTime?: Date | null, clazzId?: string | null, updatedAt?: Date | null, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date }> | null } | null } };

export type MismatchHandlingHistoriesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MismatchHandlingHistoriesQuery = { __typename?: 'Query', mismatchHandlingHistories?: Array<{ __typename?: 'MismatchHandlingHistory', id?: string | null, handlingStatus?: string | null, note?: string | null, createdAt?: Date | null, updatedAt?: Date | null, handler?: { __typename?: 'Handler', id: string, userId: string, familyName: string, givenName: string } | null }> | null };

export type PaymentMismatchCsvQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PaymentMismatchCsvQuery = { __typename?: 'Query', paymentMismatchCsv?: Array<{ __typename?: 'PaymentMismatchCsv', id: string, authDateTime?: string | null, soldDateTime?: string | null, adjustedDateTime?: string | null, memberId?: string | null, serviceId?: string | null, tel?: string | null, auOneId?: string | null, openId?: string | null, payInfoNo?: string | null, continueAccountId?: string | null, memberManageNo?: string | null, commodity?: string | null, priceSign?: string | null, priceValue?: string | null, paymtd?: string | null, reserved1?: string | null, reserved2?: string | null }> | null };

export type PaymentMismatchesTableRowFragment = { __typename?: 'PaymentMismatchSummary', id: string, payDataYYYYMMDD?: string | null, payInfoNo?: string | null, handlingStatus?: string | null, paymentStatus?: number | null, detectedDateTime?: Date | null, type?: string | null, latestUpdatedAt?: Date | null };

export type PaymentMismatchResultsFragment = { __typename?: 'PaymentMismatches', totalCount: number, nodes: Array<{ __typename?: 'PaymentMismatchSummary', id: string, payDataYYYYMMDD?: string | null, payInfoNo?: string | null, handlingStatus?: string | null, paymentStatus?: number | null, detectedDateTime?: Date | null, type?: string | null, latestUpdatedAt?: Date | null }> };

export type PaymentMismatchesQueryVariables = Exact<{
  filter?: InputMaybe<PaymentMismatchesFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PaymentMismatchesQuery = { __typename?: 'Query', paymentMismatches: { __typename?: 'PaymentMismatches', totalCount: number, nodes: Array<{ __typename?: 'PaymentMismatchSummary', id: string, payDataYYYYMMDD?: string | null, payInfoNo?: string | null, handlingStatus?: string | null, paymentStatus?: number | null, detectedDateTime?: Date | null, type?: string | null, latestUpdatedAt?: Date | null }> } };

export type PaymentDetailFragment = { __typename?: 'Payment', id: string, payInfoNo?: string | null, orderId?: string | null, customerId?: string | null, memberId?: string | null, customerName?: string | null, customerNameKana?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, typename?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, gmoFirstPaymentStatus?: string | null, gmoRecurringPaymentStatus?: string | null, submittedAt?: Date | null, soldDateTime?: Date | null, processDateTime?: Date | null, clazzId?: string | null, updatedAt?: Date | null, planName?: string | null, cancelable: PaymentCancelable, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date }> | null, receipt?: { __typename?: 'Receipt', expiredAt: Date, history: Array<{ __typename?: 'ReceiptHistory', id: string, url: string, issuedAt: Date }> } | null };

export type PaymentCourseClazzFragment = { __typename?: 'Clazz', id: string, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date }> | null };

export type CancelSoldCourseMutationVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type CancelSoldCourseMutation = { __typename?: 'Mutation', cancelSoldCourse: { __typename?: 'StartCancelSoldCourseResult', executionARN?: string | null, failedReason?: StepFunctionsCannotStartReason | null } };

export type CancelAuthorizedCourseMutationVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type CancelAuthorizedCourseMutation = { __typename?: 'Mutation', cancelAuthorizedCourse: { __typename?: 'StartCancelAuthorizedCourseResult', executionARN?: string | null, failedReason?: StepFunctionsCannotStartReason | null } };

export type PaymentDetailQueryVariables = Exact<{
  input: PaymentInput;
}>;


export type PaymentDetailQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', id: string, payInfoNo?: string | null, orderId?: string | null, customerId?: string | null, memberId?: string | null, customerName?: string | null, customerNameKana?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, typename?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, gmoFirstPaymentStatus?: string | null, gmoRecurringPaymentStatus?: string | null, submittedAt?: Date | null, soldDateTime?: Date | null, processDateTime?: Date | null, clazzId?: string | null, updatedAt?: Date | null, planName?: string | null, cancelable: PaymentCancelable, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date, endedAt: Date }> | null, receipt?: { __typename?: 'Receipt', expiredAt: Date, history: Array<{ __typename?: 'ReceiptHistory', id: string, url: string, issuedAt: Date }> } | null } };

export type PaymentCourseClazzQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentCourseClazzQuery = { __typename?: 'Query', clazz: { __typename?: 'Clazz', id: string, lessons?: Array<{ __typename?: 'Lesson', id: string, startedAt: Date }> | null } };

export type PaymentCancelSoldCourseExecutionStatusQueryVariables = Exact<{
  executionARN: Scalars['String'];
}>;


export type PaymentCancelSoldCourseExecutionStatusQuery = { __typename?: 'Query', cancelSoldCourseExecutionStatus: { __typename?: 'CancelSoldCourseExecutionStatus', status: StepFunctionsExecutionStatus } };

export type PaymentCancelAuthorizedCourseExecutionStatusQueryVariables = Exact<{
  executionARN: Scalars['String'];
}>;


export type PaymentCancelAuthorizedCourseExecutionStatusQuery = { __typename?: 'Query', cancelAuthorizedCourseExecutionStatus: { __typename?: 'CancelAuthorizedCourseExecutionStatus', status: StepFunctionsExecutionStatus } };

export type CourseNameRowFragment = { __typename?: 'Course', id: string, systemId: string, name: string };

export type CourseNamesFragment = { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string }> };

export type PaymentSearchPlanFragment = { __typename?: 'Plan', id: string, name: string, price: { __typename?: 'Price', type: PriceType } };

export type CourseNamesQueryVariables = Exact<{
  filter?: InputMaybe<CoursesFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CourseNamesQuery = { __typename?: 'Query', courses: { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string }> } };

export type PlansQueryVariables = Exact<{ [key: string]: never; }>;


export type PlansQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'Plan', id: string, name: string, price: { __typename?: 'Price', type: PriceType } }> };

export type PaymentsTableRowFragment = { __typename?: 'PaymentSummaryForDisplay', id: string, payInfoNo?: string | null, typename?: string | null, orderId?: string | null, customerId?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, planName?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, gmoFirstPaymentStatus?: string | null, gmoRecurringPaymentStatus?: string | null, submittedAt?: Date | null, soldDateTime?: Date | null, payService?: number | null };

export type PaymentsCsvRowFragment = { __typename?: 'PaymentSummary', id: string, payInfoNo?: string | null, typename?: string | null, orderId?: string | null, memberId?: string | null, customerName?: string | null, organizerName?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, planName?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, submittedAt?: Date | null, soldDateTime?: Date | null, payService?: number | null };

export type PaymentsSearchResultsFragment = { __typename?: 'PaymentsForDisplay', totalCount: number, nodes: Array<{ __typename?: 'PaymentSummaryForDisplay', id: string, payInfoNo?: string | null, typename?: string | null, orderId?: string | null, customerId?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, planName?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, gmoFirstPaymentStatus?: string | null, gmoRecurringPaymentStatus?: string | null, submittedAt?: Date | null, soldDateTime?: Date | null, payService?: number | null }> };

export type PaymentCsvDownloadsFragment = { __typename?: 'Payments', totalCount: number, nodes: Array<{ __typename?: 'PaymentSummary', id: string, payInfoNo?: string | null, typename?: string | null, orderId?: string | null, memberId?: string | null, customerName?: string | null, organizerName?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, planName?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, submittedAt?: Date | null, soldDateTime?: Date | null, payService?: number | null }> };

export type PaymentsSearchResultsQueryVariables = Exact<{
  filter?: InputMaybe<PaymentsFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PaymentsSearchResultsQuery = { __typename?: 'Query', hasAdminAuthority: boolean, paymentsForDisplay: { __typename?: 'PaymentsForDisplay', totalCount: number, nodes: Array<{ __typename?: 'PaymentSummaryForDisplay', id: string, payInfoNo?: string | null, typename?: string | null, orderId?: string | null, customerId?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, planName?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, gmoFirstPaymentStatus?: string | null, gmoRecurringPaymentStatus?: string | null, submittedAt?: Date | null, soldDateTime?: Date | null, payService?: number | null }> } };

export type PaymentCsvDownloadsQueryVariables = Exact<{
  filter?: InputMaybe<PaymentsFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PaymentCsvDownloadsQuery = { __typename?: 'Query', payments: { __typename?: 'Payments', totalCount: number, nodes: Array<{ __typename?: 'PaymentSummary', id: string, payInfoNo?: string | null, typename?: string | null, orderId?: string | null, memberId?: string | null, customerName?: string | null, organizerName?: string | null, contentName?: string | null, contentSytemId?: string | null, courseName?: string | null, courseSytemId?: string | null, planName?: string | null, priceValue?: number | null, priceValueNoTax?: number | null, paymentStatus?: number | null, submittedAt?: Date | null, soldDateTime?: Date | null, payService?: number | null }> } };

export type UpdateProfileMutationVariables = Exact<{
  input: ProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> } | null };

export type ProfileEditFragment = { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> };

export type ProfileEditQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileEditQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> } };

export type PublishClazzFragment = { __typename?: 'Clazz', id: string, systemId: string, name: string, saleStartedAt?: Date | null, saleEndedAt?: Date | null, published?: boolean | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, lessonMaster: { __typename?: 'LessonMaster', order: number } }> | null };

export type PublishPreviewTokenFragment = { __typename?: 'CoursePreviewToken', id: string, token: string };

export type PublishCoursesItemFragment = { __typename?: 'Course', id: string, systemId: string, name: string, published: boolean, clazzes: Array<{ __typename?: 'Clazz', id: string, systemId: string, name: string, saleStartedAt?: Date | null, saleEndedAt?: Date | null, published?: boolean | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, lessonMaster: { __typename?: 'LessonMaster', order: number } }> | null }>, previewToken?: { __typename?: 'CoursePreviewToken', id: string, token: string } | null };

export type PublishCoursesFragment = { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string, published: boolean, clazzes: Array<{ __typename?: 'Clazz', id: string, systemId: string, name: string, saleStartedAt?: Date | null, saleEndedAt?: Date | null, published?: boolean | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, lessonMaster: { __typename?: 'LessonMaster', order: number } }> | null }>, previewToken?: { __typename?: 'CoursePreviewToken', id: string, token: string } | null }> };

export type UpdateClassPublicationSettingMutationVariables = Exact<{
  input: UpdateClassAndLessonsInput;
}>;


export type UpdateClassPublicationSettingMutation = { __typename?: 'Mutation', updateClassAndLessons?: { __typename?: 'Clazz', id: string, systemId: string, course?: { __typename?: 'Course', published: boolean } | null } | null };

export type CreateCoursePreviewTokenMutationVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type CreateCoursePreviewTokenMutation = { __typename?: 'Mutation', createCoursePreviewToken: { __typename?: 'CoursePreviewToken', id: string, token: string } };

export type DeleteCoursePreviewTokenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCoursePreviewTokenMutation = { __typename?: 'Mutation', deleteCoursePreviewToken: boolean };

export type PublishCoursesQueryVariables = Exact<{
  filter?: InputMaybe<CoursesFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PublishCoursesQuery = { __typename?: 'Query', courses: { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, systemId: string, name: string, published: boolean, clazzes: Array<{ __typename?: 'Clazz', id: string, systemId: string, name: string, saleStartedAt?: Date | null, saleEndedAt?: Date | null, published?: boolean | null, lessons?: Array<{ __typename?: 'Lesson', id: string, systemId: string, startedAt: Date, endedAt: Date, lessonMaster: { __typename?: 'LessonMaster', order: number } }> | null }>, previewToken?: { __typename?: 'CoursePreviewToken', id: string, token: string } | null }> } };

export type AnsweredCoursesTableRowFragment = { __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null };

export type QuestionnaireAnswerRowFragment = { __typename?: 'QuestionnaireAnswer', orderId: string, submittedAt?: Date | null, customer: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null, familyName: string, givenName: string } | null }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string } | null, course?: { __typename?: 'Course', id: string, systemId: string, name: string } | null, answers?: Array<{ __typename?: 'Answer', questionnaireId: string, selectQuestionnaireOptionId?: number | null, multiSelectQuestionnaireOptionId?: number | null, freeTextValue?: string | null }> | null };

export type AnsweredCoursesFragment = { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null }> };

export type QuestionnaireAnswersFragment = { __typename?: 'QuestionnaireAnswers', totalCount: number, nodes: Array<{ __typename?: 'QuestionnaireAnswer', orderId: string, submittedAt?: Date | null, customer: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null, familyName: string, givenName: string } | null }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string } | null, course?: { __typename?: 'Course', id: string, systemId: string, name: string } | null, answers?: Array<{ __typename?: 'Answer', questionnaireId: string, selectQuestionnaireOptionId?: number | null, multiSelectQuestionnaireOptionId?: number | null, freeTextValue?: string | null }> | null }> };

export type AnsweredCoursesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AnsweredCoursesQuery = { __typename?: 'Query', hasAdminAuthority: boolean, answeredCourses: { __typename?: 'Courses', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, name: string, systemId: string, courseId?: string | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, order: number, title: string, typename: string, required: boolean, selectableNumber?: number | null, condition?: SelectableOptionConditionType | null, maxScale?: number | null, minLabel?: string | null, maxLabel?: string | null, options?: Array<{ __typename?: 'QuestionnaireOption', id: string, name: string }> | null }> | null }> } };

export type QuestionnaireAnswersQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionnaireAnswersQuery = { __typename?: 'Query', questionnaireAnswers: { __typename?: 'QuestionnaireAnswers', totalCount: number, nodes: Array<{ __typename?: 'QuestionnaireAnswer', orderId: string, submittedAt?: Date | null, customer: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', id: string, memberId?: string | null, familyName: string, givenName: string } | null }, clazz?: { __typename?: 'Clazz', id: string, systemId: string, name: string } | null, course?: { __typename?: 'Course', id: string, systemId: string, name: string } | null, answers?: Array<{ __typename?: 'Answer', questionnaireId: string, selectQuestionnaireOptionId?: number | null, multiSelectQuestionnaireOptionId?: number | null, freeTextValue?: string | null }> | null }> } };

export type VideoRatingTableRowFragment = { __typename?: 'VideoRatingSummary', rating?: number | null, ratingCount: number, video: { __typename?: 'Video', name: string } };

export type VideoLessonRatingTableRowFragment = { __typename?: 'VideoLessonRatingSummary', rating?: number | null, videoLesson: { __typename?: 'VideoLesson', id: string, name: string, expert: { __typename?: 'Expert', familyName: string, givenName: string } }, videoRatingSummaries: Array<{ __typename?: 'VideoRatingSummary', rating?: number | null, ratingCount: number, video: { __typename?: 'Video', name: string } }> };

export type VideoLessonRatingSummariesFragment = { __typename?: 'VideoLessonRatingSummaries', totalCount: number, nodes: Array<{ __typename?: 'VideoLessonRatingSummary', rating?: number | null, videoLesson: { __typename?: 'VideoLesson', id: string, name: string, expert: { __typename?: 'Expert', familyName: string, givenName: string } }, videoRatingSummaries: Array<{ __typename?: 'VideoRatingSummary', rating?: number | null, ratingCount: number, video: { __typename?: 'Video', name: string } }> }> };

export type VideoLessonRatingCsvFragment = { __typename?: 'VideoLessonRatingDetails', totalCount: number, nodes: Array<{ __typename?: 'VideoLessonRatingDetail', id: string, rating: number, freeTextValue?: string | null, createdAt: Date, customer: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', gender: Gender, age: number, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null } | null }, videoLesson: { __typename?: 'VideoLesson', id: string, name: string }, video: { __typename?: 'Video', id: string, name: string, jStreamMId: string } }> };

export type LiberalArtsVideoLessonRatingPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LiberalArtsVideoLessonRatingPageQuery = { __typename?: 'Query', videoLessonRatingSummaries: { __typename?: 'VideoLessonRatingSummaries', totalCount: number, nodes: Array<{ __typename?: 'VideoLessonRatingSummary', rating?: number | null, videoLesson: { __typename?: 'VideoLesson', id: string, name: string, expert: { __typename?: 'Expert', familyName: string, givenName: string } }, videoRatingSummaries: Array<{ __typename?: 'VideoRatingSummary', rating?: number | null, ratingCount: number, video: { __typename?: 'Video', name: string } }> }> } };

export type LiberalArtsVideoLessonRatingCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type LiberalArtsVideoLessonRatingCsvQuery = { __typename?: 'Query', videoLessonRatingDetails: { __typename?: 'VideoLessonRatingDetails', totalCount: number, nodes: Array<{ __typename?: 'VideoLessonRatingDetail', id: string, rating: number, freeTextValue?: string | null, createdAt: Date, customer: { __typename?: 'Customer', id: string, profile?: { __typename?: 'CustomerProfile', gender: Gender, age: number, userAttribute?: { __typename?: 'UserAttribute', occupation: string, industry: string, jobTitle: string, position: string, annualIncome: string } | null } | null }, videoLesson: { __typename?: 'VideoLesson', id: string, name: string }, video: { __typename?: 'Video', id: string, name: string, jStreamMId: string } }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> } };

export type GenerateUploadAvatorUrlMutationVariables = Exact<{
  userId: Scalars['ID'];
  fileName: Scalars['String'];
}>;


export type GenerateUploadAvatorUrlMutation = { __typename?: 'Mutation', generateUploadAvatorUrl?: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> } | null };

export type ServiceInputFragment = { __typename?: 'Service', id: string, shortName: string };

export type UsersEditPageFragment = { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> };

export type UsersEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UsersEditQuery = { __typename?: 'Query', hasAdminAuthority: boolean, user: { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, familyNameKana?: string | null, givenNameKana?: string | null, email: string, status: EmployeeStatus, tel?: string | null, gender: Gender, birthday?: string | null, birthplace?: string | null, yearsOfTeaching?: number | null, message?: string | null, selfIntroduction?: string | null, hobby?: string | null, avator?: string | null, extra: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, useableServiceKinds: Array<{ __typename?: 'Service', id: string, shortName: string }> }, services: Array<{ __typename?: 'Service', id: string, shortName: string }> };

export type UserExternalNewFragment = { __typename?: 'User', id: string, userId: string };

export type CreateExternalUserMutationVariables = Exact<{
  input: CreateExternalUserInput;
}>;


export type CreateExternalUserMutation = { __typename?: 'Mutation', createExternalUser: { __typename?: 'User', id: string, userId: string } };

export type ExistUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ExistUserQuery = { __typename?: 'Query', existUser: boolean };

export type UsersTableRowFragment = { __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, status: EmployeeStatus, extra: boolean, useableServiceKinds: Array<{ __typename?: 'Service', shortName: string }>, roles: Array<{ __typename?: 'Role', name: string }> };

export type UsersTableFragment = { __typename?: 'Users', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, status: EmployeeStatus, extra: boolean, useableServiceKinds: Array<{ __typename?: 'Service', shortName: string }>, roles: Array<{ __typename?: 'Role', name: string }> }> };

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'Users', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, userId: string, familyName: string, givenName: string, status: EmployeeStatus, extra: boolean, useableServiceKinds: Array<{ __typename?: 'Service', shortName: string }>, roles: Array<{ __typename?: 'Role', name: string }> }> } };

export type UpdateVideoLessonMutationVariables = Exact<{
  input: UpdateVideoLessonInput;
}>;


export type UpdateVideoLessonMutation = { __typename?: 'Mutation', updateVideoLesson: { __typename?: 'VideoLesson', id: string } };

export type GenerateUploadVideoLessonImageUrlMutationVariables = Exact<{
  input: GenerateUploadVideoLessonImageUrlInput;
}>;


export type GenerateUploadVideoLessonImageUrlMutation = { __typename?: 'Mutation', generateUploadVideoLessonImageUrl: { __typename?: 'PresignedPostResult', url: string, fields: {[key: string]: any } } };

export type VideoLessonEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VideoLessonEditPageQuery = { __typename?: 'Query', videoLesson: { __typename?: 'VideoLesson', id: string, name: string, description: string, fieldItemImg?: string | null, jStreamSampleMId: string, publishedAt: Date, closedAt?: Date | null, alias: string, field: { __typename?: 'Field', id: string, name: string }, videoTag?: { __typename?: 'VideoTag', id: string, name: string } | null, videos: Array<{ __typename?: 'Video', id: string, name: string, jStreamMId: string }> }, fields: { __typename?: 'Fields', totalCount: number, nodes: Array<{ __typename?: 'Field', id: string, name: string }> }, videoTags: { __typename?: 'VideoTags', totalCount: number, nodes: Array<{ __typename?: 'VideoTag', id: string, name: string }> } };

export type CreateVideoLessonMutationVariables = Exact<{
  input: CreateVideoLessonInput;
}>;


export type CreateVideoLessonMutation = { __typename?: 'Mutation', createVideoLesson: { __typename?: 'VideoLesson', id: string } };

export type VideoLessonNewPageQueryVariables = Exact<{ [key: string]: never; }>;


export type VideoLessonNewPageQuery = { __typename?: 'Query', fields: { __typename?: 'Fields', totalCount: number, nodes: Array<{ __typename?: 'Field', id: string, name: string }> }, videoTags: { __typename?: 'VideoTags', totalCount: number, nodes: Array<{ __typename?: 'VideoTag', id: string, name: string }> } };

export type VideoLessonPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VideoLessonPageQuery = { __typename?: 'Query', videoLesson: { __typename?: 'VideoLesson', id: string, name: string, description: string, fieldItemImg?: string | null, jStreamSampleMId: string, publishedAt: Date, closedAt?: Date | null, alias: string, field: { __typename?: 'Field', id: string, name: string }, videoTag?: { __typename?: 'VideoTag', id: string, name: string } | null, videos: Array<{ __typename?: 'Video', id: string, name: string, jStreamMId: string }> } };

export type VideoLessonDetailFragment = { __typename?: 'VideoLesson', id: string, name: string, description: string, fieldItemImg?: string | null, jStreamSampleMId: string, publishedAt: Date, closedAt?: Date | null, alias: string, field: { __typename?: 'Field', id: string, name: string }, videoTag?: { __typename?: 'VideoTag', id: string, name: string } | null, videos: Array<{ __typename?: 'Video', id: string, name: string, jStreamMId: string }> };

export type FieldSelecterFragment = { __typename?: 'Field', id: string, name: string };

export type VideoTagSelecterFragment = { __typename?: 'VideoTag', id: string, name: string };

export const CourseSelectorRowFragmentDoc = gql`
    fragment CourseSelectorRow on Course {
  id
  systemId
  name
}
    `;
export const CustomersTableRowFragmentDoc = gql`
    fragment CustomersTableRow on Customer {
  id
  profile {
    memberId
    familyName
    givenName
    familyNameKana
    givenNameKana
    tel
  }
  createdAt
}
    `;
export const CustomerSearchResultsFragmentDoc = gql`
    fragment CustomerSearchResults on Customers {
  totalCount
  nodes {
    ...CustomersTableRow
  }
}
    ${CustomersTableRowFragmentDoc}`;
export const AvatorFragmentDoc = gql`
    fragment Avator on User {
  familyName
  givenName
}
    `;
export const UseableSerivceFragmentDoc = gql`
    fragment UseableSerivce on Service {
  id
  name
  key
  shortName
}
    `;
export const MeFragmentDoc = gql`
    fragment Me on User {
  ...Avator
  useableServiceKinds {
    ...UseableSerivce
  }
  currentServiceKind @client {
    id
    key
  }
}
    ${AvatorFragmentDoc}
${UseableSerivceFragmentDoc}`;
export const LevelFragmentDoc = gql`
    fragment Level on Level {
  id
  systemId
  name
  status
}
    `;
export const LevelsResultFragmentDoc = gql`
    fragment LevelsResult on Levels {
  totalCount
  nodes {
    ...Level
  }
}
    ${LevelFragmentDoc}`;
export const OrganizerFragmentDoc = gql`
    fragment Organizer on Organizer {
  id
  name
}
    `;
export const OrganizersResultFragmentDoc = gql`
    fragment OrganizersResult on Organizers {
  totalCount
  nodes {
    ...Organizer
  }
}
    ${OrganizerFragmentDoc}`;
export const SubjectSelectorItemFragmentDoc = gql`
    fragment SubjectSelectorItem on Subject {
  id
  name
  status
}
    `;
export const UserDetailFragmentDoc = gql`
    fragment UserDetail on User {
  id
  userId
  familyName
  givenName
  familyNameKana
  givenNameKana
  email
  roles {
    id
    name
  }
  status
  tel
  gender
  birthday
  birthplace
  yearsOfTeaching
  message
  selfIntroduction
  hobby
  avator
  extra
  useableServiceKinds {
    id
    shortName
  }
}
    `;
export const AnnouncementForEditPageFragmentDoc = gql`
    fragment AnnouncementForEditPage on Announcement {
  id
  systemId
  kind
  publishStartedAt
  publishEndedAt
  subject
  body
  published
}
    `;
export const AnnouncementsTableRowFragmentDoc = gql`
    fragment AnnouncementsTableRow on Announcement {
  id
  systemId
  kind
  subject
  published
}
    `;
export const AnnouncementsFragmentDoc = gql`
    fragment Announcements on Announcements {
  totalCount
  nodes {
    ...AnnouncementsTableRow
  }
}
    ${AnnouncementsTableRowFragmentDoc}`;
export const CategoriesDnDTableItemFragmentDoc = gql`
    fragment CategoriesDnDTableItem on Subject {
  id
  systemId
  name
  order
}
    `;
export const ClassUpdateResultFragmentDoc = gql`
    fragment ClassUpdateResult on Clazz {
  id
  systemId
  course {
    published
  }
}
    `;
export const ClassForEditPageFragmentDoc = gql`
    fragment ClassForEditPage on Clazz {
  id
  anyClassId
  systemId
  courseId
  published
  course {
    systemId
    name
  }
  name
  capacity
  applicantCountVisibility
  eventLocation
  lessons {
    id
    systemId
    anyLessonId
    lessonUrl
    teachers {
      id
      userId
      familyName
      givenName
      extra
    }
    lessonMaster {
      id
      order
      name
    }
    startedAt
    endedAt
    participantsCount
  }
}
    `;
export const ClassNewResultFragmentDoc = gql`
    fragment ClassNewResult on Clazz {
  id
  systemId
}
    `;
export const CourseForCreatingClassFragmentDoc = gql`
    fragment CourseForCreatingClass on Course {
  id
  name
  systemId
  courseId
  lessonMasters {
    id
    name
    order
  }
}
    `;
export const TeachersTableRowFragmentDoc = gql`
    fragment TeachersTableRow on User {
  id
  userId
  familyName
  givenName
  roles {
    name
  }
  status
  extra
}
    `;
export const TeachersTableFragmentDoc = gql`
    fragment TeachersTable on Users {
  totalCount
  nodes {
    ...TeachersTableRow
  }
}
    ${TeachersTableRowFragmentDoc}`;
export const ClazzDetailFragmentDoc = gql`
    fragment ClazzDetail on Clazz {
  id
  systemId
  courseId
  anyClassId
  name
  eventLocation
  capacity
  applicantCountVisibility
  canceledCount
  course {
    name
  }
  lessons {
    id
    anyLessonId
    participantsCount
    lessonUrl
    startedAt
    endedAt
    teachers {
      givenName
      familyName
    }
    lessonMaster {
      name
      order
      id
    }
  }
}
    `;
export const ContactPageFragmentDoc = gql`
    fragment ContactPage on Contact {
  id
  systemId
  category {
    id
    value
  }
  content
  route
  customer {
    id
    profile {
      id
      memberId
      familyName
      givenName
      familyNameKana
      givenNameKana
      tel
    }
  }
  address {
    id
    familyName
    givenName
    familyNameKana
    givenNameKana
    email
    tel
  }
  createdAt
  histories {
    id
    oldStatus
    status
    oldServiceKind
    serviceKind
    memo
    supporterId
    supporterEmail
    supporterFamilyName
    supporterGivenName
    createdAt
  }
  serviceKind
}
    `;
export const ContactCategoryFragmentDoc = gql`
    fragment ContactCategory on ContactCategory {
  id
  value
}
    `;
export const CreateContactResultFragmentDoc = gql`
    fragment CreateContactResult on Contact {
  id
}
    `;
export const CreateContactHistoryResultFragmentDoc = gql`
    fragment CreateContactHistoryResult on ContactHistory {
  id
}
    `;
export const ContactServiceInputFragmentDoc = gql`
    fragment ContactServiceInput on Service {
  id
  key
  shortName
}
    `;
export const ContactsTableRowFragmentDoc = gql`
    fragment ContactsTableRow on ContactForDisplay {
  id
  systemId
  category {
    id
    value
  }
  route
  content
  customerId
  histories {
    id
    oldStatus
    status
    supporterFamilyName
    supporterGivenName
    createdAt
  }
  createdAt
}
    `;
export const ContactsFragmentDoc = gql`
    fragment Contacts on ContactsForDisplay {
  totalCount
  nodes {
    ...ContactsTableRow
  }
}
    ${ContactsTableRowFragmentDoc}`;
export const ContactsCsvRowFragmentDoc = gql`
    fragment ContactsCsvRow on Contact {
  id
  systemId
  category {
    id
    value
  }
  route
  content
  customer {
    id
    profile {
      memberId
      familyName
      givenName
    }
  }
  histories {
    id
    oldStatus
    status
    supporterFamilyName
    supporterGivenName
    createdAt
  }
  address {
    id
    familyName
    givenName
  }
  createdAt
}
    `;
export const ContactCsvDownloadsFragmentDoc = gql`
    fragment ContactCsvDownloads on Contacts {
  totalCount
  nodes {
    ...ContactsCsvRow
  }
}
    ${ContactsCsvRowFragmentDoc}`;
export const CorporationUploadedCsvFragmentDoc = gql`
    fragment CorporationUploadedCsv on CorporationCsvUploadHistoryData {
  id
  uploadResult
  fileName
  uploadTime
  successesCount
  failedCount
  filePath
}
    `;
export const CorporationPageHistoryFragmentDoc = gql`
    fragment CorporationPageHistory on CorporationCsvUploadHistoryResult {
  nowPageNum
  previousPageNum
  nextPageNum
  maxPageNum
  csvData {
    ...CorporationUploadedCsv
  }
}
    ${CorporationUploadedCsvFragmentDoc}`;
export const CoursePageFragmentDoc = gql`
    fragment CoursePage on Course {
  id
  systemId
  name
  courseId
  published
  organizer {
    id
    name
  }
  targets {
    type
    from
    to
  }
  levelEntity {
    id
    systemId
    name
    status
  }
  subjects {
    id
    systemId
    name
    status
  }
  teachingMaterials {
    id
    name
    url
  }
  price {
    type
    valueNoTax
  }
  overview
  images {
    id
    name
    url
    order
  }
  videos {
    id
    url
  }
  details {
    id
    category
    description
  }
  lessonMasters {
    id
    order
    name
    teachingMaterials {
      id
      name
      url
    }
  }
  clazzes {
    id
    systemId
    courseId
    name
    anyClassId
    eventLocation
    capacity
    applicantCountVisibility
    canceledCount
    lessons {
      id
      systemId
      teachers {
        id
        userId
        familyName
        givenName
        email
        roles {
          id
          name
          description
          defaultValue
        }
        status
        gender
        extra
      }
      lessonMasterId
      lessonMaster {
        id
        order
        name
      }
      clazzId
      startedAt
      endedAt
      locationType
      participantsCount
    }
  }
  questionnaires {
    id
    order
    title
    typename
    required
    options {
      id
      name
    }
    selectableNumber
    condition
    maxScale
    minLabel
    maxLabel
  }
}
    `;
export const CourseEditConfirmFragmentDoc = gql`
    fragment CourseEditConfirm on Course {
  id
  systemId
  name
  courseId
  targets {
    type
    from
    to
  }
  subjects {
    id
    systemId
    name
    status
  }
  teachingMaterials {
    url
  }
  price {
    type
    valueNoTax
  }
  overview
  images {
    url
  }
  videos {
    url
  }
  details {
    category
    description
  }
  lessonMasters {
    order
    name
  }
  published
}
    `;
export const CourseForEditPageFragmentDoc = gql`
    fragment CourseForEditPage on Course {
  id
  name
  systemId
  courseId
  published
  lessonMasters {
    id
    name
    order
  }
  organizer {
    id
    name
  }
  levelEntity {
    id
    systemId
    name
    status
  }
  targets {
    type
    from
    to
  }
  subjects {
    id
    systemId
    name
    status
  }
  teachingMaterials {
    id
    name
    url
  }
  price {
    type
    valueNoTax
  }
  overview
  details {
    id
    category
    description
  }
  lessonMasters {
    id
    order
    name
    teachingMaterials {
      id
      name
      url
    }
  }
  images {
    id
    order
    name
    url
  }
  videos {
    id
    url
  }
  published
  questionnaires {
    id
    order
    title
    typename
    required
    options {
      id
      name
    }
    selectableNumber
    condition
    maxScale
    minLabel
    maxLabel
  }
  questionnaireAnswered
}
    `;
export const CourseNewFragmentDoc = gql`
    fragment CourseNew on Course {
  id
  systemId
  name
  courseId
  targets {
    type
    from
    to
  }
  subjects {
    id
    systemId
    name
    status
  }
  teachingMaterials {
    url
  }
  price {
    type
    valueNoTax
  }
  overview
  images {
    url
  }
  details {
    category
    description
  }
  lessonMasters {
    id
    order
    name
    teachingMaterials {
      url
    }
  }
}
    `;
export const ClazzItemFragmentDoc = gql`
    fragment ClazzItem on Clazz {
  id
  anyClassId
  systemId
  courseId
  name
  capacity
  applicantCountVisibility
  canceledCount
  lessons {
    id
    systemId
    teachers {
      familyName
      givenName
    }
    lessonMaster {
      id
      order
      name
    }
    startedAt
    endedAt
    participantsCount
  }
}
    `;
export const CoursesItemFragmentDoc = gql`
    fragment CoursesItem on Course {
  id
  systemId
  name
  courseId
  subjects {
    id
    systemId
    name
    status
  }
  price {
    type
    valueNoTax
  }
  images {
    id
    order
    name
    url
  }
  clazzes {
    ...ClazzItem
  }
}
    ${ClazzItemFragmentDoc}`;
export const CoursesFragmentDoc = gql`
    fragment Courses on Courses {
  totalCount
  nodes {
    ...CoursesItem
  }
}
    ${CoursesItemFragmentDoc}`;
export const CoursesDnDTableItemFragmentDoc = gql`
    fragment CoursesDnDTableItem on Course {
  id
  systemId
  name
  order
  clazzes {
    published
    lessons {
      startedAt
      endedAt
    }
  }
}
    `;
export const BillingCustomersTableRowFragmentDoc = gql`
    fragment BillingCustomersTableRow on BillingCustomer {
  id
  customerId
  plan {
    id
    name
  }
  payService
  submittedAt
  canceledAt
}
    `;
export const CustomerBillingSearchResultsFragmentDoc = gql`
    fragment CustomerBillingSearchResults on BillingCustomers {
  totalCount
  nodes {
    ...BillingCustomersTableRow
  }
}
    ${BillingCustomersTableRowFragmentDoc}`;
export const BillingCustomersCsvRowFragmentDoc = gql`
    fragment BillingCustomersCsvRow on BillingCustomer {
  id
  customerId
  profile {
    memberId
    familyName
    givenName
    familyNameKana
    givenNameKana
    tel
  }
  plan {
    id
    name
  }
  submittedAt
  canceledAt
  mailMagazineAgreement
}
    `;
export const CustomerBillingSearchResultsCsvFragmentDoc = gql`
    fragment CustomerBillingSearchResultsCsv on BillingCustomers {
  totalCount
  nodes {
    ...BillingCustomersCsvRow
  }
}
    ${BillingCustomersCsvRowFragmentDoc}`;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  id
  profile {
    memberId
    familyName
    givenName
    familyNameKana
    givenNameKana
    gender
    tel
    birthday
    age
    postalCode
    prefecture
    city
    houseNumber
    subjects {
      id
      name
    }
    parentProfile {
      birthday
      familyName
      givenName
      familyNameKana
      givenNameKana
      email
    }
    userAttribute {
      occupation
      industry
      jobTitle
      position
      annualIncome
    }
    note {
      note
    }
  }
  auId
  agreements {
    terms {
      name
      version
    }
    status
    updatedAt
  }
  createdAt
  customerServices {
    serviceKindName
  }
}
    `;
export const CustomerCsvRowFragmentDoc = gql`
    fragment CustomerCsvRow on Customer {
  id
  createdAt
  agreedTerms {
    key
  }
  profile {
    memberId
    familyName
    givenName
    familyNameKana
    givenNameKana
    tel
    age
    subjects {
      name
    }
    userAttribute {
      occupation
      industry
      jobTitle
      position
      annualIncome
    }
  }
  customerServices {
    serviceKindName
  }
  registration {
    eventKey
  }
}
    `;
export const CustomerCsvDownloadsFragmentDoc = gql`
    fragment CustomerCsvDownloads on Customers {
  totalCount
  nodes {
    ...CustomerCsvRow
  }
}
    ${CustomerCsvRowFragmentDoc}`;
export const DiscountsFragmentDoc = gql`
    fragment Discounts on Discounts {
  totalCount
  nodes {
    id
    type
    code
    name
    description
    priceValue
    priceValueNoTax
    durationMonths
    startedAt
    endedAt
  }
}
    `;
export const VideoLessonCardFragmentDoc = gql`
    fragment VideoLessonCard on VideoLesson {
  id
  name
  publishedAt
  closedAt
  field {
    alias
  }
  alias
}
    `;
export const ExpertCardFragmentDoc = gql`
    fragment ExpertCard on Expert {
  id
  familyName
  givenName
  profilePhoto
  publishedAt
  videoLessons {
    ...VideoLessonCard
  }
}
    ${VideoLessonCardFragmentDoc}`;
export const ExpertDetailFragmentDoc = gql`
    fragment ExpertDetail on Expert {
  id
  familyName
  givenName
  familyNameKana
  givenNameKana
  company
  position
  title
  career
  alias
  profilePhoto
  headshot
  alt
  publishedAt
  closedAt
  booksListText
  siteUrl
  twitterUrl
  facebookUrl
  instagramUrl
  youtubeUrl
  wikipediaUrl
}
    `;
export const FeaturedVideoEditFragmentDoc = gql`
    fragment FeaturedVideoEdit on FeaturedVideo {
  id
  name
  order
  path
  fileName
  thumbnailUrl
}
    `;
export const ParticipantTableRowFragmentDoc = gql`
    fragment ParticipantTableRow on Participant {
  customerId
  gender
  age
  grade
  applicatedAt
}
    `;
export const ParticipantTableFragmentDoc = gql`
    fragment ParticipantTable on Participants {
  totalCount
  nodes {
    ...ParticipantTableRow
  }
}
    ${ParticipantTableRowFragmentDoc}`;
export const LessonParticipantsPageItemFragmentDoc = gql`
    fragment LessonParticipantsPageItem on Lesson {
  id
  startedAt
  endedAt
  participantsCount
  lessonMaster {
    id
    order
    name
  }
  clazz {
    id
    systemId
    name
    capacity
    course {
      id
      systemId
      name
    }
  }
}
    `;
export const LessonItemRowFragmentDoc = gql`
    fragment LessonItemRow on Lesson {
  id
  lessonUrl
  startedAt
  endedAt
  locationType
  lessonUrl
  zoomStartUrl
  participantsCount
  lessonMaster {
    id
    order
    name
  }
  clazz {
    id
    systemId
    name
    capacity
    applicantCountVisibility
    course {
      id
      systemId
      name
      teachingMaterials {
        id
        name
        url
      }
    }
  }
}
    `;
export const LessonsResultsFragmentDoc = gql`
    fragment LessonsResults on Lessons {
  totalCount
  nodes {
    ...LessonItemRow
  }
}
    ${LessonItemRowFragmentDoc}`;
export const LessonsMeResultsFragmentDoc = gql`
    fragment LessonsMeResults on User {
  id
  familyName
  givenName
  roles {
    id
    name
  }
}
    `;
export const FieldCreateFragmentDoc = gql`
    fragment FieldCreate on Field {
  id
  name
  subTitle
  summary
  alias
}
    `;
export const FieldUpdateFragmentDoc = gql`
    fragment FieldUpdate on Field {
  id
  name
  subTitle
  summary
  alias
}
    `;
export const FieldsResultItemFragmentDoc = gql`
    fragment FieldsResultItem on Field {
  id
  name
  subTitle
  summary
  alias
}
    `;
export const FieldsResultFragmentDoc = gql`
    fragment FieldsResult on Fields {
  totalCount
  nodes {
    ...FieldsResultItem
  }
}
    ${FieldsResultItemFragmentDoc}`;
export const LevelCreateFragmentDoc = gql`
    fragment LevelCreate on Level {
  id
  systemId
  name
  status
}
    `;
export const LevelUpdateFragmentDoc = gql`
    fragment LevelUpdate on Level {
  id
  name
  status
}
    `;
export const MasterPageOrganizerFragmentDoc = gql`
    fragment MasterPageOrganizer on Organizer {
  id
  name
}
    `;
export const SubjectCreateFragmentDoc = gql`
    fragment SubjectCreate on Subject {
  id
  systemId
  name
  status
}
    `;
export const SubjectUpdateFragmentDoc = gql`
    fragment SubjectUpdate on Subject {
  id
  name
  status
}
    `;
export const SubjectsResultItemFragmentDoc = gql`
    fragment SubjectsResultItem on Subject {
  id
  systemId
  name
  status
}
    `;
export const SubjectsResultFragmentDoc = gql`
    fragment SubjectsResult on Subjects {
  totalCount
  nodes {
    ...SubjectsResultItem
  }
}
    ${SubjectsResultItemFragmentDoc}`;
export const MasterPageVideoTagFragmentDoc = gql`
    fragment MasterPageVideoTag on VideoTag {
  id
  name
  status
}
    `;
export const ContBillPaymentMismatchHeaderFragmentDoc = gql`
    fragment ContBillPaymentMismatchHeader on PaymentMismatch {
  id
  detectedDateTime
  type
  continueAccountId
}
    `;
export const ContBillPaymentDetailFragmentDoc = gql`
    fragment ContBillPaymentDetail on PaymentTransaction {
  id
  continueAccountId
  accountTimingKbn
  paymentDay
  firstPaymentDate
  paymtd
  price {
    initialValue
    value
  }
  order {
    id
    name
    systemId
    submittedAt
    canceledAt
    customer {
      id
      profile {
        id
        memberId
      }
    }
  }
}
    `;
export const ContBillPaymentMismatchMplStatusFragmentDoc = gql`
    fragment ContBillPaymentMismatchMplStatus on PaymentMismatchCsv {
  id
  authDateTime
  soldDateTime
  adjustedDateTime
  memberId
  serviceId
  auOneId
  tel
  openId
  payInfoNo
  continueAccountId
  memberManageNo
  commodity
  priceSign
  priceValue
  paymtd
  reserved1
  reserved2
  processType
  processDateTime
  cancelDateTime
  claimDateTime
  refundDateTime
  note
  resultCode
  reserved3
  serviceShortName
  reserved4
  status
}
    `;
export const ContBillPaymentMismatchDetailFragmentDoc = gql`
    fragment ContBillPaymentMismatchDetail on PaymentMismatch {
  ...ContBillPaymentMismatchHeader
  paymentTransaction {
    ...ContBillPaymentDetail
  }
  paymentMismatchCsvs {
    ...ContBillPaymentMismatchMplStatus
  }
}
    ${ContBillPaymentMismatchHeaderFragmentDoc}
${ContBillPaymentDetailFragmentDoc}
${ContBillPaymentMismatchMplStatusFragmentDoc}`;
export const ContBillPaymentMismatchesTableRowFragmentDoc = gql`
    fragment ContBillPaymentMismatchesTableRow on PaymentMismatch {
  id
  detectedDateTime
  type
  continueAccountId
}
    `;
export const ContBillPaymentMismatchResultsFragmentDoc = gql`
    fragment ContBillPaymentMismatchResults on ContBillPaymentMismatches {
  totalCount
  nodes {
    ...ContBillPaymentMismatchesTableRow
  }
}
    ${ContBillPaymentMismatchesTableRowFragmentDoc}`;
export const PaymentMismatchDetailFragmentDoc = gql`
    fragment PaymentMismatchDetail on PaymentMismatch {
  id
  payInfoNo
  handlingStatus
  detectedDateTime
  serviceId
  type
  payment {
    id
    payInfoNo
    orderId
    customerId
    memberId
    customerName
    customerNameKana
    contentName
    contentSytemId
    courseName
    courseSytemId
    typename
    priceValue
    priceValueNoTax
    paymentStatus
    submittedAt
    soldDateTime
    processDateTime
    clazzId
    updatedAt
    lessons {
      id
      startedAt
      endedAt
    }
  }
}
    `;
export const MismatchHandlingHistoryFragmentDoc = gql`
    fragment MismatchHandlingHistory on MismatchHandlingHistory {
  id
  handler {
    id
    userId
    familyName
    givenName
  }
  handlingStatus
  note
  createdAt
  updatedAt
}
    `;
export const PaymentMismatchCsvFragmentDoc = gql`
    fragment PaymentMismatchCsv on PaymentMismatchCsv {
  id
  authDateTime
  soldDateTime
  adjustedDateTime
  memberId
  serviceId
  tel
  auOneId
  openId
  payInfoNo
  continueAccountId
  memberManageNo
  commodity
  priceSign
  priceValue
  paymtd
  reserved1
  reserved2
}
    `;
export const PaymentMismatchesTableRowFragmentDoc = gql`
    fragment PaymentMismatchesTableRow on PaymentMismatchSummary {
  id
  payDataYYYYMMDD
  payInfoNo
  handlingStatus
  paymentStatus
  detectedDateTime
  type
  latestUpdatedAt
}
    `;
export const PaymentMismatchResultsFragmentDoc = gql`
    fragment PaymentMismatchResults on PaymentMismatches {
  totalCount
  nodes {
    ...PaymentMismatchesTableRow
  }
}
    ${PaymentMismatchesTableRowFragmentDoc}`;
export const PaymentDetailFragmentDoc = gql`
    fragment PaymentDetail on Payment {
  id
  payInfoNo
  orderId
  customerId
  memberId
  customerName
  customerNameKana
  contentName
  contentSytemId
  courseName
  courseSytemId
  typename
  priceValue
  priceValueNoTax
  paymentStatus
  gmoFirstPaymentStatus
  gmoRecurringPaymentStatus
  submittedAt
  soldDateTime
  processDateTime
  clazzId
  updatedAt
  planName
  lessons {
    id
    startedAt
    endedAt
  }
  cancelable
  receipt {
    expiredAt
    history {
      id
      url
      issuedAt
    }
  }
}
    `;
export const PaymentCourseClazzFragmentDoc = gql`
    fragment PaymentCourseClazz on Clazz {
  id
  lessons {
    id
    startedAt
  }
}
    `;
export const CourseNameRowFragmentDoc = gql`
    fragment CourseNameRow on Course {
  id
  systemId
  name
}
    `;
export const CourseNamesFragmentDoc = gql`
    fragment CourseNames on Courses {
  totalCount
  nodes {
    ...CourseNameRow
  }
}
    ${CourseNameRowFragmentDoc}`;
export const PaymentSearchPlanFragmentDoc = gql`
    fragment paymentSearchPlan on Plan {
  id
  name
  price {
    type
  }
}
    `;
export const PaymentsTableRowFragmentDoc = gql`
    fragment PaymentsTableRow on PaymentSummaryForDisplay {
  id
  payInfoNo
  typename
  orderId
  customerId
  contentName
  contentSytemId
  courseName
  courseSytemId
  planName
  priceValue
  priceValueNoTax
  paymentStatus
  gmoFirstPaymentStatus
  gmoRecurringPaymentStatus
  submittedAt
  soldDateTime
  payService
}
    `;
export const PaymentsSearchResultsFragmentDoc = gql`
    fragment PaymentsSearchResults on PaymentsForDisplay {
  totalCount
  nodes {
    ...PaymentsTableRow
  }
}
    ${PaymentsTableRowFragmentDoc}`;
export const PaymentsCsvRowFragmentDoc = gql`
    fragment PaymentsCsvRow on PaymentSummary {
  id
  payInfoNo
  typename
  orderId
  memberId
  customerName
  organizerName
  contentName
  contentSytemId
  courseName
  courseSytemId
  planName
  priceValue
  priceValueNoTax
  paymentStatus
  submittedAt
  soldDateTime
  payService
}
    `;
export const PaymentCsvDownloadsFragmentDoc = gql`
    fragment PaymentCsvDownloads on Payments {
  totalCount
  nodes {
    ...PaymentsCsvRow
  }
}
    ${PaymentsCsvRowFragmentDoc}`;
export const ProfileEditFragmentDoc = gql`
    fragment ProfileEdit on User {
  id
  userId
  familyName
  givenName
  familyNameKana
  givenNameKana
  email
  roles {
    id
    name
  }
  status
  tel
  gender
  birthday
  birthplace
  yearsOfTeaching
  message
  selfIntroduction
  hobby
  avator
  extra
  useableServiceKinds {
    id
    shortName
  }
}
    `;
export const PublishClazzFragmentDoc = gql`
    fragment PublishClazz on Clazz {
  id
  systemId
  name
  saleStartedAt
  saleEndedAt
  published
  lessons {
    id
    systemId
    lessonMaster {
      order
    }
    startedAt
    endedAt
  }
}
    `;
export const PublishPreviewTokenFragmentDoc = gql`
    fragment PublishPreviewToken on CoursePreviewToken {
  id
  token
}
    `;
export const PublishCoursesItemFragmentDoc = gql`
    fragment PublishCoursesItem on Course {
  id
  systemId
  name
  published
  clazzes {
    ...PublishClazz
  }
  previewToken {
    ...PublishPreviewToken
  }
}
    ${PublishClazzFragmentDoc}
${PublishPreviewTokenFragmentDoc}`;
export const PublishCoursesFragmentDoc = gql`
    fragment PublishCourses on Courses {
  totalCount
  nodes {
    ...PublishCoursesItem
  }
}
    ${PublishCoursesItemFragmentDoc}`;
export const AnsweredCoursesTableRowFragmentDoc = gql`
    fragment AnsweredCoursesTableRow on Course {
  id
  name
  systemId
  courseId
  questionnaires {
    id
    order
    title
    typename
    required
    options {
      id
      name
    }
    selectableNumber
    condition
    maxScale
    minLabel
    maxLabel
  }
}
    `;
export const AnsweredCoursesFragmentDoc = gql`
    fragment AnsweredCourses on Courses {
  totalCount
  nodes {
    ...AnsweredCoursesTableRow
  }
}
    ${AnsweredCoursesTableRowFragmentDoc}`;
export const QuestionnaireAnswerRowFragmentDoc = gql`
    fragment QuestionnaireAnswerRow on QuestionnaireAnswer {
  orderId
  submittedAt
  customer {
    id
    profile {
      id
      memberId
      familyName
      givenName
    }
  }
  clazz {
    id
    systemId
    name
  }
  course {
    id
    systemId
    name
  }
  answers {
    questionnaireId
    selectQuestionnaireOptionId
    multiSelectQuestionnaireOptionId
    freeTextValue
  }
}
    `;
export const QuestionnaireAnswersFragmentDoc = gql`
    fragment QuestionnaireAnswers on QuestionnaireAnswers {
  totalCount
  nodes {
    ...QuestionnaireAnswerRow
  }
}
    ${QuestionnaireAnswerRowFragmentDoc}`;
export const VideoRatingTableRowFragmentDoc = gql`
    fragment VideoRatingTableRow on VideoRatingSummary {
  video {
    name
  }
  rating
  ratingCount
}
    `;
export const VideoLessonRatingTableRowFragmentDoc = gql`
    fragment VideoLessonRatingTableRow on VideoLessonRatingSummary {
  videoLesson {
    id
    name
    expert {
      familyName
      givenName
    }
  }
  rating
  videoRatingSummaries {
    ...VideoRatingTableRow
  }
}
    ${VideoRatingTableRowFragmentDoc}`;
export const VideoLessonRatingSummariesFragmentDoc = gql`
    fragment VideoLessonRatingSummaries on VideoLessonRatingSummaries {
  totalCount
  nodes {
    ...VideoLessonRatingTableRow
  }
}
    ${VideoLessonRatingTableRowFragmentDoc}`;
export const VideoLessonRatingCsvFragmentDoc = gql`
    fragment VideoLessonRatingCsv on VideoLessonRatingDetails {
  totalCount
  nodes {
    id
    customer {
      id
      profile {
        gender
        age
        userAttribute {
          occupation
          industry
          jobTitle
          position
          annualIncome
        }
      }
    }
    videoLesson {
      id
      name
    }
    video {
      id
      name
      jStreamMId
    }
    rating
    freeTextValue
    createdAt
  }
}
    `;
export const ServiceInputFragmentDoc = gql`
    fragment ServiceInput on Service {
  id
  shortName
}
    `;
export const UsersEditPageFragmentDoc = gql`
    fragment UsersEditPage on User {
  id
  userId
  familyName
  givenName
  familyNameKana
  givenNameKana
  email
  roles {
    id
    name
  }
  status
  tel
  gender
  birthday
  birthplace
  yearsOfTeaching
  message
  selfIntroduction
  hobby
  avator
  extra
  useableServiceKinds {
    id
    shortName
  }
}
    `;
export const UserExternalNewFragmentDoc = gql`
    fragment UserExternalNew on User {
  id
  userId
}
    `;
export const UsersTableRowFragmentDoc = gql`
    fragment UsersTableRow on User {
  id
  userId
  familyName
  givenName
  useableServiceKinds {
    shortName
  }
  roles {
    name
  }
  status
  extra
}
    `;
export const UsersTableFragmentDoc = gql`
    fragment UsersTable on Users {
  totalCount
  nodes {
    ...UsersTableRow
  }
}
    ${UsersTableRowFragmentDoc}`;
export const VideoLessonDetailFragmentDoc = gql`
    fragment VideoLessonDetail on VideoLesson {
  id
  name
  description
  field {
    id
    name
  }
  fieldItemImg
  videoTag {
    id
    name
  }
  jStreamSampleMId
  videos {
    id
    name
    jStreamMId
  }
  publishedAt
  closedAt
  alias
}
    `;
export const FieldSelecterFragmentDoc = gql`
    fragment FieldSelecter on Field {
  id
  name
}
    `;
export const VideoTagSelecterFragmentDoc = gql`
    fragment VideoTagSelecter on VideoTag {
  id
  name
}
    `;
export const IsUserLoggedInDocument = gql`
    query IsUserLoggedIn {
  isLoggedIn @client
}
    `;

/**
 * __useIsUserLoggedInQuery__
 *
 * To run a query within a React component, call `useIsUserLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserLoggedInQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserLoggedInQuery(baseOptions?: Apollo.QueryHookOptions<IsUserLoggedInQuery, IsUserLoggedInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserLoggedInQuery, IsUserLoggedInQueryVariables>(IsUserLoggedInDocument, options);
      }
export function useIsUserLoggedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserLoggedInQuery, IsUserLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserLoggedInQuery, IsUserLoggedInQueryVariables>(IsUserLoggedInDocument, options);
        }
export type IsUserLoggedInQueryHookResult = ReturnType<typeof useIsUserLoggedInQuery>;
export type IsUserLoggedInLazyQueryHookResult = ReturnType<typeof useIsUserLoggedInLazyQuery>;
export type IsUserLoggedInQueryResult = Apollo.QueryResult<IsUserLoggedInQuery, IsUserLoggedInQueryVariables>;
export const CoursesForMultiSelectorDocument = gql`
    query CoursesForMultiSelector($filter: CoursesFilterInput, $offset: Int, $limit: Int) {
  courses(filter: $filter, offset: $offset, limit: $limit) {
    totalCount
    nodes {
      ...CourseSelectorRow
    }
  }
}
    ${CourseSelectorRowFragmentDoc}`;

/**
 * __useCoursesForMultiSelectorQuery__
 *
 * To run a query within a React component, call `useCoursesForMultiSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesForMultiSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesForMultiSelectorQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCoursesForMultiSelectorQuery(baseOptions?: Apollo.QueryHookOptions<CoursesForMultiSelectorQuery, CoursesForMultiSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesForMultiSelectorQuery, CoursesForMultiSelectorQueryVariables>(CoursesForMultiSelectorDocument, options);
      }
export function useCoursesForMultiSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesForMultiSelectorQuery, CoursesForMultiSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesForMultiSelectorQuery, CoursesForMultiSelectorQueryVariables>(CoursesForMultiSelectorDocument, options);
        }
export type CoursesForMultiSelectorQueryHookResult = ReturnType<typeof useCoursesForMultiSelectorQuery>;
export type CoursesForMultiSelectorLazyQueryHookResult = ReturnType<typeof useCoursesForMultiSelectorLazyQuery>;
export type CoursesForMultiSelectorQueryResult = Apollo.QueryResult<CoursesForMultiSelectorQuery, CoursesForMultiSelectorQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LevelsDocument = gql`
    query levels($filter: LevelFilterInput, $offset: Int, $limit: Int) {
  levels(filter: $filter, offset: $offset, limit: $limit) {
    ...LevelsResult
  }
}
    ${LevelsResultFragmentDoc}`;

/**
 * __useLevelsQuery__
 *
 * To run a query within a React component, call `useLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLevelsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLevelsQuery(baseOptions?: Apollo.QueryHookOptions<LevelsQuery, LevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LevelsQuery, LevelsQueryVariables>(LevelsDocument, options);
      }
export function useLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LevelsQuery, LevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LevelsQuery, LevelsQueryVariables>(LevelsDocument, options);
        }
export type LevelsQueryHookResult = ReturnType<typeof useLevelsQuery>;
export type LevelsLazyQueryHookResult = ReturnType<typeof useLevelsLazyQuery>;
export type LevelsQueryResult = Apollo.QueryResult<LevelsQuery, LevelsQueryVariables>;
export const OrganizersDocument = gql`
    query organizers($filter: OrganizerFilterInput, $offset: Int, $limit: Int) {
  organizers(filter: $filter, offset: $offset, limit: $limit) {
    ...OrganizersResult
  }
}
    ${OrganizersResultFragmentDoc}`;

/**
 * __useOrganizersQuery__
 *
 * To run a query within a React component, call `useOrganizersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrganizersQuery(baseOptions?: Apollo.QueryHookOptions<OrganizersQuery, OrganizersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizersQuery, OrganizersQueryVariables>(OrganizersDocument, options);
      }
export function useOrganizersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizersQuery, OrganizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizersQuery, OrganizersQueryVariables>(OrganizersDocument, options);
        }
export type OrganizersQueryHookResult = ReturnType<typeof useOrganizersQuery>;
export type OrganizersLazyQueryHookResult = ReturnType<typeof useOrganizersLazyQuery>;
export type OrganizersQueryResult = Apollo.QueryResult<OrganizersQuery, OrganizersQueryVariables>;
export const AnnouncementPageDocument = gql`
    query AnnouncementPage($id: ID!) {
  announcement(id: $id) {
    id
    systemId
    kind
    subject
    body
    publishStartedAt
    publishEndedAt
  }
}
    `;

/**
 * __useAnnouncementPageQuery__
 *
 * To run a query within a React component, call `useAnnouncementPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementPageQuery(baseOptions: Apollo.QueryHookOptions<AnnouncementPageQuery, AnnouncementPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnnouncementPageQuery, AnnouncementPageQueryVariables>(AnnouncementPageDocument, options);
      }
export function useAnnouncementPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementPageQuery, AnnouncementPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnnouncementPageQuery, AnnouncementPageQueryVariables>(AnnouncementPageDocument, options);
        }
export type AnnouncementPageQueryHookResult = ReturnType<typeof useAnnouncementPageQuery>;
export type AnnouncementPageLazyQueryHookResult = ReturnType<typeof useAnnouncementPageLazyQuery>;
export type AnnouncementPageQueryResult = Apollo.QueryResult<AnnouncementPageQuery, AnnouncementPageQueryVariables>;
export const UpdateAnnouncementDocument = gql`
    mutation updateAnnouncement($input: UpdateAnnouncementInput!) {
  updateAnnouncement(input: $input) {
    id
  }
}
    `;
export type UpdateAnnouncementMutationFn = Apollo.MutationFunction<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument, options);
      }
export type UpdateAnnouncementMutationHookResult = ReturnType<typeof useUpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationResult = Apollo.MutationResult<UpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationOptions = Apollo.BaseMutationOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const AnnouncementsEditPageDocument = gql`
    query AnnouncementsEditPage($id: ID!) {
  announcement(id: $id) {
    ...AnnouncementForEditPage
  }
}
    ${AnnouncementForEditPageFragmentDoc}`;

/**
 * __useAnnouncementsEditPageQuery__
 *
 * To run a query within a React component, call `useAnnouncementsEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementsEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementsEditPageQuery(baseOptions: Apollo.QueryHookOptions<AnnouncementsEditPageQuery, AnnouncementsEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnnouncementsEditPageQuery, AnnouncementsEditPageQueryVariables>(AnnouncementsEditPageDocument, options);
      }
export function useAnnouncementsEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementsEditPageQuery, AnnouncementsEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnnouncementsEditPageQuery, AnnouncementsEditPageQueryVariables>(AnnouncementsEditPageDocument, options);
        }
export type AnnouncementsEditPageQueryHookResult = ReturnType<typeof useAnnouncementsEditPageQuery>;
export type AnnouncementsEditPageLazyQueryHookResult = ReturnType<typeof useAnnouncementsEditPageLazyQuery>;
export type AnnouncementsEditPageQueryResult = Apollo.QueryResult<AnnouncementsEditPageQuery, AnnouncementsEditPageQueryVariables>;
export const CreateAnnouncementDocument = gql`
    mutation createAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    id
  }
}
    `;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const AnnouncementsDocument = gql`
    query Announcements($offset: Int, $limit: Int) {
  announcements(offset: $offset, limit: $limit) {
    ...Announcements
  }
}
    ${AnnouncementsFragmentDoc}`;

/**
 * __useAnnouncementsQuery__
 *
 * To run a query within a React component, call `useAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, options);
      }
export function useAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, options);
        }
export type AnnouncementsQueryHookResult = ReturnType<typeof useAnnouncementsQuery>;
export type AnnouncementsLazyQueryHookResult = ReturnType<typeof useAnnouncementsLazyQuery>;
export type AnnouncementsQueryResult = Apollo.QueryResult<AnnouncementsQuery, AnnouncementsQueryVariables>;
export const UpdateSubjectOrdersDocument = gql`
    mutation updateSubjectOrders($input: UpdateSubjectOrdersInput!) {
  updateSubjectOrders(input: $input) {
    id
    order
  }
}
    `;
export type UpdateSubjectOrdersMutationFn = Apollo.MutationFunction<UpdateSubjectOrdersMutation, UpdateSubjectOrdersMutationVariables>;

/**
 * __useUpdateSubjectOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateSubjectOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubjectOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubjectOrdersMutation, { data, loading, error }] = useUpdateSubjectOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubjectOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubjectOrdersMutation, UpdateSubjectOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubjectOrdersMutation, UpdateSubjectOrdersMutationVariables>(UpdateSubjectOrdersDocument, options);
      }
export type UpdateSubjectOrdersMutationHookResult = ReturnType<typeof useUpdateSubjectOrdersMutation>;
export type UpdateSubjectOrdersMutationResult = Apollo.MutationResult<UpdateSubjectOrdersMutation>;
export type UpdateSubjectOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateSubjectOrdersMutation, UpdateSubjectOrdersMutationVariables>;
export const CategoriesSortPageDocument = gql`
    query CategoriesSortPage {
  activeSubjects {
    totalCount
    nodes {
      ...CategoriesDnDTableItem
    }
  }
}
    ${CategoriesDnDTableItemFragmentDoc}`;

/**
 * __useCategoriesSortPageQuery__
 *
 * To run a query within a React component, call `useCategoriesSortPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesSortPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesSortPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesSortPageQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesSortPageQuery, CategoriesSortPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesSortPageQuery, CategoriesSortPageQueryVariables>(CategoriesSortPageDocument, options);
      }
export function useCategoriesSortPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesSortPageQuery, CategoriesSortPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesSortPageQuery, CategoriesSortPageQueryVariables>(CategoriesSortPageDocument, options);
        }
export type CategoriesSortPageQueryHookResult = ReturnType<typeof useCategoriesSortPageQuery>;
export type CategoriesSortPageLazyQueryHookResult = ReturnType<typeof useCategoriesSortPageLazyQuery>;
export type CategoriesSortPageQueryResult = Apollo.QueryResult<CategoriesSortPageQuery, CategoriesSortPageQueryVariables>;
export const UpdateClassAndLessonsDocument = gql`
    mutation updateClassAndLessons($input: UpdateClassAndLessonsInput!) {
  updateClassAndLessons(input: $input) {
    ...ClassUpdateResult
  }
}
    ${ClassUpdateResultFragmentDoc}`;
export type UpdateClassAndLessonsMutationFn = Apollo.MutationFunction<UpdateClassAndLessonsMutation, UpdateClassAndLessonsMutationVariables>;

/**
 * __useUpdateClassAndLessonsMutation__
 *
 * To run a mutation, you first call `useUpdateClassAndLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassAndLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassAndLessonsMutation, { data, loading, error }] = useUpdateClassAndLessonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassAndLessonsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassAndLessonsMutation, UpdateClassAndLessonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassAndLessonsMutation, UpdateClassAndLessonsMutationVariables>(UpdateClassAndLessonsDocument, options);
      }
export type UpdateClassAndLessonsMutationHookResult = ReturnType<typeof useUpdateClassAndLessonsMutation>;
export type UpdateClassAndLessonsMutationResult = Apollo.MutationResult<UpdateClassAndLessonsMutation>;
export type UpdateClassAndLessonsMutationOptions = Apollo.BaseMutationOptions<UpdateClassAndLessonsMutation, UpdateClassAndLessonsMutationVariables>;
export const ClassEditPageDocument = gql`
    query ClassEditPage($id: ID!) {
  clazz: clazz(id: $id) {
    ...ClassForEditPage
  }
}
    ${ClassForEditPageFragmentDoc}`;

/**
 * __useClassEditPageQuery__
 *
 * To run a query within a React component, call `useClassEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassEditPageQuery(baseOptions: Apollo.QueryHookOptions<ClassEditPageQuery, ClassEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassEditPageQuery, ClassEditPageQueryVariables>(ClassEditPageDocument, options);
      }
export function useClassEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassEditPageQuery, ClassEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassEditPageQuery, ClassEditPageQueryVariables>(ClassEditPageDocument, options);
        }
export type ClassEditPageQueryHookResult = ReturnType<typeof useClassEditPageQuery>;
export type ClassEditPageLazyQueryHookResult = ReturnType<typeof useClassEditPageLazyQuery>;
export type ClassEditPageQueryResult = Apollo.QueryResult<ClassEditPageQuery, ClassEditPageQueryVariables>;
export const CreateClassAndLessonsDocument = gql`
    mutation createClassAndLessons($input: CreateClassAndLessonsInput!) {
  createClassAndLessons(input: $input) {
    ...ClassNewResult
  }
}
    ${ClassNewResultFragmentDoc}`;
export type CreateClassAndLessonsMutationFn = Apollo.MutationFunction<CreateClassAndLessonsMutation, CreateClassAndLessonsMutationVariables>;

/**
 * __useCreateClassAndLessonsMutation__
 *
 * To run a mutation, you first call `useCreateClassAndLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassAndLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassAndLessonsMutation, { data, loading, error }] = useCreateClassAndLessonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassAndLessonsMutation(baseOptions?: Apollo.MutationHookOptions<CreateClassAndLessonsMutation, CreateClassAndLessonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassAndLessonsMutation, CreateClassAndLessonsMutationVariables>(CreateClassAndLessonsDocument, options);
      }
export type CreateClassAndLessonsMutationHookResult = ReturnType<typeof useCreateClassAndLessonsMutation>;
export type CreateClassAndLessonsMutationResult = Apollo.MutationResult<CreateClassAndLessonsMutation>;
export type CreateClassAndLessonsMutationOptions = Apollo.BaseMutationOptions<CreateClassAndLessonsMutation, CreateClassAndLessonsMutationVariables>;
export const CourseForCreatingClassDocument = gql`
    query CourseForCreatingClass($id: ID!) {
  course(id: $id) {
    ...CourseForCreatingClass
  }
}
    ${CourseForCreatingClassFragmentDoc}`;

/**
 * __useCourseForCreatingClassQuery__
 *
 * To run a query within a React component, call `useCourseForCreatingClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseForCreatingClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseForCreatingClassQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseForCreatingClassQuery(baseOptions: Apollo.QueryHookOptions<CourseForCreatingClassQuery, CourseForCreatingClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseForCreatingClassQuery, CourseForCreatingClassQueryVariables>(CourseForCreatingClassDocument, options);
      }
export function useCourseForCreatingClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseForCreatingClassQuery, CourseForCreatingClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseForCreatingClassQuery, CourseForCreatingClassQueryVariables>(CourseForCreatingClassDocument, options);
        }
export type CourseForCreatingClassQueryHookResult = ReturnType<typeof useCourseForCreatingClassQuery>;
export type CourseForCreatingClassLazyQueryHookResult = ReturnType<typeof useCourseForCreatingClassLazyQuery>;
export type CourseForCreatingClassQueryResult = Apollo.QueryResult<CourseForCreatingClassQuery, CourseForCreatingClassQueryVariables>;
export const TeachersDocument = gql`
    query Teachers($filter: FilterInput) {
  teachers(filter: $filter) {
    ...TeachersTable
  }
}
    ${TeachersTableFragmentDoc}`;

/**
 * __useTeachersQuery__
 *
 * To run a query within a React component, call `useTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeachersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTeachersQuery(baseOptions?: Apollo.QueryHookOptions<TeachersQuery, TeachersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeachersQuery, TeachersQueryVariables>(TeachersDocument, options);
      }
export function useTeachersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeachersQuery, TeachersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeachersQuery, TeachersQueryVariables>(TeachersDocument, options);
        }
export type TeachersQueryHookResult = ReturnType<typeof useTeachersQuery>;
export type TeachersLazyQueryHookResult = ReturnType<typeof useTeachersLazyQuery>;
export type TeachersQueryResult = Apollo.QueryResult<TeachersQuery, TeachersQueryVariables>;
export const DeleteClazzAndLessonsDocument = gql`
    mutation deleteClazzAndLessons($input: DeleteClassAndLessonsInput!) {
  deleteClassAndLessons(input: $input)
}
    `;
export type DeleteClazzAndLessonsMutationFn = Apollo.MutationFunction<DeleteClazzAndLessonsMutation, DeleteClazzAndLessonsMutationVariables>;

/**
 * __useDeleteClazzAndLessonsMutation__
 *
 * To run a mutation, you first call `useDeleteClazzAndLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClazzAndLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClazzAndLessonsMutation, { data, loading, error }] = useDeleteClazzAndLessonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClazzAndLessonsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClazzAndLessonsMutation, DeleteClazzAndLessonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClazzAndLessonsMutation, DeleteClazzAndLessonsMutationVariables>(DeleteClazzAndLessonsDocument, options);
      }
export type DeleteClazzAndLessonsMutationHookResult = ReturnType<typeof useDeleteClazzAndLessonsMutation>;
export type DeleteClazzAndLessonsMutationResult = Apollo.MutationResult<DeleteClazzAndLessonsMutation>;
export type DeleteClazzAndLessonsMutationOptions = Apollo.BaseMutationOptions<DeleteClazzAndLessonsMutation, DeleteClazzAndLessonsMutationVariables>;
export const ClazzDocument = gql`
    query Clazz($id: ID!) {
  clazz(id: $id) {
    ...ClazzDetail
  }
}
    ${ClazzDetailFragmentDoc}`;

/**
 * __useClazzQuery__
 *
 * To run a query within a React component, call `useClazzQuery` and pass it any options that fit your needs.
 * When your component renders, `useClazzQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClazzQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClazzQuery(baseOptions: Apollo.QueryHookOptions<ClazzQuery, ClazzQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClazzQuery, ClazzQueryVariables>(ClazzDocument, options);
      }
export function useClazzLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClazzQuery, ClazzQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClazzQuery, ClazzQueryVariables>(ClazzDocument, options);
        }
export type ClazzQueryHookResult = ReturnType<typeof useClazzQuery>;
export type ClazzLazyQueryHookResult = ReturnType<typeof useClazzLazyQuery>;
export type ClazzQueryResult = Apollo.QueryResult<ClazzQuery, ClazzQueryVariables>;
export const DeleteContactPageDocument = gql`
    mutation deleteContactPage($id: ID!) {
  deleteContactLogically(id: $id)
}
    `;
export type DeleteContactPageMutationFn = Apollo.MutationFunction<DeleteContactPageMutation, DeleteContactPageMutationVariables>;

/**
 * __useDeleteContactPageMutation__
 *
 * To run a mutation, you first call `useDeleteContactPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactPageMutation, { data, loading, error }] = useDeleteContactPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactPageMutation, DeleteContactPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactPageMutation, DeleteContactPageMutationVariables>(DeleteContactPageDocument, options);
      }
export type DeleteContactPageMutationHookResult = ReturnType<typeof useDeleteContactPageMutation>;
export type DeleteContactPageMutationResult = Apollo.MutationResult<DeleteContactPageMutation>;
export type DeleteContactPageMutationOptions = Apollo.BaseMutationOptions<DeleteContactPageMutation, DeleteContactPageMutationVariables>;
export const ContactPageDocument = gql`
    query ContactPage($id: ID!) {
  contact(id: $id) {
    ...ContactPage
  }
  services {
    ...ContactServiceInput
  }
}
    ${ContactPageFragmentDoc}
${ContactServiceInputFragmentDoc}`;

/**
 * __useContactPageQuery__
 *
 * To run a query within a React component, call `useContactPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactPageQuery(baseOptions: Apollo.QueryHookOptions<ContactPageQuery, ContactPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPageQuery, ContactPageQueryVariables>(ContactPageDocument, options);
      }
export function useContactPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPageQuery, ContactPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPageQuery, ContactPageQueryVariables>(ContactPageDocument, options);
        }
export type ContactPageQueryHookResult = ReturnType<typeof useContactPageQuery>;
export type ContactPageLazyQueryHookResult = ReturnType<typeof useContactPageLazyQuery>;
export type ContactPageQueryResult = Apollo.QueryResult<ContactPageQuery, ContactPageQueryVariables>;
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...CreateContactResult
  }
}
    ${CreateContactResultFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateContactHistoryDocument = gql`
    mutation createContactHistory($input: CreateContactHistoryInput!) {
  createContactHistory(input: $input) {
    ...CreateContactHistoryResult
  }
}
    ${CreateContactHistoryResultFragmentDoc}`;
export type CreateContactHistoryMutationFn = Apollo.MutationFunction<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>;

/**
 * __useCreateContactHistoryMutation__
 *
 * To run a mutation, you first call `useCreateContactHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactHistoryMutation, { data, loading, error }] = useCreateContactHistoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>(CreateContactHistoryDocument, options);
      }
export type CreateContactHistoryMutationHookResult = ReturnType<typeof useCreateContactHistoryMutation>;
export type CreateContactHistoryMutationResult = Apollo.MutationResult<CreateContactHistoryMutation>;
export type CreateContactHistoryMutationOptions = Apollo.BaseMutationOptions<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>;
export const ContactSelectOptionsDocument = gql`
    query ContactSelectOptions {
  contactCategories {
    ...ContactCategory
  }
  services {
    ...ContactServiceInput
  }
}
    ${ContactCategoryFragmentDoc}
${ContactServiceInputFragmentDoc}`;

/**
 * __useContactSelectOptionsQuery__
 *
 * To run a query within a React component, call `useContactSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ContactSelectOptionsQuery, ContactSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactSelectOptionsQuery, ContactSelectOptionsQueryVariables>(ContactSelectOptionsDocument, options);
      }
export function useContactSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactSelectOptionsQuery, ContactSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactSelectOptionsQuery, ContactSelectOptionsQueryVariables>(ContactSelectOptionsDocument, options);
        }
export type ContactSelectOptionsQueryHookResult = ReturnType<typeof useContactSelectOptionsQuery>;
export type ContactSelectOptionsLazyQueryHookResult = ReturnType<typeof useContactSelectOptionsLazyQuery>;
export type ContactSelectOptionsQueryResult = Apollo.QueryResult<ContactSelectOptionsQuery, ContactSelectOptionsQueryVariables>;
export const CustomerSearchResultsDocument = gql`
    query CustomerSearchResults($filter: CustomerFilterInput, $offset: Int, $limit: Int) {
  customers(filter: $filter, offset: $offset, limit: $limit) {
    ...CustomerSearchResults
  }
  hasAdminAuthority
}
    ${CustomerSearchResultsFragmentDoc}`;

/**
 * __useCustomerSearchResultsQuery__
 *
 * To run a query within a React component, call `useCustomerSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSearchResultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerSearchResultsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerSearchResultsQuery, CustomerSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSearchResultsQuery, CustomerSearchResultsQueryVariables>(CustomerSearchResultsDocument, options);
      }
export function useCustomerSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSearchResultsQuery, CustomerSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSearchResultsQuery, CustomerSearchResultsQueryVariables>(CustomerSearchResultsDocument, options);
        }
export type CustomerSearchResultsQueryHookResult = ReturnType<typeof useCustomerSearchResultsQuery>;
export type CustomerSearchResultsLazyQueryHookResult = ReturnType<typeof useCustomerSearchResultsLazyQuery>;
export type CustomerSearchResultsQueryResult = Apollo.QueryResult<CustomerSearchResultsQuery, CustomerSearchResultsQueryVariables>;
export const ContactsDocument = gql`
    query Contacts($offset: Int, $limit: Int) {
  contactsForDisplay(offset: $offset, limit: $limit) {
    ...Contacts
  }
  hasAdminAuthority
}
    ${ContactsFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const ContactCsvDownloadsDocument = gql`
    query ContactCsvDownloads($offset: Int, $limit: Int) {
  contacts(offset: $offset, limit: $limit) {
    ...ContactCsvDownloads
  }
}
    ${ContactCsvDownloadsFragmentDoc}`;

/**
 * __useContactCsvDownloadsQuery__
 *
 * To run a query within a React component, call `useContactCsvDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCsvDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCsvDownloadsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactCsvDownloadsQuery(baseOptions?: Apollo.QueryHookOptions<ContactCsvDownloadsQuery, ContactCsvDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCsvDownloadsQuery, ContactCsvDownloadsQueryVariables>(ContactCsvDownloadsDocument, options);
      }
export function useContactCsvDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCsvDownloadsQuery, ContactCsvDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCsvDownloadsQuery, ContactCsvDownloadsQueryVariables>(ContactCsvDownloadsDocument, options);
        }
export type ContactCsvDownloadsQueryHookResult = ReturnType<typeof useContactCsvDownloadsQuery>;
export type ContactCsvDownloadsLazyQueryHookResult = ReturnType<typeof useContactCsvDownloadsLazyQuery>;
export type ContactCsvDownloadsQueryResult = Apollo.QueryResult<ContactCsvDownloadsQuery, ContactCsvDownloadsQueryVariables>;
export const UploadCorporationCsvDocument = gql`
    mutation uploadCorporationCsv($input: UploadCorporationCsvInput!) {
  uploadCorporationCsv(input: $input) {
    corporationCsvId
  }
}
    `;
export type UploadCorporationCsvMutationFn = Apollo.MutationFunction<UploadCorporationCsvMutation, UploadCorporationCsvMutationVariables>;

/**
 * __useUploadCorporationCsvMutation__
 *
 * To run a mutation, you first call `useUploadCorporationCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCorporationCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCorporationCsvMutation, { data, loading, error }] = useUploadCorporationCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCorporationCsvMutation(baseOptions?: Apollo.MutationHookOptions<UploadCorporationCsvMutation, UploadCorporationCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCorporationCsvMutation, UploadCorporationCsvMutationVariables>(UploadCorporationCsvDocument, options);
      }
export type UploadCorporationCsvMutationHookResult = ReturnType<typeof useUploadCorporationCsvMutation>;
export type UploadCorporationCsvMutationResult = Apollo.MutationResult<UploadCorporationCsvMutation>;
export type UploadCorporationCsvMutationOptions = Apollo.BaseMutationOptions<UploadCorporationCsvMutation, UploadCorporationCsvMutationVariables>;
export const CorporationPageDocument = gql`
    query CorporationPage($page: Int!, $filter: CorporationCsvUploadHistoryFilterInput) {
  corporationCsvUploadHistory(page: $page, filter: $filter) {
    ...CorporationPageHistory
  }
}
    ${CorporationPageHistoryFragmentDoc}`;

/**
 * __useCorporationPageQuery__
 *
 * To run a query within a React component, call `useCorporationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorporationPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCorporationPageQuery(baseOptions: Apollo.QueryHookOptions<CorporationPageQuery, CorporationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorporationPageQuery, CorporationPageQueryVariables>(CorporationPageDocument, options);
      }
export function useCorporationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorporationPageQuery, CorporationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorporationPageQuery, CorporationPageQueryVariables>(CorporationPageDocument, options);
        }
export type CorporationPageQueryHookResult = ReturnType<typeof useCorporationPageQuery>;
export type CorporationPageLazyQueryHookResult = ReturnType<typeof useCorporationPageLazyQuery>;
export type CorporationPageQueryResult = Apollo.QueryResult<CorporationPageQuery, CorporationPageQueryVariables>;
export const UploadCorporationCsvCheckResultDocument = gql`
    query uploadCorporationCsvCheckResult($corporationCsvId: String!) {
  uploadCorporationCsvCheckResult(corporationCsvId: $corporationCsvId) {
    uploadResult
    fileName
    count
    failedCount
    filePath
  }
}
    `;

/**
 * __useUploadCorporationCsvCheckResultQuery__
 *
 * To run a query within a React component, call `useUploadCorporationCsvCheckResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadCorporationCsvCheckResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadCorporationCsvCheckResultQuery({
 *   variables: {
 *      corporationCsvId: // value for 'corporationCsvId'
 *   },
 * });
 */
export function useUploadCorporationCsvCheckResultQuery(baseOptions: Apollo.QueryHookOptions<UploadCorporationCsvCheckResultQuery, UploadCorporationCsvCheckResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadCorporationCsvCheckResultQuery, UploadCorporationCsvCheckResultQueryVariables>(UploadCorporationCsvCheckResultDocument, options);
      }
export function useUploadCorporationCsvCheckResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadCorporationCsvCheckResultQuery, UploadCorporationCsvCheckResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadCorporationCsvCheckResultQuery, UploadCorporationCsvCheckResultQueryVariables>(UploadCorporationCsvCheckResultDocument, options);
        }
export type UploadCorporationCsvCheckResultQueryHookResult = ReturnType<typeof useUploadCorporationCsvCheckResultQuery>;
export type UploadCorporationCsvCheckResultLazyQueryHookResult = ReturnType<typeof useUploadCorporationCsvCheckResultLazyQuery>;
export type UploadCorporationCsvCheckResultQueryResult = Apollo.QueryResult<UploadCorporationCsvCheckResultQuery, UploadCorporationCsvCheckResultQueryVariables>;
export const DeleteCourseDocument = gql`
    mutation deleteCourse($input: DeleteCourseInput!) {
  deleteCourse(input: $input)
}
    `;
export type DeleteCourseMutationFn = Apollo.MutationFunction<DeleteCourseMutation, DeleteCourseMutationVariables>;

/**
 * __useDeleteCourseMutation__
 *
 * To run a mutation, you first call `useDeleteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseMutation, { data, loading, error }] = useDeleteCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseMutation, DeleteCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseMutation, DeleteCourseMutationVariables>(DeleteCourseDocument, options);
      }
export type DeleteCourseMutationHookResult = ReturnType<typeof useDeleteCourseMutation>;
export type DeleteCourseMutationResult = Apollo.MutationResult<DeleteCourseMutation>;
export type DeleteCourseMutationOptions = Apollo.BaseMutationOptions<DeleteCourseMutation, DeleteCourseMutationVariables>;
export const CoursePageDocument = gql`
    query CoursePage($id: ID!) {
  course(id: $id) {
    ...CoursePage
  }
}
    ${CoursePageFragmentDoc}`;

/**
 * __useCoursePageQuery__
 *
 * To run a query within a React component, call `useCoursePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCoursePageQuery(baseOptions: Apollo.QueryHookOptions<CoursePageQuery, CoursePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursePageQuery, CoursePageQueryVariables>(CoursePageDocument, options);
      }
export function useCoursePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursePageQuery, CoursePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursePageQuery, CoursePageQueryVariables>(CoursePageDocument, options);
        }
export type CoursePageQueryHookResult = ReturnType<typeof useCoursePageQuery>;
export type CoursePageLazyQueryHookResult = ReturnType<typeof useCoursePageLazyQuery>;
export type CoursePageQueryResult = Apollo.QueryResult<CoursePageQuery, CoursePageQueryVariables>;
export const UpdateCourseDocument = gql`
    mutation updateCourse($input: UpdateCourseInput!) {
  updateCourse(input: $input) {
    ...CourseEditConfirm
  }
}
    ${CourseEditConfirmFragmentDoc}`;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const DeleteCourseTeachingMaterialsDocument = gql`
    mutation deleteCourseTeachingMaterials($input: DeleteTeachingMaterialsInput!) {
  deleteTeachingMaterials(input: $input)
}
    `;
export type DeleteCourseTeachingMaterialsMutationFn = Apollo.MutationFunction<DeleteCourseTeachingMaterialsMutation, DeleteCourseTeachingMaterialsMutationVariables>;

/**
 * __useDeleteCourseTeachingMaterialsMutation__
 *
 * To run a mutation, you first call `useDeleteCourseTeachingMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseTeachingMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseTeachingMaterialsMutation, { data, loading, error }] = useDeleteCourseTeachingMaterialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCourseTeachingMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseTeachingMaterialsMutation, DeleteCourseTeachingMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseTeachingMaterialsMutation, DeleteCourseTeachingMaterialsMutationVariables>(DeleteCourseTeachingMaterialsDocument, options);
      }
export type DeleteCourseTeachingMaterialsMutationHookResult = ReturnType<typeof useDeleteCourseTeachingMaterialsMutation>;
export type DeleteCourseTeachingMaterialsMutationResult = Apollo.MutationResult<DeleteCourseTeachingMaterialsMutation>;
export type DeleteCourseTeachingMaterialsMutationOptions = Apollo.BaseMutationOptions<DeleteCourseTeachingMaterialsMutation, DeleteCourseTeachingMaterialsMutationVariables>;
export const DeleteLessonMasterTeachingMaterialsDocument = gql`
    mutation deleteLessonMasterTeachingMaterials($input: DeleteLessonMasterTeachingMaterialInput!) {
  deleteLessonMasterTeachingMaterials(input: $input)
}
    `;
export type DeleteLessonMasterTeachingMaterialsMutationFn = Apollo.MutationFunction<DeleteLessonMasterTeachingMaterialsMutation, DeleteLessonMasterTeachingMaterialsMutationVariables>;

/**
 * __useDeleteLessonMasterTeachingMaterialsMutation__
 *
 * To run a mutation, you first call `useDeleteLessonMasterTeachingMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLessonMasterTeachingMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLessonMasterTeachingMaterialsMutation, { data, loading, error }] = useDeleteLessonMasterTeachingMaterialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLessonMasterTeachingMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLessonMasterTeachingMaterialsMutation, DeleteLessonMasterTeachingMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLessonMasterTeachingMaterialsMutation, DeleteLessonMasterTeachingMaterialsMutationVariables>(DeleteLessonMasterTeachingMaterialsDocument, options);
      }
export type DeleteLessonMasterTeachingMaterialsMutationHookResult = ReturnType<typeof useDeleteLessonMasterTeachingMaterialsMutation>;
export type DeleteLessonMasterTeachingMaterialsMutationResult = Apollo.MutationResult<DeleteLessonMasterTeachingMaterialsMutation>;
export type DeleteLessonMasterTeachingMaterialsMutationOptions = Apollo.BaseMutationOptions<DeleteLessonMasterTeachingMaterialsMutation, DeleteLessonMasterTeachingMaterialsMutationVariables>;
export const DeleteCourseProductImagesDocument = gql`
    mutation deleteCourseProductImages($input: DeleteProductImagesInput!) {
  deleteProductImages(input: $input)
}
    `;
export type DeleteCourseProductImagesMutationFn = Apollo.MutationFunction<DeleteCourseProductImagesMutation, DeleteCourseProductImagesMutationVariables>;

/**
 * __useDeleteCourseProductImagesMutation__
 *
 * To run a mutation, you first call `useDeleteCourseProductImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseProductImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseProductImagesMutation, { data, loading, error }] = useDeleteCourseProductImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCourseProductImagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseProductImagesMutation, DeleteCourseProductImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseProductImagesMutation, DeleteCourseProductImagesMutationVariables>(DeleteCourseProductImagesDocument, options);
      }
export type DeleteCourseProductImagesMutationHookResult = ReturnType<typeof useDeleteCourseProductImagesMutation>;
export type DeleteCourseProductImagesMutationResult = Apollo.MutationResult<DeleteCourseProductImagesMutation>;
export type DeleteCourseProductImagesMutationOptions = Apollo.BaseMutationOptions<DeleteCourseProductImagesMutation, DeleteCourseProductImagesMutationVariables>;
export const UpdateCourseImageOrdersDocument = gql`
    mutation updateCourseImageOrders($input: UpdateCourseImageOrdersInput!) {
  updateCourseImageOrders(input: $input) {
    id
    order
  }
}
    `;
export type UpdateCourseImageOrdersMutationFn = Apollo.MutationFunction<UpdateCourseImageOrdersMutation, UpdateCourseImageOrdersMutationVariables>;

/**
 * __useUpdateCourseImageOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateCourseImageOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseImageOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseImageOrdersMutation, { data, loading, error }] = useUpdateCourseImageOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseImageOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseImageOrdersMutation, UpdateCourseImageOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseImageOrdersMutation, UpdateCourseImageOrdersMutationVariables>(UpdateCourseImageOrdersDocument, options);
      }
export type UpdateCourseImageOrdersMutationHookResult = ReturnType<typeof useUpdateCourseImageOrdersMutation>;
export type UpdateCourseImageOrdersMutationResult = Apollo.MutationResult<UpdateCourseImageOrdersMutation>;
export type UpdateCourseImageOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateCourseImageOrdersMutation, UpdateCourseImageOrdersMutationVariables>;
export const CoursesEditPageDocument = gql`
    query CoursesEditPage($id: ID!, $selectorsLimit: Int) {
  course: course(id: $id) {
    ...CourseForEditPage
  }
  organizers: organizers(offset: 0, limit: $selectorsLimit) {
    totalCount
    nodes {
      ...Organizer
    }
  }
  subjects: subjects(filter: {active: true}, offset: 0, limit: $selectorsLimit) {
    totalCount
    nodes {
      ...SubjectSelectorItem
    }
  }
  levels: levels(filter: {active: true}, offset: 0, limit: $selectorsLimit) {
    totalCount
    nodes {
      ...Level
    }
  }
}
    ${CourseForEditPageFragmentDoc}
${OrganizerFragmentDoc}
${SubjectSelectorItemFragmentDoc}
${LevelFragmentDoc}`;

/**
 * __useCoursesEditPageQuery__
 *
 * To run a query within a React component, call `useCoursesEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      selectorsLimit: // value for 'selectorsLimit'
 *   },
 * });
 */
export function useCoursesEditPageQuery(baseOptions: Apollo.QueryHookOptions<CoursesEditPageQuery, CoursesEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesEditPageQuery, CoursesEditPageQueryVariables>(CoursesEditPageDocument, options);
      }
export function useCoursesEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesEditPageQuery, CoursesEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesEditPageQuery, CoursesEditPageQueryVariables>(CoursesEditPageDocument, options);
        }
export type CoursesEditPageQueryHookResult = ReturnType<typeof useCoursesEditPageQuery>;
export type CoursesEditPageLazyQueryHookResult = ReturnType<typeof useCoursesEditPageLazyQuery>;
export type CoursesEditPageQueryResult = Apollo.QueryResult<CoursesEditPageQuery, CoursesEditPageQueryVariables>;
export const CreateCourseDocument = gql`
    mutation createCourse($input: CreateCourseInput!) {
  createCourse(input: $input) {
    ...CourseNew
  }
}
    ${CourseNewFragmentDoc}`;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = Apollo.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const GenerateUploadCourseTeachingMaterialUrlDocument = gql`
    mutation generateUploadCourseTeachingMaterialUrl($courseId: ID!, $fileName: String!) {
  generateUploadCourseTeachingMaterialUrl(
    courseId: $courseId
    fileName: $fileName
  ) {
    url
    fields
  }
}
    `;
export type GenerateUploadCourseTeachingMaterialUrlMutationFn = Apollo.MutationFunction<GenerateUploadCourseTeachingMaterialUrlMutation, GenerateUploadCourseTeachingMaterialUrlMutationVariables>;

/**
 * __useGenerateUploadCourseTeachingMaterialUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadCourseTeachingMaterialUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadCourseTeachingMaterialUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadCourseTeachingMaterialUrlMutation, { data, loading, error }] = useGenerateUploadCourseTeachingMaterialUrlMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGenerateUploadCourseTeachingMaterialUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadCourseTeachingMaterialUrlMutation, GenerateUploadCourseTeachingMaterialUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadCourseTeachingMaterialUrlMutation, GenerateUploadCourseTeachingMaterialUrlMutationVariables>(GenerateUploadCourseTeachingMaterialUrlDocument, options);
      }
export type GenerateUploadCourseTeachingMaterialUrlMutationHookResult = ReturnType<typeof useGenerateUploadCourseTeachingMaterialUrlMutation>;
export type GenerateUploadCourseTeachingMaterialUrlMutationResult = Apollo.MutationResult<GenerateUploadCourseTeachingMaterialUrlMutation>;
export type GenerateUploadCourseTeachingMaterialUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadCourseTeachingMaterialUrlMutation, GenerateUploadCourseTeachingMaterialUrlMutationVariables>;
export const GenerateUploadLessonMasterTeachingMaterialUrlDocument = gql`
    mutation generateUploadLessonMasterTeachingMaterialUrl($lessonMasterId: ID!, $fileName: String!) {
  generateUploadLessonMasterTeachingMaterialUrl(
    lessonMasterId: $lessonMasterId
    fileName: $fileName
  ) {
    url
    fields
  }
}
    `;
export type GenerateUploadLessonMasterTeachingMaterialUrlMutationFn = Apollo.MutationFunction<GenerateUploadLessonMasterTeachingMaterialUrlMutation, GenerateUploadLessonMasterTeachingMaterialUrlMutationVariables>;

/**
 * __useGenerateUploadLessonMasterTeachingMaterialUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadLessonMasterTeachingMaterialUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadLessonMasterTeachingMaterialUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadLessonMasterTeachingMaterialUrlMutation, { data, loading, error }] = useGenerateUploadLessonMasterTeachingMaterialUrlMutation({
 *   variables: {
 *      lessonMasterId: // value for 'lessonMasterId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGenerateUploadLessonMasterTeachingMaterialUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadLessonMasterTeachingMaterialUrlMutation, GenerateUploadLessonMasterTeachingMaterialUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadLessonMasterTeachingMaterialUrlMutation, GenerateUploadLessonMasterTeachingMaterialUrlMutationVariables>(GenerateUploadLessonMasterTeachingMaterialUrlDocument, options);
      }
export type GenerateUploadLessonMasterTeachingMaterialUrlMutationHookResult = ReturnType<typeof useGenerateUploadLessonMasterTeachingMaterialUrlMutation>;
export type GenerateUploadLessonMasterTeachingMaterialUrlMutationResult = Apollo.MutationResult<GenerateUploadLessonMasterTeachingMaterialUrlMutation>;
export type GenerateUploadLessonMasterTeachingMaterialUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadLessonMasterTeachingMaterialUrlMutation, GenerateUploadLessonMasterTeachingMaterialUrlMutationVariables>;
export const GenerateUploadCourseImageUrlDocument = gql`
    mutation generateUploadCourseImageUrl($courseId: ID!, $fileName: String!, $order: Int!, $courseImageId: ID) {
  generateUploadCourseImageUrl(
    courseId: $courseId
    fileName: $fileName
    order: $order
    courseImageId: $courseImageId
  ) {
    url
    fields
  }
}
    `;
export type GenerateUploadCourseImageUrlMutationFn = Apollo.MutationFunction<GenerateUploadCourseImageUrlMutation, GenerateUploadCourseImageUrlMutationVariables>;

/**
 * __useGenerateUploadCourseImageUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadCourseImageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadCourseImageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadCourseImageUrlMutation, { data, loading, error }] = useGenerateUploadCourseImageUrlMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      fileName: // value for 'fileName'
 *      order: // value for 'order'
 *      courseImageId: // value for 'courseImageId'
 *   },
 * });
 */
export function useGenerateUploadCourseImageUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadCourseImageUrlMutation, GenerateUploadCourseImageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadCourseImageUrlMutation, GenerateUploadCourseImageUrlMutationVariables>(GenerateUploadCourseImageUrlDocument, options);
      }
export type GenerateUploadCourseImageUrlMutationHookResult = ReturnType<typeof useGenerateUploadCourseImageUrlMutation>;
export type GenerateUploadCourseImageUrlMutationResult = Apollo.MutationResult<GenerateUploadCourseImageUrlMutation>;
export type GenerateUploadCourseImageUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadCourseImageUrlMutation, GenerateUploadCourseImageUrlMutationVariables>;
export const CoursesNewPageDocument = gql`
    query CoursesNewPage($selectorsLimit: Int) {
  organizers: organizers(offset: 0, limit: $selectorsLimit) {
    totalCount
    nodes {
      ...Organizer
    }
  }
  subjects: subjects(filter: {active: true}, offset: 0, limit: $selectorsLimit) {
    totalCount
    nodes {
      ...SubjectSelectorItem
    }
  }
  levels: levels(filter: {active: true}, offset: 0, limit: $selectorsLimit) {
    totalCount
    nodes {
      ...Level
    }
  }
}
    ${OrganizerFragmentDoc}
${SubjectSelectorItemFragmentDoc}
${LevelFragmentDoc}`;

/**
 * __useCoursesNewPageQuery__
 *
 * To run a query within a React component, call `useCoursesNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesNewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesNewPageQuery({
 *   variables: {
 *      selectorsLimit: // value for 'selectorsLimit'
 *   },
 * });
 */
export function useCoursesNewPageQuery(baseOptions?: Apollo.QueryHookOptions<CoursesNewPageQuery, CoursesNewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesNewPageQuery, CoursesNewPageQueryVariables>(CoursesNewPageDocument, options);
      }
export function useCoursesNewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesNewPageQuery, CoursesNewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesNewPageQuery, CoursesNewPageQueryVariables>(CoursesNewPageDocument, options);
        }
export type CoursesNewPageQueryHookResult = ReturnType<typeof useCoursesNewPageQuery>;
export type CoursesNewPageLazyQueryHookResult = ReturnType<typeof useCoursesNewPageLazyQuery>;
export type CoursesNewPageQueryResult = Apollo.QueryResult<CoursesNewPageQuery, CoursesNewPageQueryVariables>;
export const CoursesForCoursesPageDocument = gql`
    query CoursesForCoursesPage($filter: CoursesFilterInput, $offset: Int, $limit: Int) {
  courses(filter: $filter, offset: $offset, limit: $limit) {
    ...Courses
  }
}
    ${CoursesFragmentDoc}`;

/**
 * __useCoursesForCoursesPageQuery__
 *
 * To run a query within a React component, call `useCoursesForCoursesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesForCoursesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesForCoursesPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCoursesForCoursesPageQuery(baseOptions?: Apollo.QueryHookOptions<CoursesForCoursesPageQuery, CoursesForCoursesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesForCoursesPageQuery, CoursesForCoursesPageQueryVariables>(CoursesForCoursesPageDocument, options);
      }
export function useCoursesForCoursesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesForCoursesPageQuery, CoursesForCoursesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesForCoursesPageQuery, CoursesForCoursesPageQueryVariables>(CoursesForCoursesPageDocument, options);
        }
export type CoursesForCoursesPageQueryHookResult = ReturnType<typeof useCoursesForCoursesPageQuery>;
export type CoursesForCoursesPageLazyQueryHookResult = ReturnType<typeof useCoursesForCoursesPageLazyQuery>;
export type CoursesForCoursesPageQueryResult = Apollo.QueryResult<CoursesForCoursesPageQuery, CoursesForCoursesPageQueryVariables>;
export const UpdateCourseOrdersDocument = gql`
    mutation updateCourseOrders($input: UpdateCourseOrdersInput!) {
  updateCourseOrders(input: $input) {
    id
    order
  }
}
    `;
export type UpdateCourseOrdersMutationFn = Apollo.MutationFunction<UpdateCourseOrdersMutation, UpdateCourseOrdersMutationVariables>;

/**
 * __useUpdateCourseOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateCourseOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseOrdersMutation, { data, loading, error }] = useUpdateCourseOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseOrdersMutation, UpdateCourseOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseOrdersMutation, UpdateCourseOrdersMutationVariables>(UpdateCourseOrdersDocument, options);
      }
export type UpdateCourseOrdersMutationHookResult = ReturnType<typeof useUpdateCourseOrdersMutation>;
export type UpdateCourseOrdersMutationResult = Apollo.MutationResult<UpdateCourseOrdersMutation>;
export type UpdateCourseOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateCourseOrdersMutation, UpdateCourseOrdersMutationVariables>;
export const CoursesSortPageDocument = gql`
    query CoursesSortPage {
  publishedCourses {
    totalCount
    nodes {
      ...CoursesDnDTableItem
    }
  }
}
    ${CoursesDnDTableItemFragmentDoc}`;

/**
 * __useCoursesSortPageQuery__
 *
 * To run a query within a React component, call `useCoursesSortPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesSortPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesSortPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoursesSortPageQuery(baseOptions?: Apollo.QueryHookOptions<CoursesSortPageQuery, CoursesSortPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesSortPageQuery, CoursesSortPageQueryVariables>(CoursesSortPageDocument, options);
      }
export function useCoursesSortPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesSortPageQuery, CoursesSortPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesSortPageQuery, CoursesSortPageQueryVariables>(CoursesSortPageDocument, options);
        }
export type CoursesSortPageQueryHookResult = ReturnType<typeof useCoursesSortPageQuery>;
export type CoursesSortPageLazyQueryHookResult = ReturnType<typeof useCoursesSortPageLazyQuery>;
export type CoursesSortPageQueryResult = Apollo.QueryResult<CoursesSortPageQuery, CoursesSortPageQueryVariables>;
export const CustomerBillingSearchResultsDocument = gql`
    query CustomerBillingSearchResults($filter: BillingCustomerFilterInput, $offset: Int, $limit: Int) {
  billingCustomers(filter: $filter, offset: $offset, limit: $limit) {
    ...CustomerBillingSearchResults
  }
  hasAdminAuthority
}
    ${CustomerBillingSearchResultsFragmentDoc}`;

/**
 * __useCustomerBillingSearchResultsQuery__
 *
 * To run a query within a React component, call `useCustomerBillingSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerBillingSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerBillingSearchResultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerBillingSearchResultsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerBillingSearchResultsQuery, CustomerBillingSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerBillingSearchResultsQuery, CustomerBillingSearchResultsQueryVariables>(CustomerBillingSearchResultsDocument, options);
      }
export function useCustomerBillingSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerBillingSearchResultsQuery, CustomerBillingSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerBillingSearchResultsQuery, CustomerBillingSearchResultsQueryVariables>(CustomerBillingSearchResultsDocument, options);
        }
export type CustomerBillingSearchResultsQueryHookResult = ReturnType<typeof useCustomerBillingSearchResultsQuery>;
export type CustomerBillingSearchResultsLazyQueryHookResult = ReturnType<typeof useCustomerBillingSearchResultsLazyQuery>;
export type CustomerBillingSearchResultsQueryResult = Apollo.QueryResult<CustomerBillingSearchResultsQuery, CustomerBillingSearchResultsQueryVariables>;
export const CustomerBillingCsvDownloadDocument = gql`
    query CustomerBillingCsvDownload($filter: BillingCustomerFilterInput, $offset: Int, $limit: Int) {
  billingCustomers(filter: $filter, offset: $offset, limit: $limit) {
    ...CustomerBillingSearchResultsCsv
  }
}
    ${CustomerBillingSearchResultsCsvFragmentDoc}`;

/**
 * __useCustomerBillingCsvDownloadQuery__
 *
 * To run a query within a React component, call `useCustomerBillingCsvDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerBillingCsvDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerBillingCsvDownloadQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerBillingCsvDownloadQuery(baseOptions?: Apollo.QueryHookOptions<CustomerBillingCsvDownloadQuery, CustomerBillingCsvDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerBillingCsvDownloadQuery, CustomerBillingCsvDownloadQueryVariables>(CustomerBillingCsvDownloadDocument, options);
      }
export function useCustomerBillingCsvDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerBillingCsvDownloadQuery, CustomerBillingCsvDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerBillingCsvDownloadQuery, CustomerBillingCsvDownloadQueryVariables>(CustomerBillingCsvDownloadDocument, options);
        }
export type CustomerBillingCsvDownloadQueryHookResult = ReturnType<typeof useCustomerBillingCsvDownloadQuery>;
export type CustomerBillingCsvDownloadLazyQueryHookResult = ReturnType<typeof useCustomerBillingCsvDownloadLazyQuery>;
export type CustomerBillingCsvDownloadQueryResult = Apollo.QueryResult<CustomerBillingCsvDownloadQuery, CustomerBillingCsvDownloadQueryVariables>;
export const CreateCustomerNoteDocument = gql`
    mutation createCustomerNote($input: CreateCustomerNoteInput!) {
  createCustomerNote(input: $input) {
    note
  }
}
    `;
export type CreateCustomerNoteMutationFn = Apollo.MutationFunction<CreateCustomerNoteMutation, CreateCustomerNoteMutationVariables>;

/**
 * __useCreateCustomerNoteMutation__
 *
 * To run a mutation, you first call `useCreateCustomerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerNoteMutation, { data, loading, error }] = useCreateCustomerNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerNoteMutation, CreateCustomerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerNoteMutation, CreateCustomerNoteMutationVariables>(CreateCustomerNoteDocument, options);
      }
export type CreateCustomerNoteMutationHookResult = ReturnType<typeof useCreateCustomerNoteMutation>;
export type CreateCustomerNoteMutationResult = Apollo.MutationResult<CreateCustomerNoteMutation>;
export type CreateCustomerNoteMutationOptions = Apollo.BaseMutationOptions<CreateCustomerNoteMutation, CreateCustomerNoteMutationVariables>;
export const CustomerDocument = gql`
    query Customer($id: ID!) {
  customer(id: $id) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const ServicesDocument = gql`
    query Services {
  services {
    id
    key
    shortName
  }
}
    `;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesQuery(baseOptions?: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const CustomerIdsSearchResultDocument = gql`
    query CustomerIdsSearchResult($filter: CustomerFilterInput, $offset: Int, $limit: Int) {
  customersForDisplay(filter: $filter, offset: $offset, limit: $limit) {
    totalCount
    nodes {
      id
    }
  }
  hasAdminAuthority
}
    `;

/**
 * __useCustomerIdsSearchResultQuery__
 *
 * To run a query within a React component, call `useCustomerIdsSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerIdsSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerIdsSearchResultQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerIdsSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<CustomerIdsSearchResultQuery, CustomerIdsSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerIdsSearchResultQuery, CustomerIdsSearchResultQueryVariables>(CustomerIdsSearchResultDocument, options);
      }
export function useCustomerIdsSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerIdsSearchResultQuery, CustomerIdsSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerIdsSearchResultQuery, CustomerIdsSearchResultQueryVariables>(CustomerIdsSearchResultDocument, options);
        }
export type CustomerIdsSearchResultQueryHookResult = ReturnType<typeof useCustomerIdsSearchResultQuery>;
export type CustomerIdsSearchResultLazyQueryHookResult = ReturnType<typeof useCustomerIdsSearchResultLazyQuery>;
export type CustomerIdsSearchResultQueryResult = Apollo.QueryResult<CustomerIdsSearchResultQuery, CustomerIdsSearchResultQueryVariables>;
export const CustomerCsvDownloadsDocument = gql`
    query CustomerCsvDownloads($filter: CustomerFilterInput, $offset: Int, $limit: Int) {
  customers(filter: $filter, offset: $offset, limit: $limit) {
    ...CustomerCsvDownloads
  }
  hasAdminAuthority
}
    ${CustomerCsvDownloadsFragmentDoc}`;

/**
 * __useCustomerCsvDownloadsQuery__
 *
 * To run a query within a React component, call `useCustomerCsvDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCsvDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCsvDownloadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerCsvDownloadsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerCsvDownloadsQuery, CustomerCsvDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerCsvDownloadsQuery, CustomerCsvDownloadsQueryVariables>(CustomerCsvDownloadsDocument, options);
      }
export function useCustomerCsvDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerCsvDownloadsQuery, CustomerCsvDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerCsvDownloadsQuery, CustomerCsvDownloadsQueryVariables>(CustomerCsvDownloadsDocument, options);
        }
export type CustomerCsvDownloadsQueryHookResult = ReturnType<typeof useCustomerCsvDownloadsQuery>;
export type CustomerCsvDownloadsLazyQueryHookResult = ReturnType<typeof useCustomerCsvDownloadsLazyQuery>;
export type CustomerCsvDownloadsQueryResult = Apollo.QueryResult<CustomerCsvDownloadsQuery, CustomerCsvDownloadsQueryVariables>;
export const UpdateDiscountDocument = gql`
    mutation updateDiscount($input: UpdateDiscountInput!) {
  updateDiscount(input: $input) {
    id
  }
}
    `;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;

/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
      }
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const EditingDiscountDocument = gql`
    query EditingDiscount($id: ID!) {
  discount(id: $id) {
    id
    type
    code
    name
    description
    durationMonths
    priceValue
    priceValueNoTax
    startedAt
    endedAt
  }
  discountCourses(discountId: $id) {
    id
    systemId
    name
  }
}
    `;

/**
 * __useEditingDiscountQuery__
 *
 * To run a query within a React component, call `useEditingDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditingDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditingDiscountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditingDiscountQuery(baseOptions: Apollo.QueryHookOptions<EditingDiscountQuery, EditingDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditingDiscountQuery, EditingDiscountQueryVariables>(EditingDiscountDocument, options);
      }
export function useEditingDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditingDiscountQuery, EditingDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditingDiscountQuery, EditingDiscountQueryVariables>(EditingDiscountDocument, options);
        }
export type EditingDiscountQueryHookResult = ReturnType<typeof useEditingDiscountQuery>;
export type EditingDiscountLazyQueryHookResult = ReturnType<typeof useEditingDiscountLazyQuery>;
export type EditingDiscountQueryResult = Apollo.QueryResult<EditingDiscountQuery, EditingDiscountQueryVariables>;
export const CreateDiscountDocument = gql`
    mutation createDiscount($input: CreateDiscountInput!) {
  createDiscount(input: $input) {
    id
  }
}
    `;
export type CreateDiscountMutationFn = Apollo.MutationFunction<CreateDiscountMutation, CreateDiscountMutationVariables>;

/**
 * __useCreateDiscountMutation__
 *
 * To run a mutation, you first call `useCreateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountMutation, { data, loading, error }] = useCreateDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountMutation, CreateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountMutation, CreateDiscountMutationVariables>(CreateDiscountDocument, options);
      }
export type CreateDiscountMutationHookResult = ReturnType<typeof useCreateDiscountMutation>;
export type CreateDiscountMutationResult = Apollo.MutationResult<CreateDiscountMutation>;
export type CreateDiscountMutationOptions = Apollo.BaseMutationOptions<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const DeleteDiscountDocument = gql`
    mutation deleteDiscount($id: ID!) {
  deleteDiscount(id: $id) {
    id
  }
}
    `;
export type DeleteDiscountMutationFn = Apollo.MutationFunction<DeleteDiscountMutation, DeleteDiscountMutationVariables>;

/**
 * __useDeleteDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountMutation, { data, loading, error }] = useDeleteDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountMutation, DeleteDiscountMutationVariables>(DeleteDiscountDocument, options);
      }
export type DeleteDiscountMutationHookResult = ReturnType<typeof useDeleteDiscountMutation>;
export type DeleteDiscountMutationResult = Apollo.MutationResult<DeleteDiscountMutation>;
export type DeleteDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>;
export const DiscountsDocument = gql`
    query Discounts($offset: Int, $limit: Int) {
  discounts(offset: $offset, limit: $limit) {
    ...Discounts
  }
}
    ${DiscountsFragmentDoc}`;

/**
 * __useDiscountsQuery__
 *
 * To run a query within a React component, call `useDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<DiscountsQuery, DiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountsQuery, DiscountsQueryVariables>(DiscountsDocument, options);
      }
export function useDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountsQuery, DiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountsQuery, DiscountsQueryVariables>(DiscountsDocument, options);
        }
export type DiscountsQueryHookResult = ReturnType<typeof useDiscountsQuery>;
export type DiscountsLazyQueryHookResult = ReturnType<typeof useDiscountsLazyQuery>;
export type DiscountsQueryResult = Apollo.QueryResult<DiscountsQuery, DiscountsQueryVariables>;
export const DiscountByCodeOnNewDocument = gql`
    query DiscountByCodeOnNew($code: String!) {
  discountByCode(code: $code) {
    id
    type
    code
    name
    description
    priceValue
    priceValueNoTax
    startedAt
    endedAt
  }
}
    `;

/**
 * __useDiscountByCodeOnNewQuery__
 *
 * To run a query within a React component, call `useDiscountByCodeOnNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountByCodeOnNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountByCodeOnNewQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useDiscountByCodeOnNewQuery(baseOptions: Apollo.QueryHookOptions<DiscountByCodeOnNewQuery, DiscountByCodeOnNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountByCodeOnNewQuery, DiscountByCodeOnNewQueryVariables>(DiscountByCodeOnNewDocument, options);
      }
export function useDiscountByCodeOnNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountByCodeOnNewQuery, DiscountByCodeOnNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountByCodeOnNewQuery, DiscountByCodeOnNewQueryVariables>(DiscountByCodeOnNewDocument, options);
        }
export type DiscountByCodeOnNewQueryHookResult = ReturnType<typeof useDiscountByCodeOnNewQuery>;
export type DiscountByCodeOnNewLazyQueryHookResult = ReturnType<typeof useDiscountByCodeOnNewLazyQuery>;
export type DiscountByCodeOnNewQueryResult = Apollo.QueryResult<DiscountByCodeOnNewQuery, DiscountByCodeOnNewQueryVariables>;
export const MaximumDiscountAmountDocument = gql`
    query MaximumDiscountAmount($serviceKindId: String!) {
  maximumDiscountAmount(serviceKindId: $serviceKindId)
}
    `;

/**
 * __useMaximumDiscountAmountQuery__
 *
 * To run a query within a React component, call `useMaximumDiscountAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaximumDiscountAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaximumDiscountAmountQuery({
 *   variables: {
 *      serviceKindId: // value for 'serviceKindId'
 *   },
 * });
 */
export function useMaximumDiscountAmountQuery(baseOptions: Apollo.QueryHookOptions<MaximumDiscountAmountQuery, MaximumDiscountAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaximumDiscountAmountQuery, MaximumDiscountAmountQueryVariables>(MaximumDiscountAmountDocument, options);
      }
export function useMaximumDiscountAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaximumDiscountAmountQuery, MaximumDiscountAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaximumDiscountAmountQuery, MaximumDiscountAmountQueryVariables>(MaximumDiscountAmountDocument, options);
        }
export type MaximumDiscountAmountQueryHookResult = ReturnType<typeof useMaximumDiscountAmountQuery>;
export type MaximumDiscountAmountLazyQueryHookResult = ReturnType<typeof useMaximumDiscountAmountLazyQuery>;
export type MaximumDiscountAmountQueryResult = Apollo.QueryResult<MaximumDiscountAmountQuery, MaximumDiscountAmountQueryVariables>;
export const UpdateExpertDocument = gql`
    mutation updateExpert($input: UpdateExpertInput!) {
  updateExpert(input: $input) {
    id
  }
}
    `;
export type UpdateExpertMutationFn = Apollo.MutationFunction<UpdateExpertMutation, UpdateExpertMutationVariables>;

/**
 * __useUpdateExpertMutation__
 *
 * To run a mutation, you first call `useUpdateExpertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertMutation, { data, loading, error }] = useUpdateExpertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertMutation, UpdateExpertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpertMutation, UpdateExpertMutationVariables>(UpdateExpertDocument, options);
      }
export type UpdateExpertMutationHookResult = ReturnType<typeof useUpdateExpertMutation>;
export type UpdateExpertMutationResult = Apollo.MutationResult<UpdateExpertMutation>;
export type UpdateExpertMutationOptions = Apollo.BaseMutationOptions<UpdateExpertMutation, UpdateExpertMutationVariables>;
export const GenerateUploadExpertImageUrlDocument = gql`
    mutation generateUploadExpertImageUrl($input: GenerateUploadExpertImageUrlInput!) {
  generateUploadExpertImageUrl(input: $input) {
    profilePhoto {
      url
      fields
    }
    headshot {
      url
      fields
    }
  }
}
    `;
export type GenerateUploadExpertImageUrlMutationFn = Apollo.MutationFunction<GenerateUploadExpertImageUrlMutation, GenerateUploadExpertImageUrlMutationVariables>;

/**
 * __useGenerateUploadExpertImageUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadExpertImageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadExpertImageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadExpertImageUrlMutation, { data, loading, error }] = useGenerateUploadExpertImageUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUploadExpertImageUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadExpertImageUrlMutation, GenerateUploadExpertImageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadExpertImageUrlMutation, GenerateUploadExpertImageUrlMutationVariables>(GenerateUploadExpertImageUrlDocument, options);
      }
export type GenerateUploadExpertImageUrlMutationHookResult = ReturnType<typeof useGenerateUploadExpertImageUrlMutation>;
export type GenerateUploadExpertImageUrlMutationResult = Apollo.MutationResult<GenerateUploadExpertImageUrlMutation>;
export type GenerateUploadExpertImageUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadExpertImageUrlMutation, GenerateUploadExpertImageUrlMutationVariables>;
export const ExpertEditPageDocument = gql`
    query ExpertEditPage($id: ID!) {
  expert(id: $id) {
    ...ExpertDetail
  }
}
    ${ExpertDetailFragmentDoc}`;

/**
 * __useExpertEditPageQuery__
 *
 * To run a query within a React component, call `useExpertEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertEditPageQuery(baseOptions: Apollo.QueryHookOptions<ExpertEditPageQuery, ExpertEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertEditPageQuery, ExpertEditPageQueryVariables>(ExpertEditPageDocument, options);
      }
export function useExpertEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertEditPageQuery, ExpertEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertEditPageQuery, ExpertEditPageQueryVariables>(ExpertEditPageDocument, options);
        }
export type ExpertEditPageQueryHookResult = ReturnType<typeof useExpertEditPageQuery>;
export type ExpertEditPageLazyQueryHookResult = ReturnType<typeof useExpertEditPageLazyQuery>;
export type ExpertEditPageQueryResult = Apollo.QueryResult<ExpertEditPageQuery, ExpertEditPageQueryVariables>;
export const CreateExpertDocument = gql`
    mutation createExpert($input: CreateExpertInput!) {
  createExpert(input: $input) {
    id
  }
}
    `;
export type CreateExpertMutationFn = Apollo.MutationFunction<CreateExpertMutation, CreateExpertMutationVariables>;

/**
 * __useCreateExpertMutation__
 *
 * To run a mutation, you first call `useCreateExpertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpertMutation, { data, loading, error }] = useCreateExpertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpertMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpertMutation, CreateExpertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpertMutation, CreateExpertMutationVariables>(CreateExpertDocument, options);
      }
export type CreateExpertMutationHookResult = ReturnType<typeof useCreateExpertMutation>;
export type CreateExpertMutationResult = Apollo.MutationResult<CreateExpertMutation>;
export type CreateExpertMutationOptions = Apollo.BaseMutationOptions<CreateExpertMutation, CreateExpertMutationVariables>;
export const ExpertPageDocument = gql`
    query ExpertPage($id: ID!) {
  expert(id: $id) {
    ...ExpertDetail
  }
}
    ${ExpertDetailFragmentDoc}`;

/**
 * __useExpertPageQuery__
 *
 * To run a query within a React component, call `useExpertPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertPageQuery(baseOptions: Apollo.QueryHookOptions<ExpertPageQuery, ExpertPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertPageQuery, ExpertPageQueryVariables>(ExpertPageDocument, options);
      }
export function useExpertPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertPageQuery, ExpertPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertPageQuery, ExpertPageQueryVariables>(ExpertPageDocument, options);
        }
export type ExpertPageQueryHookResult = ReturnType<typeof useExpertPageQuery>;
export type ExpertPageLazyQueryHookResult = ReturnType<typeof useExpertPageLazyQuery>;
export type ExpertPageQueryResult = Apollo.QueryResult<ExpertPageQuery, ExpertPageQueryVariables>;
export const ExpertsPageDocument = gql`
    query ExpertsPage($filter: ExpertsFilterInput, $limit: Int, $offset: Int) {
  experts(filter: $filter, limit: $limit, offset: $offset) {
    totalCount
    nodes {
      ...ExpertCard
    }
  }
}
    ${ExpertCardFragmentDoc}`;

/**
 * __useExpertsPageQuery__
 *
 * To run a query within a React component, call `useExpertsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useExpertsPageQuery(baseOptions?: Apollo.QueryHookOptions<ExpertsPageQuery, ExpertsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertsPageQuery, ExpertsPageQueryVariables>(ExpertsPageDocument, options);
      }
export function useExpertsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertsPageQuery, ExpertsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertsPageQuery, ExpertsPageQueryVariables>(ExpertsPageDocument, options);
        }
export type ExpertsPageQueryHookResult = ReturnType<typeof useExpertsPageQuery>;
export type ExpertsPageLazyQueryHookResult = ReturnType<typeof useExpertsPageLazyQuery>;
export type ExpertsPageQueryResult = Apollo.QueryResult<ExpertsPageQuery, ExpertsPageQueryVariables>;
export const GenerateUploadFeaturedVideoImageUrlDocument = gql`
    mutation generateUploadFeaturedVideoImageUrl($featuredVideoId: ID!, $featuredVideoImageId: ID, $fileName: String!, $order: Int!) {
  generateUploadFeaturedVideoImageUrl(
    featuredVideoId: $featuredVideoId
    featuredVideoImageId: $featuredVideoImageId
    fileName: $fileName
    order: $order
  ) {
    url
    fields
  }
}
    `;
export type GenerateUploadFeaturedVideoImageUrlMutationFn = Apollo.MutationFunction<GenerateUploadFeaturedVideoImageUrlMutation, GenerateUploadFeaturedVideoImageUrlMutationVariables>;

/**
 * __useGenerateUploadFeaturedVideoImageUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadFeaturedVideoImageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadFeaturedVideoImageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadFeaturedVideoImageUrlMutation, { data, loading, error }] = useGenerateUploadFeaturedVideoImageUrlMutation({
 *   variables: {
 *      featuredVideoId: // value for 'featuredVideoId'
 *      featuredVideoImageId: // value for 'featuredVideoImageId'
 *      fileName: // value for 'fileName'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGenerateUploadFeaturedVideoImageUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadFeaturedVideoImageUrlMutation, GenerateUploadFeaturedVideoImageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadFeaturedVideoImageUrlMutation, GenerateUploadFeaturedVideoImageUrlMutationVariables>(GenerateUploadFeaturedVideoImageUrlDocument, options);
      }
export type GenerateUploadFeaturedVideoImageUrlMutationHookResult = ReturnType<typeof useGenerateUploadFeaturedVideoImageUrlMutation>;
export type GenerateUploadFeaturedVideoImageUrlMutationResult = Apollo.MutationResult<GenerateUploadFeaturedVideoImageUrlMutation>;
export type GenerateUploadFeaturedVideoImageUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadFeaturedVideoImageUrlMutation, GenerateUploadFeaturedVideoImageUrlMutationVariables>;
export const UpdateFeaturedVideosDocument = gql`
    mutation updateFeaturedVideos($input: [UpdateFeaturedVideoInput!]!) {
  updateFeaturedVideos(input: $input) {
    id
    name
    order
    path
    fileName
    thumbnailUrl
  }
}
    `;
export type UpdateFeaturedVideosMutationFn = Apollo.MutationFunction<UpdateFeaturedVideosMutation, UpdateFeaturedVideosMutationVariables>;

/**
 * __useUpdateFeaturedVideosMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedVideosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedVideosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedVideosMutation, { data, loading, error }] = useUpdateFeaturedVideosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeaturedVideosMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedVideosMutation, UpdateFeaturedVideosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeaturedVideosMutation, UpdateFeaturedVideosMutationVariables>(UpdateFeaturedVideosDocument, options);
      }
export type UpdateFeaturedVideosMutationHookResult = ReturnType<typeof useUpdateFeaturedVideosMutation>;
export type UpdateFeaturedVideosMutationResult = Apollo.MutationResult<UpdateFeaturedVideosMutation>;
export type UpdateFeaturedVideosMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedVideosMutation, UpdateFeaturedVideosMutationVariables>;
export const FeaturedVideosEditPageDocument = gql`
    query FeaturedVideosEditPage {
  featuredVideos {
    ...FeaturedVideoEdit
  }
}
    ${FeaturedVideoEditFragmentDoc}`;

/**
 * __useFeaturedVideosEditPageQuery__
 *
 * To run a query within a React component, call `useFeaturedVideosEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedVideosEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedVideosEditPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturedVideosEditPageQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedVideosEditPageQuery, FeaturedVideosEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedVideosEditPageQuery, FeaturedVideosEditPageQueryVariables>(FeaturedVideosEditPageDocument, options);
      }
export function useFeaturedVideosEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedVideosEditPageQuery, FeaturedVideosEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedVideosEditPageQuery, FeaturedVideosEditPageQueryVariables>(FeaturedVideosEditPageDocument, options);
        }
export type FeaturedVideosEditPageQueryHookResult = ReturnType<typeof useFeaturedVideosEditPageQuery>;
export type FeaturedVideosEditPageLazyQueryHookResult = ReturnType<typeof useFeaturedVideosEditPageLazyQuery>;
export type FeaturedVideosEditPageQueryResult = Apollo.QueryResult<FeaturedVideosEditPageQuery, FeaturedVideosEditPageQueryVariables>;
export const FeaturedVideosPageDocument = gql`
    query FeaturedVideosPage {
  featuredVideos {
    id
    name
    order
    path
    thumbnailUrl
  }
}
    `;

/**
 * __useFeaturedVideosPageQuery__
 *
 * To run a query within a React component, call `useFeaturedVideosPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedVideosPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedVideosPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturedVideosPageQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedVideosPageQuery, FeaturedVideosPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedVideosPageQuery, FeaturedVideosPageQueryVariables>(FeaturedVideosPageDocument, options);
      }
export function useFeaturedVideosPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedVideosPageQuery, FeaturedVideosPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedVideosPageQuery, FeaturedVideosPageQueryVariables>(FeaturedVideosPageDocument, options);
        }
export type FeaturedVideosPageQueryHookResult = ReturnType<typeof useFeaturedVideosPageQuery>;
export type FeaturedVideosPageLazyQueryHookResult = ReturnType<typeof useFeaturedVideosPageLazyQuery>;
export type FeaturedVideosPageQueryResult = Apollo.QueryResult<FeaturedVideosPageQuery, FeaturedVideosPageQueryVariables>;
export const LessonParticipantsPageDocument = gql`
    query lessonParticipantsPage($lessonId: ID!, $offset: Int, $limit: Int) {
  participants(lessonId: $lessonId, offset: $offset, limit: $limit) {
    ...ParticipantTable
  }
  lesson(id: $lessonId) {
    ...LessonParticipantsPageItem
  }
}
    ${ParticipantTableFragmentDoc}
${LessonParticipantsPageItemFragmentDoc}`;

/**
 * __useLessonParticipantsPageQuery__
 *
 * To run a query within a React component, call `useLessonParticipantsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonParticipantsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonParticipantsPageQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLessonParticipantsPageQuery(baseOptions: Apollo.QueryHookOptions<LessonParticipantsPageQuery, LessonParticipantsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonParticipantsPageQuery, LessonParticipantsPageQueryVariables>(LessonParticipantsPageDocument, options);
      }
export function useLessonParticipantsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonParticipantsPageQuery, LessonParticipantsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonParticipantsPageQuery, LessonParticipantsPageQueryVariables>(LessonParticipantsPageDocument, options);
        }
export type LessonParticipantsPageQueryHookResult = ReturnType<typeof useLessonParticipantsPageQuery>;
export type LessonParticipantsPageLazyQueryHookResult = ReturnType<typeof useLessonParticipantsPageLazyQuery>;
export type LessonParticipantsPageQueryResult = Apollo.QueryResult<LessonParticipantsPageQuery, LessonParticipantsPageQueryVariables>;
export const LessonsPageDocument = gql`
    query LessonsPage($offset: Int, $limit: Int) {
  lessons(offset: $offset, limit: $limit) {
    ...LessonsResults
  }
  me {
    ...LessonsMeResults
  }
}
    ${LessonsResultsFragmentDoc}
${LessonsMeResultsFragmentDoc}`;

/**
 * __useLessonsPageQuery__
 *
 * To run a query within a React component, call `useLessonsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLessonsPageQuery(baseOptions?: Apollo.QueryHookOptions<LessonsPageQuery, LessonsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonsPageQuery, LessonsPageQueryVariables>(LessonsPageDocument, options);
      }
export function useLessonsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsPageQuery, LessonsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonsPageQuery, LessonsPageQueryVariables>(LessonsPageDocument, options);
        }
export type LessonsPageQueryHookResult = ReturnType<typeof useLessonsPageQuery>;
export type LessonsPageLazyQueryHookResult = ReturnType<typeof useLessonsPageLazyQuery>;
export type LessonsPageQueryResult = Apollo.QueryResult<LessonsPageQuery, LessonsPageQueryVariables>;
export const CreateFieldDocument = gql`
    mutation createField($input: CreateFieldInput!) {
  createField(input: $input) {
    ...FieldCreate
  }
}
    ${FieldCreateFragmentDoc}`;
export type CreateFieldMutationFn = Apollo.MutationFunction<CreateFieldMutation, CreateFieldMutationVariables>;

/**
 * __useCreateFieldMutation__
 *
 * To run a mutation, you first call `useCreateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldMutation, { data, loading, error }] = useCreateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateFieldMutation, CreateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFieldMutation, CreateFieldMutationVariables>(CreateFieldDocument, options);
      }
export type CreateFieldMutationHookResult = ReturnType<typeof useCreateFieldMutation>;
export type CreateFieldMutationResult = Apollo.MutationResult<CreateFieldMutation>;
export type CreateFieldMutationOptions = Apollo.BaseMutationOptions<CreateFieldMutation, CreateFieldMutationVariables>;
export const UpdateFieldDocument = gql`
    mutation updateField($input: UpdateFieldInput!) {
  updateField(input: $input) {
    ...FieldUpdate
  }
}
    ${FieldUpdateFragmentDoc}`;
export type UpdateFieldMutationFn = Apollo.MutationFunction<UpdateFieldMutation, UpdateFieldMutationVariables>;

/**
 * __useUpdateFieldMutation__
 *
 * To run a mutation, you first call `useUpdateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldMutation, { data, loading, error }] = useUpdateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldMutation, UpdateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldMutation, UpdateFieldMutationVariables>(UpdateFieldDocument, options);
      }
export type UpdateFieldMutationHookResult = ReturnType<typeof useUpdateFieldMutation>;
export type UpdateFieldMutationResult = Apollo.MutationResult<UpdateFieldMutation>;
export type UpdateFieldMutationOptions = Apollo.BaseMutationOptions<UpdateFieldMutation, UpdateFieldMutationVariables>;
export const FieldsDocument = gql`
    query fields($offset: Int, $limit: Int) {
  fields(offset: $offset, limit: $limit) {
    ...FieldsResult
  }
}
    ${FieldsResultFragmentDoc}`;

/**
 * __useFieldsQuery__
 *
 * To run a query within a React component, call `useFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFieldsQuery(baseOptions?: Apollo.QueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
      }
export function useFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
        }
export type FieldsQueryHookResult = ReturnType<typeof useFieldsQuery>;
export type FieldsLazyQueryHookResult = ReturnType<typeof useFieldsLazyQuery>;
export type FieldsQueryResult = Apollo.QueryResult<FieldsQuery, FieldsQueryVariables>;
export const CreateLevelDocument = gql`
    mutation createLevel($input: CreateLevelInput!) {
  createLevel(input: $input) {
    ...LevelCreate
  }
}
    ${LevelCreateFragmentDoc}`;
export type CreateLevelMutationFn = Apollo.MutationFunction<CreateLevelMutation, CreateLevelMutationVariables>;

/**
 * __useCreateLevelMutation__
 *
 * To run a mutation, you first call `useCreateLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLevelMutation, { data, loading, error }] = useCreateLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateLevelMutation, CreateLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLevelMutation, CreateLevelMutationVariables>(CreateLevelDocument, options);
      }
export type CreateLevelMutationHookResult = ReturnType<typeof useCreateLevelMutation>;
export type CreateLevelMutationResult = Apollo.MutationResult<CreateLevelMutation>;
export type CreateLevelMutationOptions = Apollo.BaseMutationOptions<CreateLevelMutation, CreateLevelMutationVariables>;
export const UpdateLevelDocument = gql`
    mutation updateLevel($input: UpdateLevelInput!) {
  updateLevel(input: $input) {
    ...LevelUpdate
  }
}
    ${LevelUpdateFragmentDoc}`;
export type UpdateLevelMutationFn = Apollo.MutationFunction<UpdateLevelMutation, UpdateLevelMutationVariables>;

/**
 * __useUpdateLevelMutation__
 *
 * To run a mutation, you first call `useUpdateLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLevelMutation, { data, loading, error }] = useUpdateLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLevelMutation, UpdateLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLevelMutation, UpdateLevelMutationVariables>(UpdateLevelDocument, options);
      }
export type UpdateLevelMutationHookResult = ReturnType<typeof useUpdateLevelMutation>;
export type UpdateLevelMutationResult = Apollo.MutationResult<UpdateLevelMutation>;
export type UpdateLevelMutationOptions = Apollo.BaseMutationOptions<UpdateLevelMutation, UpdateLevelMutationVariables>;
export const CreateOrganizerDocument = gql`
    mutation createOrganizer($input: CreateOrganizerInput!) {
  createOrganizer(input: $input) {
    id
  }
}
    `;
export type CreateOrganizerMutationFn = Apollo.MutationFunction<CreateOrganizerMutation, CreateOrganizerMutationVariables>;

/**
 * __useCreateOrganizerMutation__
 *
 * To run a mutation, you first call `useCreateOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizerMutation, { data, loading, error }] = useCreateOrganizerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizerMutation, CreateOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizerMutation, CreateOrganizerMutationVariables>(CreateOrganizerDocument, options);
      }
export type CreateOrganizerMutationHookResult = ReturnType<typeof useCreateOrganizerMutation>;
export type CreateOrganizerMutationResult = Apollo.MutationResult<CreateOrganizerMutation>;
export type CreateOrganizerMutationOptions = Apollo.BaseMutationOptions<CreateOrganizerMutation, CreateOrganizerMutationVariables>;
export const UpdateOrganizerDocument = gql`
    mutation updateOrganizer($input: UpdateOrganizerInput!) {
  updateOrganizer(input: $input) {
    id
  }
}
    `;
export type UpdateOrganizerMutationFn = Apollo.MutationFunction<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>;

/**
 * __useUpdateOrganizerMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizerMutation, { data, loading, error }] = useUpdateOrganizerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>(UpdateOrganizerDocument, options);
      }
export type UpdateOrganizerMutationHookResult = ReturnType<typeof useUpdateOrganizerMutation>;
export type UpdateOrganizerMutationResult = Apollo.MutationResult<UpdateOrganizerMutation>;
export type UpdateOrganizerMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizerMutation, UpdateOrganizerMutationVariables>;
export const MasterPageOrganizersDocument = gql`
    query MasterPageOrganizers($filter: OrganizerFilterInput, $offset: Int, $limit: Int) {
  organizers(filter: $filter, offset: $offset, limit: $limit) {
    totalCount
    nodes {
      ...MasterPageOrganizer
    }
  }
}
    ${MasterPageOrganizerFragmentDoc}`;

/**
 * __useMasterPageOrganizersQuery__
 *
 * To run a query within a React component, call `useMasterPageOrganizersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterPageOrganizersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterPageOrganizersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMasterPageOrganizersQuery(baseOptions?: Apollo.QueryHookOptions<MasterPageOrganizersQuery, MasterPageOrganizersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterPageOrganizersQuery, MasterPageOrganizersQueryVariables>(MasterPageOrganizersDocument, options);
      }
export function useMasterPageOrganizersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterPageOrganizersQuery, MasterPageOrganizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterPageOrganizersQuery, MasterPageOrganizersQueryVariables>(MasterPageOrganizersDocument, options);
        }
export type MasterPageOrganizersQueryHookResult = ReturnType<typeof useMasterPageOrganizersQuery>;
export type MasterPageOrganizersLazyQueryHookResult = ReturnType<typeof useMasterPageOrganizersLazyQuery>;
export type MasterPageOrganizersQueryResult = Apollo.QueryResult<MasterPageOrganizersQuery, MasterPageOrganizersQueryVariables>;
export const CreateSubjectDocument = gql`
    mutation createSubject($input: CreateSubjectInput!) {
  createSubject(input: $input) {
    ...SubjectCreate
  }
}
    ${SubjectCreateFragmentDoc}`;
export type CreateSubjectMutationFn = Apollo.MutationFunction<CreateSubjectMutation, CreateSubjectMutationVariables>;

/**
 * __useCreateSubjectMutation__
 *
 * To run a mutation, you first call `useCreateSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubjectMutation, { data, loading, error }] = useCreateSubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubjectMutation, CreateSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubjectMutation, CreateSubjectMutationVariables>(CreateSubjectDocument, options);
      }
export type CreateSubjectMutationHookResult = ReturnType<typeof useCreateSubjectMutation>;
export type CreateSubjectMutationResult = Apollo.MutationResult<CreateSubjectMutation>;
export type CreateSubjectMutationOptions = Apollo.BaseMutationOptions<CreateSubjectMutation, CreateSubjectMutationVariables>;
export const UpdateSubjectDocument = gql`
    mutation updateSubject($input: UpdateSubjectInput!) {
  updateSubject(input: $input) {
    ...SubjectUpdate
  }
}
    ${SubjectUpdateFragmentDoc}`;
export type UpdateSubjectMutationFn = Apollo.MutationFunction<UpdateSubjectMutation, UpdateSubjectMutationVariables>;

/**
 * __useUpdateSubjectMutation__
 *
 * To run a mutation, you first call `useUpdateSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubjectMutation, { data, loading, error }] = useUpdateSubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubjectMutation, UpdateSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubjectMutation, UpdateSubjectMutationVariables>(UpdateSubjectDocument, options);
      }
export type UpdateSubjectMutationHookResult = ReturnType<typeof useUpdateSubjectMutation>;
export type UpdateSubjectMutationResult = Apollo.MutationResult<UpdateSubjectMutation>;
export type UpdateSubjectMutationOptions = Apollo.BaseMutationOptions<UpdateSubjectMutation, UpdateSubjectMutationVariables>;
export const SubjectsDocument = gql`
    query subjects($filter: SubjectFilterInput, $offset: Int, $limit: Int) {
  subjects(filter: $filter, offset: $offset, limit: $limit) {
    ...SubjectsResult
  }
}
    ${SubjectsResultFragmentDoc}`;

/**
 * __useSubjectsQuery__
 *
 * To run a query within a React component, call `useSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<SubjectsQuery, SubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectsQuery, SubjectsQueryVariables>(SubjectsDocument, options);
      }
export function useSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectsQuery, SubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectsQuery, SubjectsQueryVariables>(SubjectsDocument, options);
        }
export type SubjectsQueryHookResult = ReturnType<typeof useSubjectsQuery>;
export type SubjectsLazyQueryHookResult = ReturnType<typeof useSubjectsLazyQuery>;
export type SubjectsQueryResult = Apollo.QueryResult<SubjectsQuery, SubjectsQueryVariables>;
export const CreateVideoTagDocument = gql`
    mutation createVideoTag($input: CreateVideoTagInput!) {
  createVideoTag(input: $input) {
    id
  }
}
    `;
export type CreateVideoTagMutationFn = Apollo.MutationFunction<CreateVideoTagMutation, CreateVideoTagMutationVariables>;

/**
 * __useCreateVideoTagMutation__
 *
 * To run a mutation, you first call `useCreateVideoTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoTagMutation, { data, loading, error }] = useCreateVideoTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoTagMutation, CreateVideoTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoTagMutation, CreateVideoTagMutationVariables>(CreateVideoTagDocument, options);
      }
export type CreateVideoTagMutationHookResult = ReturnType<typeof useCreateVideoTagMutation>;
export type CreateVideoTagMutationResult = Apollo.MutationResult<CreateVideoTagMutation>;
export type CreateVideoTagMutationOptions = Apollo.BaseMutationOptions<CreateVideoTagMutation, CreateVideoTagMutationVariables>;
export const UpdateVideoTagDocument = gql`
    mutation updateVideoTag($input: UpdateVideoTagInput!) {
  updateVideoTag(input: $input) {
    id
  }
}
    `;
export type UpdateVideoTagMutationFn = Apollo.MutationFunction<UpdateVideoTagMutation, UpdateVideoTagMutationVariables>;

/**
 * __useUpdateVideoTagMutation__
 *
 * To run a mutation, you first call `useUpdateVideoTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoTagMutation, { data, loading, error }] = useUpdateVideoTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoTagMutation, UpdateVideoTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoTagMutation, UpdateVideoTagMutationVariables>(UpdateVideoTagDocument, options);
      }
export type UpdateVideoTagMutationHookResult = ReturnType<typeof useUpdateVideoTagMutation>;
export type UpdateVideoTagMutationResult = Apollo.MutationResult<UpdateVideoTagMutation>;
export type UpdateVideoTagMutationOptions = Apollo.BaseMutationOptions<UpdateVideoTagMutation, UpdateVideoTagMutationVariables>;
export const MasterPageVideoTagsDocument = gql`
    query MasterPageVideoTags($filter: VideoTagFilterInput, $offset: Int, $limit: Int) {
  videoTags(filter: $filter, offset: $offset, limit: $limit) {
    totalCount
    nodes {
      ...MasterPageVideoTag
    }
  }
}
    ${MasterPageVideoTagFragmentDoc}`;

/**
 * __useMasterPageVideoTagsQuery__
 *
 * To run a query within a React component, call `useMasterPageVideoTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterPageVideoTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterPageVideoTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMasterPageVideoTagsQuery(baseOptions?: Apollo.QueryHookOptions<MasterPageVideoTagsQuery, MasterPageVideoTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterPageVideoTagsQuery, MasterPageVideoTagsQueryVariables>(MasterPageVideoTagsDocument, options);
      }
export function useMasterPageVideoTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterPageVideoTagsQuery, MasterPageVideoTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterPageVideoTagsQuery, MasterPageVideoTagsQueryVariables>(MasterPageVideoTagsDocument, options);
        }
export type MasterPageVideoTagsQueryHookResult = ReturnType<typeof useMasterPageVideoTagsQuery>;
export type MasterPageVideoTagsLazyQueryHookResult = ReturnType<typeof useMasterPageVideoTagsLazyQuery>;
export type MasterPageVideoTagsQueryResult = Apollo.QueryResult<MasterPageVideoTagsQuery, MasterPageVideoTagsQueryVariables>;
export const ContBillPaymentMismatchDocument = gql`
    query ContBillPaymentMismatch($id: ID!) {
  paymentMismatch(id: $id) {
    ...ContBillPaymentMismatchDetail
  }
}
    ${ContBillPaymentMismatchDetailFragmentDoc}`;

/**
 * __useContBillPaymentMismatchQuery__
 *
 * To run a query within a React component, call `useContBillPaymentMismatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useContBillPaymentMismatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContBillPaymentMismatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContBillPaymentMismatchQuery(baseOptions: Apollo.QueryHookOptions<ContBillPaymentMismatchQuery, ContBillPaymentMismatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContBillPaymentMismatchQuery, ContBillPaymentMismatchQueryVariables>(ContBillPaymentMismatchDocument, options);
      }
export function useContBillPaymentMismatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContBillPaymentMismatchQuery, ContBillPaymentMismatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContBillPaymentMismatchQuery, ContBillPaymentMismatchQueryVariables>(ContBillPaymentMismatchDocument, options);
        }
export type ContBillPaymentMismatchQueryHookResult = ReturnType<typeof useContBillPaymentMismatchQuery>;
export type ContBillPaymentMismatchLazyQueryHookResult = ReturnType<typeof useContBillPaymentMismatchLazyQuery>;
export type ContBillPaymentMismatchQueryResult = Apollo.QueryResult<ContBillPaymentMismatchQuery, ContBillPaymentMismatchQueryVariables>;
export const ContBillPaymentMismatchesDocument = gql`
    query ContBillPaymentMismatches($filter: ContBillPaymentMismatchesFilterInput, $offset: Int, $limit: Int) {
  contBillPaymentMismatches(filter: $filter, offset: $offset, limit: $limit) {
    ...ContBillPaymentMismatchResults
  }
}
    ${ContBillPaymentMismatchResultsFragmentDoc}`;

/**
 * __useContBillPaymentMismatchesQuery__
 *
 * To run a query within a React component, call `useContBillPaymentMismatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContBillPaymentMismatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContBillPaymentMismatchesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContBillPaymentMismatchesQuery(baseOptions?: Apollo.QueryHookOptions<ContBillPaymentMismatchesQuery, ContBillPaymentMismatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContBillPaymentMismatchesQuery, ContBillPaymentMismatchesQueryVariables>(ContBillPaymentMismatchesDocument, options);
      }
export function useContBillPaymentMismatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContBillPaymentMismatchesQuery, ContBillPaymentMismatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContBillPaymentMismatchesQuery, ContBillPaymentMismatchesQueryVariables>(ContBillPaymentMismatchesDocument, options);
        }
export type ContBillPaymentMismatchesQueryHookResult = ReturnType<typeof useContBillPaymentMismatchesQuery>;
export type ContBillPaymentMismatchesLazyQueryHookResult = ReturnType<typeof useContBillPaymentMismatchesLazyQuery>;
export type ContBillPaymentMismatchesQueryResult = Apollo.QueryResult<ContBillPaymentMismatchesQuery, ContBillPaymentMismatchesQueryVariables>;
export const CreateMismatchHandlingHistoryDocument = gql`
    mutation createMismatchHandlingHistory($input: MismatchHandlingHistoryInput!) {
  createMismatchHandlingHistory(input: $input) {
    ...MismatchHandlingHistory
  }
}
    ${MismatchHandlingHistoryFragmentDoc}`;
export type CreateMismatchHandlingHistoryMutationFn = Apollo.MutationFunction<CreateMismatchHandlingHistoryMutation, CreateMismatchHandlingHistoryMutationVariables>;

/**
 * __useCreateMismatchHandlingHistoryMutation__
 *
 * To run a mutation, you first call `useCreateMismatchHandlingHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMismatchHandlingHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMismatchHandlingHistoryMutation, { data, loading, error }] = useCreateMismatchHandlingHistoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMismatchHandlingHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMismatchHandlingHistoryMutation, CreateMismatchHandlingHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMismatchHandlingHistoryMutation, CreateMismatchHandlingHistoryMutationVariables>(CreateMismatchHandlingHistoryDocument, options);
      }
export type CreateMismatchHandlingHistoryMutationHookResult = ReturnType<typeof useCreateMismatchHandlingHistoryMutation>;
export type CreateMismatchHandlingHistoryMutationResult = Apollo.MutationResult<CreateMismatchHandlingHistoryMutation>;
export type CreateMismatchHandlingHistoryMutationOptions = Apollo.BaseMutationOptions<CreateMismatchHandlingHistoryMutation, CreateMismatchHandlingHistoryMutationVariables>;
export const UpdatePaymentMismatchDocument = gql`
    mutation updatePaymentMismatch($input: UpdatePaymentMismatchInput!) {
  updatePaymentMismatch(input: $input) {
    ...PaymentMismatchDetail
  }
}
    ${PaymentMismatchDetailFragmentDoc}`;
export type UpdatePaymentMismatchMutationFn = Apollo.MutationFunction<UpdatePaymentMismatchMutation, UpdatePaymentMismatchMutationVariables>;

/**
 * __useUpdatePaymentMismatchMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMismatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMismatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMismatchMutation, { data, loading, error }] = useUpdatePaymentMismatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMismatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMismatchMutation, UpdatePaymentMismatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMismatchMutation, UpdatePaymentMismatchMutationVariables>(UpdatePaymentMismatchDocument, options);
      }
export type UpdatePaymentMismatchMutationHookResult = ReturnType<typeof useUpdatePaymentMismatchMutation>;
export type UpdatePaymentMismatchMutationResult = Apollo.MutationResult<UpdatePaymentMismatchMutation>;
export type UpdatePaymentMismatchMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMismatchMutation, UpdatePaymentMismatchMutationVariables>;
export const PaymentMismatchDocument = gql`
    query PaymentMismatch($id: ID!) {
  paymentMismatch(id: $id) {
    ...PaymentMismatchDetail
  }
}
    ${PaymentMismatchDetailFragmentDoc}`;

/**
 * __usePaymentMismatchQuery__
 *
 * To run a query within a React component, call `usePaymentMismatchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMismatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMismatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMismatchQuery(baseOptions: Apollo.QueryHookOptions<PaymentMismatchQuery, PaymentMismatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMismatchQuery, PaymentMismatchQueryVariables>(PaymentMismatchDocument, options);
      }
export function usePaymentMismatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMismatchQuery, PaymentMismatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMismatchQuery, PaymentMismatchQueryVariables>(PaymentMismatchDocument, options);
        }
export type PaymentMismatchQueryHookResult = ReturnType<typeof usePaymentMismatchQuery>;
export type PaymentMismatchLazyQueryHookResult = ReturnType<typeof usePaymentMismatchLazyQuery>;
export type PaymentMismatchQueryResult = Apollo.QueryResult<PaymentMismatchQuery, PaymentMismatchQueryVariables>;
export const MismatchHandlingHistoriesDocument = gql`
    query MismatchHandlingHistories($id: String!) {
  mismatchHandlingHistories(paymentMismatchId: $id) {
    ...MismatchHandlingHistory
  }
}
    ${MismatchHandlingHistoryFragmentDoc}`;

/**
 * __useMismatchHandlingHistoriesQuery__
 *
 * To run a query within a React component, call `useMismatchHandlingHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMismatchHandlingHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMismatchHandlingHistoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMismatchHandlingHistoriesQuery(baseOptions: Apollo.QueryHookOptions<MismatchHandlingHistoriesQuery, MismatchHandlingHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MismatchHandlingHistoriesQuery, MismatchHandlingHistoriesQueryVariables>(MismatchHandlingHistoriesDocument, options);
      }
export function useMismatchHandlingHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MismatchHandlingHistoriesQuery, MismatchHandlingHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MismatchHandlingHistoriesQuery, MismatchHandlingHistoriesQueryVariables>(MismatchHandlingHistoriesDocument, options);
        }
export type MismatchHandlingHistoriesQueryHookResult = ReturnType<typeof useMismatchHandlingHistoriesQuery>;
export type MismatchHandlingHistoriesLazyQueryHookResult = ReturnType<typeof useMismatchHandlingHistoriesLazyQuery>;
export type MismatchHandlingHistoriesQueryResult = Apollo.QueryResult<MismatchHandlingHistoriesQuery, MismatchHandlingHistoriesQueryVariables>;
export const PaymentMismatchCsvDocument = gql`
    query paymentMismatchCsv($id: String!) {
  paymentMismatchCsv(paymentMismatchId: $id) {
    ...PaymentMismatchCsv
  }
}
    ${PaymentMismatchCsvFragmentDoc}`;

/**
 * __usePaymentMismatchCsvQuery__
 *
 * To run a query within a React component, call `usePaymentMismatchCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMismatchCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMismatchCsvQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMismatchCsvQuery(baseOptions: Apollo.QueryHookOptions<PaymentMismatchCsvQuery, PaymentMismatchCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMismatchCsvQuery, PaymentMismatchCsvQueryVariables>(PaymentMismatchCsvDocument, options);
      }
export function usePaymentMismatchCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMismatchCsvQuery, PaymentMismatchCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMismatchCsvQuery, PaymentMismatchCsvQueryVariables>(PaymentMismatchCsvDocument, options);
        }
export type PaymentMismatchCsvQueryHookResult = ReturnType<typeof usePaymentMismatchCsvQuery>;
export type PaymentMismatchCsvLazyQueryHookResult = ReturnType<typeof usePaymentMismatchCsvLazyQuery>;
export type PaymentMismatchCsvQueryResult = Apollo.QueryResult<PaymentMismatchCsvQuery, PaymentMismatchCsvQueryVariables>;
export const PaymentMismatchesDocument = gql`
    query PaymentMismatches($filter: PaymentMismatchesFilterInput, $offset: Int, $limit: Int) {
  paymentMismatches(filter: $filter, offset: $offset, limit: $limit) {
    ...PaymentMismatchResults
  }
}
    ${PaymentMismatchResultsFragmentDoc}`;

/**
 * __usePaymentMismatchesQuery__
 *
 * To run a query within a React component, call `usePaymentMismatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMismatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMismatchesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaymentMismatchesQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMismatchesQuery, PaymentMismatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMismatchesQuery, PaymentMismatchesQueryVariables>(PaymentMismatchesDocument, options);
      }
export function usePaymentMismatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMismatchesQuery, PaymentMismatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMismatchesQuery, PaymentMismatchesQueryVariables>(PaymentMismatchesDocument, options);
        }
export type PaymentMismatchesQueryHookResult = ReturnType<typeof usePaymentMismatchesQuery>;
export type PaymentMismatchesLazyQueryHookResult = ReturnType<typeof usePaymentMismatchesLazyQuery>;
export type PaymentMismatchesQueryResult = Apollo.QueryResult<PaymentMismatchesQuery, PaymentMismatchesQueryVariables>;
export const CancelSoldCourseDocument = gql`
    mutation cancelSoldCourse($paymentId: String!) {
  cancelSoldCourse(paymentId: $paymentId) {
    executionARN
    failedReason
  }
}
    `;
export type CancelSoldCourseMutationFn = Apollo.MutationFunction<CancelSoldCourseMutation, CancelSoldCourseMutationVariables>;

/**
 * __useCancelSoldCourseMutation__
 *
 * To run a mutation, you first call `useCancelSoldCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSoldCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSoldCourseMutation, { data, loading, error }] = useCancelSoldCourseMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCancelSoldCourseMutation(baseOptions?: Apollo.MutationHookOptions<CancelSoldCourseMutation, CancelSoldCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSoldCourseMutation, CancelSoldCourseMutationVariables>(CancelSoldCourseDocument, options);
      }
export type CancelSoldCourseMutationHookResult = ReturnType<typeof useCancelSoldCourseMutation>;
export type CancelSoldCourseMutationResult = Apollo.MutationResult<CancelSoldCourseMutation>;
export type CancelSoldCourseMutationOptions = Apollo.BaseMutationOptions<CancelSoldCourseMutation, CancelSoldCourseMutationVariables>;
export const CancelAuthorizedCourseDocument = gql`
    mutation cancelAuthorizedCourse($paymentId: String!) {
  cancelAuthorizedCourse(paymentId: $paymentId) {
    executionARN
    failedReason
  }
}
    `;
export type CancelAuthorizedCourseMutationFn = Apollo.MutationFunction<CancelAuthorizedCourseMutation, CancelAuthorizedCourseMutationVariables>;

/**
 * __useCancelAuthorizedCourseMutation__
 *
 * To run a mutation, you first call `useCancelAuthorizedCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAuthorizedCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAuthorizedCourseMutation, { data, loading, error }] = useCancelAuthorizedCourseMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCancelAuthorizedCourseMutation(baseOptions?: Apollo.MutationHookOptions<CancelAuthorizedCourseMutation, CancelAuthorizedCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAuthorizedCourseMutation, CancelAuthorizedCourseMutationVariables>(CancelAuthorizedCourseDocument, options);
      }
export type CancelAuthorizedCourseMutationHookResult = ReturnType<typeof useCancelAuthorizedCourseMutation>;
export type CancelAuthorizedCourseMutationResult = Apollo.MutationResult<CancelAuthorizedCourseMutation>;
export type CancelAuthorizedCourseMutationOptions = Apollo.BaseMutationOptions<CancelAuthorizedCourseMutation, CancelAuthorizedCourseMutationVariables>;
export const PaymentDetailDocument = gql`
    query PaymentDetail($input: PaymentInput!) {
  payment(input: $input) {
    ...PaymentDetail
  }
}
    ${PaymentDetailFragmentDoc}`;

/**
 * __usePaymentDetailQuery__
 *
 * To run a query within a React component, call `usePaymentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentDetailQuery(baseOptions: Apollo.QueryHookOptions<PaymentDetailQuery, PaymentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(PaymentDetailDocument, options);
      }
export function usePaymentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentDetailQuery, PaymentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(PaymentDetailDocument, options);
        }
export type PaymentDetailQueryHookResult = ReturnType<typeof usePaymentDetailQuery>;
export type PaymentDetailLazyQueryHookResult = ReturnType<typeof usePaymentDetailLazyQuery>;
export type PaymentDetailQueryResult = Apollo.QueryResult<PaymentDetailQuery, PaymentDetailQueryVariables>;
export const PaymentCourseClazzDocument = gql`
    query PaymentCourseClazz($id: ID!) {
  clazz(id: $id) {
    ...PaymentCourseClazz
  }
}
    ${PaymentCourseClazzFragmentDoc}`;

/**
 * __usePaymentCourseClazzQuery__
 *
 * To run a query within a React component, call `usePaymentCourseClazzQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCourseClazzQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCourseClazzQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentCourseClazzQuery(baseOptions: Apollo.QueryHookOptions<PaymentCourseClazzQuery, PaymentCourseClazzQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentCourseClazzQuery, PaymentCourseClazzQueryVariables>(PaymentCourseClazzDocument, options);
      }
export function usePaymentCourseClazzLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCourseClazzQuery, PaymentCourseClazzQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentCourseClazzQuery, PaymentCourseClazzQueryVariables>(PaymentCourseClazzDocument, options);
        }
export type PaymentCourseClazzQueryHookResult = ReturnType<typeof usePaymentCourseClazzQuery>;
export type PaymentCourseClazzLazyQueryHookResult = ReturnType<typeof usePaymentCourseClazzLazyQuery>;
export type PaymentCourseClazzQueryResult = Apollo.QueryResult<PaymentCourseClazzQuery, PaymentCourseClazzQueryVariables>;
export const PaymentCancelSoldCourseExecutionStatusDocument = gql`
    query PaymentCancelSoldCourseExecutionStatus($executionARN: String!) {
  cancelSoldCourseExecutionStatus(executionARN: $executionARN) {
    status
  }
}
    `;

/**
 * __usePaymentCancelSoldCourseExecutionStatusQuery__
 *
 * To run a query within a React component, call `usePaymentCancelSoldCourseExecutionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCancelSoldCourseExecutionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCancelSoldCourseExecutionStatusQuery({
 *   variables: {
 *      executionARN: // value for 'executionARN'
 *   },
 * });
 */
export function usePaymentCancelSoldCourseExecutionStatusQuery(baseOptions: Apollo.QueryHookOptions<PaymentCancelSoldCourseExecutionStatusQuery, PaymentCancelSoldCourseExecutionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentCancelSoldCourseExecutionStatusQuery, PaymentCancelSoldCourseExecutionStatusQueryVariables>(PaymentCancelSoldCourseExecutionStatusDocument, options);
      }
export function usePaymentCancelSoldCourseExecutionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCancelSoldCourseExecutionStatusQuery, PaymentCancelSoldCourseExecutionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentCancelSoldCourseExecutionStatusQuery, PaymentCancelSoldCourseExecutionStatusQueryVariables>(PaymentCancelSoldCourseExecutionStatusDocument, options);
        }
export type PaymentCancelSoldCourseExecutionStatusQueryHookResult = ReturnType<typeof usePaymentCancelSoldCourseExecutionStatusQuery>;
export type PaymentCancelSoldCourseExecutionStatusLazyQueryHookResult = ReturnType<typeof usePaymentCancelSoldCourseExecutionStatusLazyQuery>;
export type PaymentCancelSoldCourseExecutionStatusQueryResult = Apollo.QueryResult<PaymentCancelSoldCourseExecutionStatusQuery, PaymentCancelSoldCourseExecutionStatusQueryVariables>;
export const PaymentCancelAuthorizedCourseExecutionStatusDocument = gql`
    query PaymentCancelAuthorizedCourseExecutionStatus($executionARN: String!) {
  cancelAuthorizedCourseExecutionStatus(executionARN: $executionARN) {
    status
  }
}
    `;

/**
 * __usePaymentCancelAuthorizedCourseExecutionStatusQuery__
 *
 * To run a query within a React component, call `usePaymentCancelAuthorizedCourseExecutionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCancelAuthorizedCourseExecutionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCancelAuthorizedCourseExecutionStatusQuery({
 *   variables: {
 *      executionARN: // value for 'executionARN'
 *   },
 * });
 */
export function usePaymentCancelAuthorizedCourseExecutionStatusQuery(baseOptions: Apollo.QueryHookOptions<PaymentCancelAuthorizedCourseExecutionStatusQuery, PaymentCancelAuthorizedCourseExecutionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentCancelAuthorizedCourseExecutionStatusQuery, PaymentCancelAuthorizedCourseExecutionStatusQueryVariables>(PaymentCancelAuthorizedCourseExecutionStatusDocument, options);
      }
export function usePaymentCancelAuthorizedCourseExecutionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCancelAuthorizedCourseExecutionStatusQuery, PaymentCancelAuthorizedCourseExecutionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentCancelAuthorizedCourseExecutionStatusQuery, PaymentCancelAuthorizedCourseExecutionStatusQueryVariables>(PaymentCancelAuthorizedCourseExecutionStatusDocument, options);
        }
export type PaymentCancelAuthorizedCourseExecutionStatusQueryHookResult = ReturnType<typeof usePaymentCancelAuthorizedCourseExecutionStatusQuery>;
export type PaymentCancelAuthorizedCourseExecutionStatusLazyQueryHookResult = ReturnType<typeof usePaymentCancelAuthorizedCourseExecutionStatusLazyQuery>;
export type PaymentCancelAuthorizedCourseExecutionStatusQueryResult = Apollo.QueryResult<PaymentCancelAuthorizedCourseExecutionStatusQuery, PaymentCancelAuthorizedCourseExecutionStatusQueryVariables>;
export const CourseNamesDocument = gql`
    query CourseNames($filter: CoursesFilterInput, $offset: Int, $limit: Int) {
  courses(filter: $filter, offset: $offset, limit: $limit) {
    ...CourseNames
  }
}
    ${CourseNamesFragmentDoc}`;

/**
 * __useCourseNamesQuery__
 *
 * To run a query within a React component, call `useCourseNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCourseNamesQuery(baseOptions?: Apollo.QueryHookOptions<CourseNamesQuery, CourseNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseNamesQuery, CourseNamesQueryVariables>(CourseNamesDocument, options);
      }
export function useCourseNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseNamesQuery, CourseNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseNamesQuery, CourseNamesQueryVariables>(CourseNamesDocument, options);
        }
export type CourseNamesQueryHookResult = ReturnType<typeof useCourseNamesQuery>;
export type CourseNamesLazyQueryHookResult = ReturnType<typeof useCourseNamesLazyQuery>;
export type CourseNamesQueryResult = Apollo.QueryResult<CourseNamesQuery, CourseNamesQueryVariables>;
export const PlansDocument = gql`
    query Plans {
  plans {
    ...paymentSearchPlan
  }
}
    ${PaymentSearchPlanFragmentDoc}`;

/**
 * __usePlansQuery__
 *
 * To run a query within a React component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlansQuery(baseOptions?: Apollo.QueryHookOptions<PlansQuery, PlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
      }
export function usePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansQuery, PlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
        }
export type PlansQueryHookResult = ReturnType<typeof usePlansQuery>;
export type PlansLazyQueryHookResult = ReturnType<typeof usePlansLazyQuery>;
export type PlansQueryResult = Apollo.QueryResult<PlansQuery, PlansQueryVariables>;
export const PaymentsSearchResultsDocument = gql`
    query PaymentsSearchResults($filter: PaymentsFilterInput, $offset: Int, $limit: Int) {
  paymentsForDisplay(filter: $filter, offset: $offset, limit: $limit) {
    ...PaymentsSearchResults
  }
  hasAdminAuthority
}
    ${PaymentsSearchResultsFragmentDoc}`;

/**
 * __usePaymentsSearchResultsQuery__
 *
 * To run a query within a React component, call `usePaymentsSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsSearchResultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaymentsSearchResultsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentsSearchResultsQuery, PaymentsSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsSearchResultsQuery, PaymentsSearchResultsQueryVariables>(PaymentsSearchResultsDocument, options);
      }
export function usePaymentsSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsSearchResultsQuery, PaymentsSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsSearchResultsQuery, PaymentsSearchResultsQueryVariables>(PaymentsSearchResultsDocument, options);
        }
export type PaymentsSearchResultsQueryHookResult = ReturnType<typeof usePaymentsSearchResultsQuery>;
export type PaymentsSearchResultsLazyQueryHookResult = ReturnType<typeof usePaymentsSearchResultsLazyQuery>;
export type PaymentsSearchResultsQueryResult = Apollo.QueryResult<PaymentsSearchResultsQuery, PaymentsSearchResultsQueryVariables>;
export const PaymentCsvDownloadsDocument = gql`
    query PaymentCsvDownloads($filter: PaymentsFilterInput, $offset: Int, $limit: Int) {
  payments(filter: $filter, offset: $offset, limit: $limit) {
    ...PaymentCsvDownloads
  }
}
    ${PaymentCsvDownloadsFragmentDoc}`;

/**
 * __usePaymentCsvDownloadsQuery__
 *
 * To run a query within a React component, call `usePaymentCsvDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCsvDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCsvDownloadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaymentCsvDownloadsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentCsvDownloadsQuery, PaymentCsvDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentCsvDownloadsQuery, PaymentCsvDownloadsQueryVariables>(PaymentCsvDownloadsDocument, options);
      }
export function usePaymentCsvDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCsvDownloadsQuery, PaymentCsvDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentCsvDownloadsQuery, PaymentCsvDownloadsQueryVariables>(PaymentCsvDownloadsDocument, options);
        }
export type PaymentCsvDownloadsQueryHookResult = ReturnType<typeof usePaymentCsvDownloadsQuery>;
export type PaymentCsvDownloadsLazyQueryHookResult = ReturnType<typeof usePaymentCsvDownloadsLazyQuery>;
export type PaymentCsvDownloadsQueryResult = Apollo.QueryResult<PaymentCsvDownloadsQuery, PaymentCsvDownloadsQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($input: ProfileInput!) {
  updateProfile(input: $input) {
    ...ProfileEdit
  }
}
    ${ProfileEditFragmentDoc}`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const ProfileEditDocument = gql`
    query ProfileEdit {
  me {
    ...ProfileEdit
  }
}
    ${ProfileEditFragmentDoc}`;

/**
 * __useProfileEditQuery__
 *
 * To run a query within a React component, call `useProfileEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileEditQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileEditQuery(baseOptions?: Apollo.QueryHookOptions<ProfileEditQuery, ProfileEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileEditQuery, ProfileEditQueryVariables>(ProfileEditDocument, options);
      }
export function useProfileEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileEditQuery, ProfileEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileEditQuery, ProfileEditQueryVariables>(ProfileEditDocument, options);
        }
export type ProfileEditQueryHookResult = ReturnType<typeof useProfileEditQuery>;
export type ProfileEditLazyQueryHookResult = ReturnType<typeof useProfileEditLazyQuery>;
export type ProfileEditQueryResult = Apollo.QueryResult<ProfileEditQuery, ProfileEditQueryVariables>;
export const ProfileDocument = gql`
    query Profile {
  me {
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const UpdateClassPublicationSettingDocument = gql`
    mutation updateClassPublicationSetting($input: UpdateClassAndLessonsInput!) {
  updateClassAndLessons(input: $input) {
    ...ClassUpdateResult
  }
}
    ${ClassUpdateResultFragmentDoc}`;
export type UpdateClassPublicationSettingMutationFn = Apollo.MutationFunction<UpdateClassPublicationSettingMutation, UpdateClassPublicationSettingMutationVariables>;

/**
 * __useUpdateClassPublicationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateClassPublicationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassPublicationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassPublicationSettingMutation, { data, loading, error }] = useUpdateClassPublicationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassPublicationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassPublicationSettingMutation, UpdateClassPublicationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassPublicationSettingMutation, UpdateClassPublicationSettingMutationVariables>(UpdateClassPublicationSettingDocument, options);
      }
export type UpdateClassPublicationSettingMutationHookResult = ReturnType<typeof useUpdateClassPublicationSettingMutation>;
export type UpdateClassPublicationSettingMutationResult = Apollo.MutationResult<UpdateClassPublicationSettingMutation>;
export type UpdateClassPublicationSettingMutationOptions = Apollo.BaseMutationOptions<UpdateClassPublicationSettingMutation, UpdateClassPublicationSettingMutationVariables>;
export const CreateCoursePreviewTokenDocument = gql`
    mutation createCoursePreviewToken($courseId: ID!) {
  createCoursePreviewToken(courseId: $courseId) {
    ...PublishPreviewToken
  }
}
    ${PublishPreviewTokenFragmentDoc}`;
export type CreateCoursePreviewTokenMutationFn = Apollo.MutationFunction<CreateCoursePreviewTokenMutation, CreateCoursePreviewTokenMutationVariables>;

/**
 * __useCreateCoursePreviewTokenMutation__
 *
 * To run a mutation, you first call `useCreateCoursePreviewTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoursePreviewTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoursePreviewTokenMutation, { data, loading, error }] = useCreateCoursePreviewTokenMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCreateCoursePreviewTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoursePreviewTokenMutation, CreateCoursePreviewTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoursePreviewTokenMutation, CreateCoursePreviewTokenMutationVariables>(CreateCoursePreviewTokenDocument, options);
      }
export type CreateCoursePreviewTokenMutationHookResult = ReturnType<typeof useCreateCoursePreviewTokenMutation>;
export type CreateCoursePreviewTokenMutationResult = Apollo.MutationResult<CreateCoursePreviewTokenMutation>;
export type CreateCoursePreviewTokenMutationOptions = Apollo.BaseMutationOptions<CreateCoursePreviewTokenMutation, CreateCoursePreviewTokenMutationVariables>;
export const DeleteCoursePreviewTokenDocument = gql`
    mutation deleteCoursePreviewToken($id: ID!) {
  deleteCoursePreviewToken(id: $id)
}
    `;
export type DeleteCoursePreviewTokenMutationFn = Apollo.MutationFunction<DeleteCoursePreviewTokenMutation, DeleteCoursePreviewTokenMutationVariables>;

/**
 * __useDeleteCoursePreviewTokenMutation__
 *
 * To run a mutation, you first call `useDeleteCoursePreviewTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoursePreviewTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoursePreviewTokenMutation, { data, loading, error }] = useDeleteCoursePreviewTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCoursePreviewTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCoursePreviewTokenMutation, DeleteCoursePreviewTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCoursePreviewTokenMutation, DeleteCoursePreviewTokenMutationVariables>(DeleteCoursePreviewTokenDocument, options);
      }
export type DeleteCoursePreviewTokenMutationHookResult = ReturnType<typeof useDeleteCoursePreviewTokenMutation>;
export type DeleteCoursePreviewTokenMutationResult = Apollo.MutationResult<DeleteCoursePreviewTokenMutation>;
export type DeleteCoursePreviewTokenMutationOptions = Apollo.BaseMutationOptions<DeleteCoursePreviewTokenMutation, DeleteCoursePreviewTokenMutationVariables>;
export const PublishCoursesDocument = gql`
    query PublishCourses($filter: CoursesFilterInput, $offset: Int, $limit: Int) {
  courses(filter: $filter, offset: $offset, limit: $limit) {
    ...PublishCourses
  }
}
    ${PublishCoursesFragmentDoc}`;

/**
 * __usePublishCoursesQuery__
 *
 * To run a query within a React component, call `usePublishCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishCoursesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePublishCoursesQuery(baseOptions?: Apollo.QueryHookOptions<PublishCoursesQuery, PublishCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishCoursesQuery, PublishCoursesQueryVariables>(PublishCoursesDocument, options);
      }
export function usePublishCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishCoursesQuery, PublishCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishCoursesQuery, PublishCoursesQueryVariables>(PublishCoursesDocument, options);
        }
export type PublishCoursesQueryHookResult = ReturnType<typeof usePublishCoursesQuery>;
export type PublishCoursesLazyQueryHookResult = ReturnType<typeof usePublishCoursesLazyQuery>;
export type PublishCoursesQueryResult = Apollo.QueryResult<PublishCoursesQuery, PublishCoursesQueryVariables>;
export const AnsweredCoursesDocument = gql`
    query AnsweredCourses($offset: Int, $limit: Int) {
  answeredCourses(offset: $offset, limit: $limit) {
    ...AnsweredCourses
  }
  hasAdminAuthority
}
    ${AnsweredCoursesFragmentDoc}`;

/**
 * __useAnsweredCoursesQuery__
 *
 * To run a query within a React component, call `useAnsweredCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnsweredCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnsweredCoursesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAnsweredCoursesQuery(baseOptions?: Apollo.QueryHookOptions<AnsweredCoursesQuery, AnsweredCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnsweredCoursesQuery, AnsweredCoursesQueryVariables>(AnsweredCoursesDocument, options);
      }
export function useAnsweredCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnsweredCoursesQuery, AnsweredCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnsweredCoursesQuery, AnsweredCoursesQueryVariables>(AnsweredCoursesDocument, options);
        }
export type AnsweredCoursesQueryHookResult = ReturnType<typeof useAnsweredCoursesQuery>;
export type AnsweredCoursesLazyQueryHookResult = ReturnType<typeof useAnsweredCoursesLazyQuery>;
export type AnsweredCoursesQueryResult = Apollo.QueryResult<AnsweredCoursesQuery, AnsweredCoursesQueryVariables>;
export const QuestionnaireAnswersDocument = gql`
    query QuestionnaireAnswers($courseId: ID, $offset: Int, $limit: Int) {
  questionnaireAnswers(courseId: $courseId, offset: $offset, limit: $limit) {
    ...QuestionnaireAnswers
  }
}
    ${QuestionnaireAnswersFragmentDoc}`;

/**
 * __useQuestionnaireAnswersQuery__
 *
 * To run a query within a React component, call `useQuestionnaireAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionnaireAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionnaireAnswersQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useQuestionnaireAnswersQuery(baseOptions?: Apollo.QueryHookOptions<QuestionnaireAnswersQuery, QuestionnaireAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionnaireAnswersQuery, QuestionnaireAnswersQueryVariables>(QuestionnaireAnswersDocument, options);
      }
export function useQuestionnaireAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionnaireAnswersQuery, QuestionnaireAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionnaireAnswersQuery, QuestionnaireAnswersQueryVariables>(QuestionnaireAnswersDocument, options);
        }
export type QuestionnaireAnswersQueryHookResult = ReturnType<typeof useQuestionnaireAnswersQuery>;
export type QuestionnaireAnswersLazyQueryHookResult = ReturnType<typeof useQuestionnaireAnswersLazyQuery>;
export type QuestionnaireAnswersQueryResult = Apollo.QueryResult<QuestionnaireAnswersQuery, QuestionnaireAnswersQueryVariables>;
export const LiberalArtsVideoLessonRatingPageDocument = gql`
    query liberalArtsVideoLessonRatingPage {
  videoLessonRatingSummaries {
    ...VideoLessonRatingSummaries
  }
}
    ${VideoLessonRatingSummariesFragmentDoc}`;

/**
 * __useLiberalArtsVideoLessonRatingPageQuery__
 *
 * To run a query within a React component, call `useLiberalArtsVideoLessonRatingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiberalArtsVideoLessonRatingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiberalArtsVideoLessonRatingPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiberalArtsVideoLessonRatingPageQuery(baseOptions?: Apollo.QueryHookOptions<LiberalArtsVideoLessonRatingPageQuery, LiberalArtsVideoLessonRatingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiberalArtsVideoLessonRatingPageQuery, LiberalArtsVideoLessonRatingPageQueryVariables>(LiberalArtsVideoLessonRatingPageDocument, options);
      }
export function useLiberalArtsVideoLessonRatingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiberalArtsVideoLessonRatingPageQuery, LiberalArtsVideoLessonRatingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiberalArtsVideoLessonRatingPageQuery, LiberalArtsVideoLessonRatingPageQueryVariables>(LiberalArtsVideoLessonRatingPageDocument, options);
        }
export type LiberalArtsVideoLessonRatingPageQueryHookResult = ReturnType<typeof useLiberalArtsVideoLessonRatingPageQuery>;
export type LiberalArtsVideoLessonRatingPageLazyQueryHookResult = ReturnType<typeof useLiberalArtsVideoLessonRatingPageLazyQuery>;
export type LiberalArtsVideoLessonRatingPageQueryResult = Apollo.QueryResult<LiberalArtsVideoLessonRatingPageQuery, LiberalArtsVideoLessonRatingPageQueryVariables>;
export const LiberalArtsVideoLessonRatingCsvDocument = gql`
    query liberalArtsVideoLessonRatingCsv {
  videoLessonRatingDetails {
    ...VideoLessonRatingCsv
  }
}
    ${VideoLessonRatingCsvFragmentDoc}`;

/**
 * __useLiberalArtsVideoLessonRatingCsvQuery__
 *
 * To run a query within a React component, call `useLiberalArtsVideoLessonRatingCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiberalArtsVideoLessonRatingCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiberalArtsVideoLessonRatingCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiberalArtsVideoLessonRatingCsvQuery(baseOptions?: Apollo.QueryHookOptions<LiberalArtsVideoLessonRatingCsvQuery, LiberalArtsVideoLessonRatingCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiberalArtsVideoLessonRatingCsvQuery, LiberalArtsVideoLessonRatingCsvQueryVariables>(LiberalArtsVideoLessonRatingCsvDocument, options);
      }
export function useLiberalArtsVideoLessonRatingCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiberalArtsVideoLessonRatingCsvQuery, LiberalArtsVideoLessonRatingCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiberalArtsVideoLessonRatingCsvQuery, LiberalArtsVideoLessonRatingCsvQueryVariables>(LiberalArtsVideoLessonRatingCsvDocument, options);
        }
export type LiberalArtsVideoLessonRatingCsvQueryHookResult = ReturnType<typeof useLiberalArtsVideoLessonRatingCsvQuery>;
export type LiberalArtsVideoLessonRatingCsvLazyQueryHookResult = ReturnType<typeof useLiberalArtsVideoLessonRatingCsvLazyQuery>;
export type LiberalArtsVideoLessonRatingCsvQueryResult = Apollo.QueryResult<LiberalArtsVideoLessonRatingCsvQuery, LiberalArtsVideoLessonRatingCsvQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const GenerateUploadAvatorUrlDocument = gql`
    mutation generateUploadAvatorUrl($userId: ID!, $fileName: String!) {
  generateUploadAvatorUrl(userId: $userId, fileName: $fileName) {
    url
    fields
  }
}
    `;
export type GenerateUploadAvatorUrlMutationFn = Apollo.MutationFunction<GenerateUploadAvatorUrlMutation, GenerateUploadAvatorUrlMutationVariables>;

/**
 * __useGenerateUploadAvatorUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadAvatorUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadAvatorUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadAvatorUrlMutation, { data, loading, error }] = useGenerateUploadAvatorUrlMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGenerateUploadAvatorUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadAvatorUrlMutation, GenerateUploadAvatorUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadAvatorUrlMutation, GenerateUploadAvatorUrlMutationVariables>(GenerateUploadAvatorUrlDocument, options);
      }
export type GenerateUploadAvatorUrlMutationHookResult = ReturnType<typeof useGenerateUploadAvatorUrlMutation>;
export type GenerateUploadAvatorUrlMutationResult = Apollo.MutationResult<GenerateUploadAvatorUrlMutation>;
export type GenerateUploadAvatorUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadAvatorUrlMutation, GenerateUploadAvatorUrlMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!) {
  updateUser(input: $input) {
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UsersEditDocument = gql`
    query UsersEdit($id: ID!) {
  user(id: $id) {
    ...UsersEditPage
  }
  hasAdminAuthority
  services {
    ...ServiceInput
  }
}
    ${UsersEditPageFragmentDoc}
${ServiceInputFragmentDoc}`;

/**
 * __useUsersEditQuery__
 *
 * To run a query within a React component, call `useUsersEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersEditQuery(baseOptions: Apollo.QueryHookOptions<UsersEditQuery, UsersEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersEditQuery, UsersEditQueryVariables>(UsersEditDocument, options);
      }
export function useUsersEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersEditQuery, UsersEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersEditQuery, UsersEditQueryVariables>(UsersEditDocument, options);
        }
export type UsersEditQueryHookResult = ReturnType<typeof useUsersEditQuery>;
export type UsersEditLazyQueryHookResult = ReturnType<typeof useUsersEditLazyQuery>;
export type UsersEditQueryResult = Apollo.QueryResult<UsersEditQuery, UsersEditQueryVariables>;
export const CreateExternalUserDocument = gql`
    mutation createExternalUser($input: CreateExternalUserInput!) {
  createExternalUser(input: $input) {
    ...UserExternalNew
  }
}
    ${UserExternalNewFragmentDoc}`;
export type CreateExternalUserMutationFn = Apollo.MutationFunction<CreateExternalUserMutation, CreateExternalUserMutationVariables>;

/**
 * __useCreateExternalUserMutation__
 *
 * To run a mutation, you first call `useCreateExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalUserMutation, { data, loading, error }] = useCreateExternalUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalUserMutation, CreateExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalUserMutation, CreateExternalUserMutationVariables>(CreateExternalUserDocument, options);
      }
export type CreateExternalUserMutationHookResult = ReturnType<typeof useCreateExternalUserMutation>;
export type CreateExternalUserMutationResult = Apollo.MutationResult<CreateExternalUserMutation>;
export type CreateExternalUserMutationOptions = Apollo.BaseMutationOptions<CreateExternalUserMutation, CreateExternalUserMutationVariables>;
export const ExistUserDocument = gql`
    query ExistUser($userId: String!) {
  existUser(userId: $userId)
}
    `;

/**
 * __useExistUserQuery__
 *
 * To run a query within a React component, call `useExistUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExistUserQuery(baseOptions: Apollo.QueryHookOptions<ExistUserQuery, ExistUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExistUserQuery, ExistUserQueryVariables>(ExistUserDocument, options);
      }
export function useExistUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistUserQuery, ExistUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExistUserQuery, ExistUserQueryVariables>(ExistUserDocument, options);
        }
export type ExistUserQueryHookResult = ReturnType<typeof useExistUserQuery>;
export type ExistUserLazyQueryHookResult = ReturnType<typeof useExistUserLazyQuery>;
export type ExistUserQueryResult = Apollo.QueryResult<ExistUserQuery, ExistUserQueryVariables>;
export const UsersDocument = gql`
    query Users($filter: UserFilterInput, $offset: Int, $limit: Int) {
  users(filter: $filter, offset: $offset, limit: $limit) {
    ...UsersTable
  }
}
    ${UsersTableFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UpdateVideoLessonDocument = gql`
    mutation updateVideoLesson($input: UpdateVideoLessonInput!) {
  updateVideoLesson(input: $input) {
    id
  }
}
    `;
export type UpdateVideoLessonMutationFn = Apollo.MutationFunction<UpdateVideoLessonMutation, UpdateVideoLessonMutationVariables>;

/**
 * __useUpdateVideoLessonMutation__
 *
 * To run a mutation, you first call `useUpdateVideoLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoLessonMutation, { data, loading, error }] = useUpdateVideoLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoLessonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoLessonMutation, UpdateVideoLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoLessonMutation, UpdateVideoLessonMutationVariables>(UpdateVideoLessonDocument, options);
      }
export type UpdateVideoLessonMutationHookResult = ReturnType<typeof useUpdateVideoLessonMutation>;
export type UpdateVideoLessonMutationResult = Apollo.MutationResult<UpdateVideoLessonMutation>;
export type UpdateVideoLessonMutationOptions = Apollo.BaseMutationOptions<UpdateVideoLessonMutation, UpdateVideoLessonMutationVariables>;
export const GenerateUploadVideoLessonImageUrlDocument = gql`
    mutation generateUploadVideoLessonImageUrl($input: GenerateUploadVideoLessonImageUrlInput!) {
  generateUploadVideoLessonImageUrl(input: $input) {
    url
    fields
  }
}
    `;
export type GenerateUploadVideoLessonImageUrlMutationFn = Apollo.MutationFunction<GenerateUploadVideoLessonImageUrlMutation, GenerateUploadVideoLessonImageUrlMutationVariables>;

/**
 * __useGenerateUploadVideoLessonImageUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadVideoLessonImageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadVideoLessonImageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadVideoLessonImageUrlMutation, { data, loading, error }] = useGenerateUploadVideoLessonImageUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUploadVideoLessonImageUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadVideoLessonImageUrlMutation, GenerateUploadVideoLessonImageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadVideoLessonImageUrlMutation, GenerateUploadVideoLessonImageUrlMutationVariables>(GenerateUploadVideoLessonImageUrlDocument, options);
      }
export type GenerateUploadVideoLessonImageUrlMutationHookResult = ReturnType<typeof useGenerateUploadVideoLessonImageUrlMutation>;
export type GenerateUploadVideoLessonImageUrlMutationResult = Apollo.MutationResult<GenerateUploadVideoLessonImageUrlMutation>;
export type GenerateUploadVideoLessonImageUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadVideoLessonImageUrlMutation, GenerateUploadVideoLessonImageUrlMutationVariables>;
export const VideoLessonEditPageDocument = gql`
    query VideoLessonEditPage($id: ID!) {
  videoLesson(id: $id) {
    ...VideoLessonDetail
  }
  fields(offset: 0, limit: 1000) {
    totalCount
    nodes {
      ...FieldSelecter
    }
  }
  videoTags(filter: {active: true}, offset: 0, limit: 1000) {
    totalCount
    nodes {
      ...VideoTagSelecter
    }
  }
}
    ${VideoLessonDetailFragmentDoc}
${FieldSelecterFragmentDoc}
${VideoTagSelecterFragmentDoc}`;

/**
 * __useVideoLessonEditPageQuery__
 *
 * To run a query within a React component, call `useVideoLessonEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoLessonEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoLessonEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoLessonEditPageQuery(baseOptions: Apollo.QueryHookOptions<VideoLessonEditPageQuery, VideoLessonEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoLessonEditPageQuery, VideoLessonEditPageQueryVariables>(VideoLessonEditPageDocument, options);
      }
export function useVideoLessonEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoLessonEditPageQuery, VideoLessonEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoLessonEditPageQuery, VideoLessonEditPageQueryVariables>(VideoLessonEditPageDocument, options);
        }
export type VideoLessonEditPageQueryHookResult = ReturnType<typeof useVideoLessonEditPageQuery>;
export type VideoLessonEditPageLazyQueryHookResult = ReturnType<typeof useVideoLessonEditPageLazyQuery>;
export type VideoLessonEditPageQueryResult = Apollo.QueryResult<VideoLessonEditPageQuery, VideoLessonEditPageQueryVariables>;
export const CreateVideoLessonDocument = gql`
    mutation createVideoLesson($input: CreateVideoLessonInput!) {
  createVideoLesson(input: $input) {
    id
  }
}
    `;
export type CreateVideoLessonMutationFn = Apollo.MutationFunction<CreateVideoLessonMutation, CreateVideoLessonMutationVariables>;

/**
 * __useCreateVideoLessonMutation__
 *
 * To run a mutation, you first call `useCreateVideoLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoLessonMutation, { data, loading, error }] = useCreateVideoLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoLessonMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoLessonMutation, CreateVideoLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoLessonMutation, CreateVideoLessonMutationVariables>(CreateVideoLessonDocument, options);
      }
export type CreateVideoLessonMutationHookResult = ReturnType<typeof useCreateVideoLessonMutation>;
export type CreateVideoLessonMutationResult = Apollo.MutationResult<CreateVideoLessonMutation>;
export type CreateVideoLessonMutationOptions = Apollo.BaseMutationOptions<CreateVideoLessonMutation, CreateVideoLessonMutationVariables>;
export const VideoLessonNewPageDocument = gql`
    query VideoLessonNewPage {
  fields(offset: 0, limit: 1000) {
    totalCount
    nodes {
      ...FieldSelecter
    }
  }
  videoTags(filter: {active: true}, offset: 0, limit: 1000) {
    totalCount
    nodes {
      ...VideoTagSelecter
    }
  }
}
    ${FieldSelecterFragmentDoc}
${VideoTagSelecterFragmentDoc}`;

/**
 * __useVideoLessonNewPageQuery__
 *
 * To run a query within a React component, call `useVideoLessonNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoLessonNewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoLessonNewPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useVideoLessonNewPageQuery(baseOptions?: Apollo.QueryHookOptions<VideoLessonNewPageQuery, VideoLessonNewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoLessonNewPageQuery, VideoLessonNewPageQueryVariables>(VideoLessonNewPageDocument, options);
      }
export function useVideoLessonNewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoLessonNewPageQuery, VideoLessonNewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoLessonNewPageQuery, VideoLessonNewPageQueryVariables>(VideoLessonNewPageDocument, options);
        }
export type VideoLessonNewPageQueryHookResult = ReturnType<typeof useVideoLessonNewPageQuery>;
export type VideoLessonNewPageLazyQueryHookResult = ReturnType<typeof useVideoLessonNewPageLazyQuery>;
export type VideoLessonNewPageQueryResult = Apollo.QueryResult<VideoLessonNewPageQuery, VideoLessonNewPageQueryVariables>;
export const VideoLessonPageDocument = gql`
    query VideoLessonPage($id: ID!) {
  videoLesson(id: $id) {
    ...VideoLessonDetail
  }
}
    ${VideoLessonDetailFragmentDoc}`;

/**
 * __useVideoLessonPageQuery__
 *
 * To run a query within a React component, call `useVideoLessonPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoLessonPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoLessonPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoLessonPageQuery(baseOptions: Apollo.QueryHookOptions<VideoLessonPageQuery, VideoLessonPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoLessonPageQuery, VideoLessonPageQueryVariables>(VideoLessonPageDocument, options);
      }
export function useVideoLessonPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoLessonPageQuery, VideoLessonPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoLessonPageQuery, VideoLessonPageQueryVariables>(VideoLessonPageDocument, options);
        }
export type VideoLessonPageQueryHookResult = ReturnType<typeof useVideoLessonPageQuery>;
export type VideoLessonPageLazyQueryHookResult = ReturnType<typeof useVideoLessonPageLazyQuery>;
export type VideoLessonPageQueryResult = Apollo.QueryResult<VideoLessonPageQuery, VideoLessonPageQueryVariables>;